import { C as e, I as t, N as n, S as r, T as i, a, b as o, d as s, f as c, g as l, h as u, j as d, l as f, m as p, o as m, v as h, w as g, x as _ } from "./config-CrKIGf7w.js";
import { a as v, c as y, d as b, f as x, i as S, l as C, m as ee, n as w, o as te, p as ne, r as re, s as ie, t as T, u as E } from "./businessHours-AQmzZWFt.js";
import { a as D, c as ae, i as O, l as oe, n as se, o as ce, r as le, s as ue, t as de, u as fe } from "./theme-C5OUkEkk.js";
import { ActionIcon as k, Alert as pe, Anchor as me, Avatar as he, Badge as A, Box as j, Breadcrumbs as ge, Button as M, Card as N, Center as _e, Checkbox as ve, CloseButton as ye, Code as be, Collapse as xe, Combobox as Se, Container as Ce, Divider as we, Drawer as Te, Flex as Ee, Group as P, HoverCard as De, Image as Oe, Indicator as ke, Loader as Ae, Menu as je, Modal as Me, NumberInput as Ne, Pagination as Pe, Paper as Fe, Popover as Ie, ScrollArea as Le, Select as Re, SimpleGrid as ze, Skeleton as F, Stack as I, Table as L, Text as R, TextInput as Be, ThemeIcon as Ve, Timeline as He, Title as Ue, Tooltip as We, UnstyledButton as Ge, useCombobox as Ke, useComputedColorScheme as qe, useMantineColorScheme as Je } from "@mantine/core";
import { IconAlertCircle as Ye, IconAlertTriangle as Xe, IconArchive as Ze, IconArrowRight as Qe, IconBriefcase as $e, IconBuildingStore as et, IconCalendar as tt, IconCheck as z, IconChecks as nt, IconChefHat as rt, IconChevronDown as it, IconChevronLeft as at, IconChevronRight as ot, IconChevronUp as st, IconCircle as ct, IconCircleCheck as lt, IconCircleDot as ut, IconClock as B, IconClockOff as dt, IconCloudCheck as ft, IconCloudOff as pt, IconCloudUpload as mt, IconCoin as ht, IconCoinOff as gt, IconCoins as _t, IconCreditCard as vt, IconCurrencyBitcoin as yt, IconCurrencyDollar as bt, IconDownload as xt, IconFile as St, IconFileSpreadsheet as Ct, IconFileText as wt, IconFileTypePdf as Tt, IconFileTypeZip as Et, IconFingerprint as Dt, IconHeart as Ot, IconHeartFilled as kt, IconInbox as At, IconInfoCircle as jt, IconKey as Mt, IconLanguage as Nt, IconLoader2 as Pt, IconLock as Ft, IconLogout as It, IconMapPin as Lt, IconMessage2 as Rt, IconMinus as zt, IconMoodSmile as Bt, IconMoon as Vt, IconPackage as Ht, IconPaperclip as Ut, IconPhotoOff as Wt, IconPlus as Gt, IconReceiptRefund as Kt, IconRefresh as qt, IconRepeat as Jt, IconSearch as Yt, IconSelector as Xt, IconSend2 as Zt, IconSettings as Qt, IconShield as $t, IconShoppingBag as en, IconShoppingCart as tn, IconSun as nn, IconToolsKitchen2 as rn, IconTrash as an, IconTrendingDown as on, IconTrendingUp as sn, IconTruck as cn, IconUser as ln, IconUsers as un, IconWifi as dn, IconX as V, IconZoomIn as fn, IconZoomOut as pn } from "@tabler/icons-react";
import { Fragment as mn, jsx as H, jsxs as U } from "react/jsx-runtime";
import { useTranslation as hn } from "react-i18next";
import gn, { Component as _n, Fragment as vn, Suspense as yn, createContext as bn, forwardRef as xn, lazy as Sn, useCallback as W, useContext as Cn, useEffect as G, useImperativeHandle as wn, useLayoutEffect as Tn, useMemo as K, useReducer as En, useRef as q, useState as J } from "react";
import { useDebouncedCallback as Dn, useDebouncedValue as On, useDisclosure as kn, useMediaQuery as An } from "@mantine/hooks";
import { AreaChart as jn, BarChart as Mn, DonutChart as Nn, LineChart as Pn, PieChart as Fn } from "@mantine/charts";
import { DatePicker as In } from "@mantine/dates";
import Y from "dayjs";
import "dayjs/locale/es";
import { Link as Ln } from "react-router-dom";
import { UserAvatar as Rn } from "@teletienda/shared-auth-ui";
import zn from "react-markdown";
import Bn from "remark-gfm";
import { notifications as Vn } from "@mantine/notifications";
import { Extension as Hn } from "@tiptap/core";
import { useEditor as Un } from "@tiptap/react";
import Wn from "@tiptap/starter-kit";
import Gn from "@tiptap/extension-link";
import Kn from "@tiptap/extension-placeholder";
import { Markdown as qn } from "tiptap-markdown";
import { RichTextEditor as Jn } from "@mantine/tiptap";
import { useQuery as Yn } from "@tanstack/react-query";
import { EventType as Xn, RealtimeTopics as Zn, useRealtimeEventOptional as Qn, useWebSocketOptional as $n } from "@teletienda/ws-client/react";
//#region \0rolldown/runtime.js
var er = Object.create, tr = Object.defineProperty, nr = Object.getOwnPropertyDescriptor, rr = Object.getOwnPropertyNames, ir = Object.getPrototypeOf, ar = Object.prototype.hasOwnProperty, or = (e, t) => () => (t || (e((t = { exports: {} }).exports, t), e = null), t.exports), sr = (e, t, n, r) => {
	if (t && typeof t == "object" || typeof t == "function") for (var i = rr(t), a = 0, o = i.length, s; a < o; a++) s = i[a], !ar.call(e, s) && s !== n && tr(e, s, {
		get: ((e) => t[e]).bind(null, s),
		enumerable: !(r = nr(t, s)) || r.enumerable
	});
	return e;
}, cr = (e, t, n) => (n = e == null ? {} : er(ir(e)), sr(t || !e || !e.__esModule ? tr(n, "default", {
	value: e,
	enumerable: !0
}) : n, e)), lr = {
	order: {
		completed: z,
		pending: B,
		partially_paid: bt,
		overpaid: _t,
		check: Ye,
		expired: B,
		expired_partial: B,
		cancelled: V,
		failed: V
	},
	payment: {
		pending: B,
		detected: ut,
		confirming: qt,
		confirmed: z,
		completed: z,
		failed: V,
		refunded: qt
	},
	withdrawal: {
		completed: z,
		processing: qt,
		pending: B,
		failed: V,
		cancelled: V
	},
	transaction: {
		confirmed: z,
		pending: B,
		failed: V
	},
	address: {
		ready: ut,
		assigned_to_order: B,
		payment_received: bt,
		check: Ye,
		consolidating: qt,
		archived: Ze
	},
	merchant: {
		active: z,
		inactive: V,
		pending: B
	},
	merchantOrder: {
		pending: B,
		paid: bt,
		confirmed: z,
		preparing: Ht,
		ready: Ht,
		shipped: cn,
		delivered: z,
		cancelled: V
	},
	sync: {
		synced: ft,
		pending: qt,
		error: pt
	},
	stock: {
		in_stock: z,
		low_stock: Ye,
		out_of_stock: V
	},
	paymentStatus: {
		pending: B,
		partially_paid: gt,
		paid: ht,
		overpaid: Xe,
		expired: dt,
		expired_partial: dt,
		failed: V,
		refunded: Kt
	},
	fulfillmentStatus: {
		awaiting_payment: B,
		confirmed: z,
		preparing: rt,
		ready: Ht,
		shipped: cn,
		delivered: lt,
		cancelled: V
	}
};
function X({ type: e, status: t, showIcon: n = !1, label: r, ...i }) {
	let a = h(e, t), o = n ? lr[e]?.[t] : void 0, s = l(e, t), c = r ?? s;
	return /* @__PURE__ */ H(A, {
		color: a.color,
		leftSection: o ? /* @__PURE__ */ H(o, {
			size: 12,
			stroke: 1.5
		}) : void 0,
		...i,
		children: c
	});
}
function ur(e) {
	return /* @__PURE__ */ H(X, {
		type: "order",
		...e
	});
}
function dr(e) {
	return /* @__PURE__ */ H(X, {
		type: "payment",
		...e
	});
}
function fr(e) {
	return /* @__PURE__ */ H(X, {
		type: "withdrawal",
		...e
	});
}
function pr(e) {
	return /* @__PURE__ */ H(X, {
		type: "transaction",
		...e
	});
}
function mr(e) {
	return /* @__PURE__ */ H(X, {
		type: "address",
		...e
	});
}
function hr(e) {
	return /* @__PURE__ */ H(X, {
		type: "merchant",
		...e
	});
}
function gr(e) {
	return /* @__PURE__ */ H(X, {
		type: "merchantOrder",
		...e
	});
}
function _r(e) {
	return /* @__PURE__ */ H(X, {
		type: "sync",
		...e
	});
}
function vr(e) {
	return /* @__PURE__ */ H(X, {
		type: "stock",
		...e
	});
}
function yr(e) {
	return /* @__PURE__ */ H(X, {
		type: "paymentStatus",
		...e
	});
}
function br(e) {
	return /* @__PURE__ */ H(X, {
		type: "fulfillmentStatus",
		...e
	});
}
//#endregion
//#region src/components/feedback/CategoryBadge/CategoryBadge.tsx
var xr = {
	merchant: {
		shop: en,
		restaurant: rn,
		service: $e
	},
	resource: {
		users: un,
		roles: $t,
		permissions: Ft,
		merchants: et,
		orders: tn,
		products: Ht,
		payments: vt,
		settings: Qt,
		addresses: Lt,
		api_keys: Mt,
		blockchain: yt,
		cart: tn
	},
	role: {
		system: $t,
		custom: ln
	},
	addressContext: {
		personal: ln,
		merchant: et,
		system: Qt
	},
	paymentMode: {
		reuse: Jt,
		unique: Dt
	}
};
function Sr({ type: e, value: t, showIcon: n = !1, label: r, ...i }) {
	let a = f(e, t), o = n ? xr[e]?.[t] : void 0, s = p(e, t), c = r ?? s;
	return /* @__PURE__ */ H(A, {
		color: a.color,
		leftSection: o ? /* @__PURE__ */ H(o, {
			size: 12,
			stroke: 1.5
		}) : void 0,
		...i,
		children: c
	});
}
function Cr(e) {
	return /* @__PURE__ */ H(Sr, {
		type: "merchant",
		...e
	});
}
function wr(e) {
	return /* @__PURE__ */ H(Sr, {
		type: "resource",
		...e
	});
}
function Tr(e) {
	return /* @__PURE__ */ H(Sr, {
		type: "role",
		...e
	});
}
function Er(e) {
	return /* @__PURE__ */ H(Sr, {
		type: "addressContext",
		...e
	});
}
function Dr(e) {
	return /* @__PURE__ */ H(Sr, {
		type: "paymentMode",
		...e
	});
}
//#endregion
//#region src/components/feedback/LevelBadge/LevelBadge.tsx
function Or({ value: e, thresholds: t, suffix: n = "", prefix: r = "", showLabel: i = !1, formatValue: a, ...o }) {
	let l = s(e, t), d;
	if (i) {
		let n = c(e, t);
		d = n ? u(n) : String(e);
	} else d = a ? `${r}${a(e)}${n}` : `${r}${e}${n}`;
	return /* @__PURE__ */ H(A, {
		color: l,
		...o,
		children: d
	});
}
function kr(e) {
	return /* @__PURE__ */ H(Or, {
		thresholds: g,
		...e
	});
}
function Ar(e) {
	return /* @__PURE__ */ H(Or, {
		thresholds: _,
		...e
	});
}
function jr(t) {
	return /* @__PURE__ */ H(Or, {
		thresholds: e,
		...t
	});
}
function Mr(e) {
	return /* @__PURE__ */ H(Or, {
		thresholds: o,
		...e
	});
}
function Nr(e) {
	return /* @__PURE__ */ H(Or, {
		thresholds: i,
		...e
	});
}
function Pr(e) {
	return /* @__PURE__ */ H(Or, {
		thresholds: r,
		...e
	});
}
//#endregion
//#region src/components/feedback/CounterBadge/CounterBadge.tsx
function Fr({ count: e, max: t, showZero: n = !0, formatCount: r, color: i = "blue", ...a }) {
	if (e === 0 && !n) return null;
	let o;
	return o = r ? r(e, t) : t !== void 0 && e > t ? `${t}+` : String(e), /* @__PURE__ */ H(A, {
		color: i,
		...a,
		children: o
	});
}
function Ir(e) {
	return /* @__PURE__ */ H(Fr, {
		max: 99,
		size: "xs",
		...e
	});
}
function Lr(e) {
	return /* @__PURE__ */ H(Fr, {
		max: 999,
		...e
	});
}
function Rr(e) {
	return /* @__PURE__ */ H(Fr, {
		color: "gray",
		...e
	});
}
//#endregion
//#region src/components/feedback/RoleBadge/RoleBadge.tsx
var zr = {
	super_admin: "Super Admin",
	admin: "Admin",
	merchant_admin: "Merchant Admin",
	merchant_user: "Merchant User",
	support: "Support",
	content_manager: "Content Manager",
	customer: "Customer",
	readonly: "Read Only",
	unverified: "Unverified",
	test_role: "Test Role"
};
function Br(e) {
	return zr[e] ? zr[e] : e.split("_").map((e) => e.charAt(0).toUpperCase() + e.slice(1).toLowerCase()).join(" ");
}
function Vr({ role: e, isSystem: t = !1, showIcon: n = !1, label: r, color: i, ...a }) {
	let o = d[t ? "system" : "custom"], s = i ?? o.color, c = r ?? Br(e), l = n ? t ? $t : ln : void 0;
	return /* @__PURE__ */ H(A, {
		color: s,
		leftSection: l ? /* @__PURE__ */ H(l, {
			size: 12,
			stroke: 1.5
		}) : void 0,
		...a,
		children: c
	});
}
function Hr(e) {
	return /* @__PURE__ */ H(Vr, {
		isSystem: !0,
		...e
	});
}
function Ur(e) {
	return /* @__PURE__ */ H(Vr, {
		isSystem: !1,
		...e
	});
}
//#endregion
//#region src/components/feedback/LoadingSkeleton/layouts/ProductGridSkeleton.tsx
function Wr() {
	return /* @__PURE__ */ U(N, {
		shadow: "sm",
		padding: "lg",
		radius: "md",
		withBorder: !0,
		"data-testid": "product-skeleton",
		children: [
			/* @__PURE__ */ H(N.Section, { children: /* @__PURE__ */ H(F, { height: 160 }) }),
			/* @__PURE__ */ U(P, {
				justify: "space-between",
				mt: "md",
				mb: "xs",
				children: [/* @__PURE__ */ H(F, {
					height: 16,
					width: "70%"
				}), /* @__PURE__ */ H(F, {
					height: 20,
					width: 60
				})]
			}),
			/* @__PURE__ */ H(F, {
				height: 14,
				mt: 6
			}),
			/* @__PURE__ */ H(F, {
				height: 14,
				mt: 6,
				width: "80%"
			}),
			/* @__PURE__ */ U(P, {
				justify: "space-between",
				mt: "md",
				children: [/* @__PURE__ */ H(F, {
					height: 24,
					width: 80
				}), /* @__PURE__ */ H(F, {
					height: 36,
					width: 100
				})]
			})
		]
	});
}
function Gr({ count: e = 8 }) {
	return /* @__PURE__ */ H(ze, {
		cols: {
			base: 1,
			xs: 2,
			sm: 3,
			md: 4
		},
		spacing: "md",
		"data-testid": "product-grid-skeleton",
		children: Array.from({ length: e }).map((e, t) => /* @__PURE__ */ H(Wr, {}, t))
	});
}
//#endregion
//#region src/components/feedback/LoadingSkeleton/layouts/MerchantGridSkeleton.tsx
function Kr() {
	return /* @__PURE__ */ U(N, {
		shadow: "sm",
		padding: "lg",
		radius: "md",
		withBorder: !0,
		children: [
			/* @__PURE__ */ H(N.Section, { children: /* @__PURE__ */ H(F, { height: 120 }) }),
			/* @__PURE__ */ U(P, {
				justify: "space-between",
				mt: "md",
				mb: "xs",
				children: [/* @__PURE__ */ H(F, {
					height: 18,
					width: "70%"
				}), /* @__PURE__ */ H(F, {
					height: 20,
					width: 60
				})]
			}),
			/* @__PURE__ */ H(F, {
				height: 14,
				mt: 6
			}),
			/* @__PURE__ */ H(F, {
				height: 14,
				mt: 6,
				width: "80%"
			}),
			/* @__PURE__ */ U(P, {
				justify: "space-between",
				mt: "md",
				children: [/* @__PURE__ */ H(F, {
					height: 16,
					width: 100
				}), /* @__PURE__ */ H(F, {
					height: 36,
					width: 120
				})]
			})
		]
	});
}
function qr({ count: e = 6 }) {
	return /* @__PURE__ */ H(ze, {
		cols: {
			base: 1,
			sm: 2,
			md: 3
		},
		spacing: "md",
		"data-testid": "merchant-grid-skeleton",
		children: Array.from({ length: e }).map((e, t) => /* @__PURE__ */ H(Kr, {}, t))
	});
}
//#endregion
//#region src/components/feedback/LoadingSkeleton/layouts/ProductDetailSkeleton.tsx
function Jr() {
	return /* @__PURE__ */ U(P, {
		align: "flex-start",
		gap: "xl",
		wrap: "wrap",
		"data-testid": "product-detail-skeleton",
		children: [/* @__PURE__ */ U(j, {
			style: {
				flex: 1,
				minWidth: 300
			},
			children: [/* @__PURE__ */ H(F, {
				height: 400,
				radius: "md"
			}), /* @__PURE__ */ U(P, {
				gap: "sm",
				mt: "sm",
				children: [
					/* @__PURE__ */ H(F, {
						height: 60,
						width: 60,
						radius: "sm"
					}),
					/* @__PURE__ */ H(F, {
						height: 60,
						width: 60,
						radius: "sm"
					}),
					/* @__PURE__ */ H(F, {
						height: 60,
						width: 60,
						radius: "sm"
					}),
					/* @__PURE__ */ H(F, {
						height: 60,
						width: 60,
						radius: "sm"
					})
				]
			})]
		}), /* @__PURE__ */ U(I, {
			gap: "md",
			style: {
				flex: 1,
				minWidth: 300
			},
			children: [
				/* @__PURE__ */ H(F, {
					height: 32,
					width: "80%"
				}),
				/* @__PURE__ */ H(F, {
					height: 20,
					width: "40%"
				}),
				/* @__PURE__ */ H(F, {
					height: 28,
					width: 120
				}),
				/* @__PURE__ */ H(F, {
					height: 20,
					width: "30%"
				}),
				/* @__PURE__ */ H(F, { height: 100 }),
				/* @__PURE__ */ U(P, { children: [/* @__PURE__ */ H(F, {
					height: 44,
					width: 200,
					radius: "md"
				}), /* @__PURE__ */ H(F, {
					height: 44,
					width: 44,
					radius: "md"
				})] })
			]
		})]
	});
}
//#endregion
//#region src/components/feedback/LoadingSkeleton/layouts/ListSkeleton.tsx
function Yr() {
	return /* @__PURE__ */ U(P, {
		gap: "md",
		p: "md",
		"data-testid": "list-item-skeleton",
		children: [/* @__PURE__ */ H(F, {
			height: 60,
			width: 60,
			radius: "md"
		}), /* @__PURE__ */ U(I, {
			gap: "xs",
			style: { flex: 1 },
			children: [/* @__PURE__ */ H(F, {
				height: 14,
				width: "60%"
			}), /* @__PURE__ */ H(F, {
				height: 12,
				width: "40%"
			})]
		})]
	});
}
function Xr({ count: e = 4 }) {
	return /* @__PURE__ */ H(I, {
		gap: 0,
		"data-testid": "list-skeleton",
		children: Array.from({ length: e }).map((e, t) => /* @__PURE__ */ H(Yr, {}, t))
	});
}
//#endregion
//#region src/components/feedback/LoadingSkeleton/layouts/CardSkeleton.tsx
function Zr() {
	return /* @__PURE__ */ U(N, {
		withBorder: !0,
		padding: "md",
		"data-testid": "card-skeleton",
		children: [/* @__PURE__ */ H(N.Section, { children: /* @__PURE__ */ H(F, { height: 200 }) }), /* @__PURE__ */ U(I, {
			gap: "xs",
			mt: "md",
			children: [
				/* @__PURE__ */ H(F, {
					height: 16,
					width: "70%"
				}),
				/* @__PURE__ */ H(F, {
					height: 12,
					width: "50%"
				}),
				/* @__PURE__ */ U(P, {
					justify: "space-between",
					mt: "xs",
					children: [/* @__PURE__ */ H(F, {
						height: 20,
						width: 80
					}), /* @__PURE__ */ H(F, {
						height: 32,
						width: 32,
						radius: "xl"
					})]
				})
			]
		})]
	});
}
//#endregion
//#region src/components/feedback/LoadingSkeleton/layouts/TextSkeleton.tsx
function Qr({ lines: e = 3, width: t = [
	"100%",
	"80%",
	"60%"
] }) {
	return /* @__PURE__ */ H(I, {
		gap: "xs",
		"data-testid": "text-skeleton",
		children: Array.from({ length: e }).map((e, n) => /* @__PURE__ */ H(F, {
			height: 14,
			width: Array.isArray(t) ? t[n % t.length] : t
		}, n))
	});
}
//#endregion
//#region src/components/feedback/LoadingSkeleton/layouts/StatsSkeleton.tsx
function $r({ count: e = 4 }) {
	return /* @__PURE__ */ H(P, {
		justify: "space-around",
		"data-testid": "stats-skeleton",
		children: Array.from({ length: e }).map((e, t) => /* @__PURE__ */ U("div", {
			style: { textAlign: "center" },
			children: [/* @__PURE__ */ H(F, {
				height: 32,
				width: 80,
				mb: "xs"
			}), /* @__PURE__ */ H(F, {
				height: 16,
				width: 100
			})]
		}, t))
	});
}
//#endregion
//#region src/components/feedback/LoadingSkeleton/layouts/TableSkeleton.tsx
function ei({ rows: e = 5, columns: t = 4 }) {
	return /* @__PURE__ */ U(L, {
		"data-testid": "table-skeleton",
		children: [/* @__PURE__ */ H(L.Thead, { children: /* @__PURE__ */ H(L.Tr, { children: Array.from({ length: t }).map((e, t) => /* @__PURE__ */ H(L.Th, { children: /* @__PURE__ */ H(F, {
			height: 16,
			width: "70%"
		}) }, t)) }) }), /* @__PURE__ */ H(L.Tbody, { children: Array.from({ length: e }).map((e, n) => /* @__PURE__ */ H(L.Tr, { children: Array.from({ length: t }).map((e, t) => /* @__PURE__ */ H(L.Td, { children: /* @__PURE__ */ H(F, {
			height: 14,
			width: t === 0 ? "80%" : "60%"
		}) }, t)) }, n)) })]
	});
}
//#endregion
//#region src/components/feedback/LoadingSkeleton/layouts/KPISkeleton.tsx
function ti() {
	return /* @__PURE__ */ H(N, {
		withBorder: !0,
		padding: "lg",
		radius: "md",
		children: /* @__PURE__ */ U(I, {
			gap: "xs",
			children: [
				/* @__PURE__ */ U(P, {
					justify: "space-between",
					children: [/* @__PURE__ */ H(F, {
						height: 14,
						width: 100
					}), /* @__PURE__ */ H(F, {
						height: 24,
						width: 24,
						radius: "sm"
					})]
				}),
				/* @__PURE__ */ H(F, {
					height: 32,
					width: "60%"
				}),
				/* @__PURE__ */ H(F, {
					height: 12,
					width: "40%"
				})
			]
		})
	});
}
function ni({ count: e = 4 }) {
	return /* @__PURE__ */ H(ze, {
		cols: {
			base: 1,
			xs: 2,
			md: 4
		},
		spacing: "md",
		"data-testid": "kpi-skeleton",
		children: Array.from({ length: e }).map((e, t) => /* @__PURE__ */ H(ti, {}, t))
	});
}
//#endregion
//#region src/components/feedback/LoadingSkeleton/layouts/ChartSkeleton.tsx
function ri({ height: e = 300 }) {
	return /* @__PURE__ */ U(I, {
		gap: "md",
		"data-testid": "chart-skeleton",
		children: [
			/* @__PURE__ */ U(P, {
				justify: "space-between",
				children: [/* @__PURE__ */ H(F, {
					height: 20,
					width: 150
				}), /* @__PURE__ */ U(P, {
					gap: "sm",
					children: [
						/* @__PURE__ */ H(F, {
							height: 16,
							width: 60,
							radius: "xl"
						}),
						/* @__PURE__ */ H(F, {
							height: 16,
							width: 60,
							radius: "xl"
						}),
						/* @__PURE__ */ H(F, {
							height: 16,
							width: 60,
							radius: "xl"
						})
					]
				})]
			}),
			/* @__PURE__ */ H(j, {
				pos: "relative",
				h: e,
				children: /* @__PURE__ */ H(F, {
					height: e,
					radius: "md"
				})
			}),
			/* @__PURE__ */ H(P, {
				justify: "space-between",
				px: "md",
				children: Array.from({ length: 6 }).map((e, t) => /* @__PURE__ */ H(F, {
					height: 12,
					width: 40
				}, t))
			})
		]
	});
}
//#endregion
//#region src/components/feedback/LoadingSkeleton/LoadingSkeleton.tsx
function ii({ layout: e, count: t, rows: n, columns: r, lines: i, width: a, height: o }) {
	switch (e) {
		case "product-grid": return /* @__PURE__ */ H(Gr, { count: t });
		case "merchant-grid": return /* @__PURE__ */ H(qr, { count: t });
		case "product-detail": return /* @__PURE__ */ H(Jr, {});
		case "list": return /* @__PURE__ */ H(Xr, { count: t });
		case "card": return /* @__PURE__ */ H(Zr, {});
		case "text": return /* @__PURE__ */ H(Qr, {
			lines: i,
			width: a
		});
		case "stats": return /* @__PURE__ */ H($r, { count: t });
		case "table": return /* @__PURE__ */ H(ei, {
			rows: n,
			columns: r
		});
		case "kpi": return /* @__PURE__ */ H(ni, { count: t });
		case "chart": return /* @__PURE__ */ H(ri, { height: o });
		default: return null;
	}
}
//#endregion
//#region src/components/feedback/LoadingSkeleton/PageLoader.tsx
function ai({ message: e, height: t = 300 }) {
	let { t: n } = hn("common"), r = e ?? n("loading_states.loading", "Loading...");
	return /* @__PURE__ */ H(_e, {
		h: t,
		"data-testid": "page-loader",
		children: /* @__PURE__ */ U(I, {
			align: "center",
			gap: "md",
			children: [/* @__PURE__ */ H(Ae, { size: "lg" }), /* @__PURE__ */ H(R, {
				size: "lg",
				c: "dimmed",
				children: r
			})]
		})
	});
}
//#endregion
//#region src/components/feedback/LoadingSkeleton/FullScreenLoader.tsx
function oi({ message: e }) {
	let { t } = hn("common"), n = qe("light"), r = e ?? t("loading_states.loading", "Loading...");
	return /* @__PURE__ */ H("div", {
		style: {
			position: "fixed",
			top: 0,
			left: 0,
			right: 0,
			bottom: 0,
			backgroundColor: n === "dark" ? "rgba(0, 0, 0, 0.9)" : "rgba(255, 255, 255, 0.9)",
			display: "flex",
			alignItems: "center",
			justifyContent: "center",
			zIndex: 1e3
		},
		"data-testid": "full-screen-loader",
		children: /* @__PURE__ */ U(I, {
			align: "center",
			gap: "md",
			children: [/* @__PURE__ */ H(Ae, { size: "xl" }), /* @__PURE__ */ H(R, {
				size: "lg",
				c: "dimmed",
				children: r
			})]
		})
	});
}
//#endregion
//#region src/components/feedback/EmptyState/EmptyState.tsx
var si = {
	sm: 120,
	md: 180,
	lg: 240
}, ci = {
	sm: 60,
	md: 80,
	lg: 100
}, li = {
	sm: 30,
	md: 40,
	lg: 50
}, ui = {
	sm: 4,
	md: 3,
	lg: 2
};
function di({ title: e, description: t, icon: n, image: r, action: i, secondaryAction: a, size: o = "md", ...s }) {
	let c = si[o], l = ci[o], u = li[o], d = ui[o], f = o === "sm" ? "sm" : "md", p = o === "sm" ? "xs" : "sm";
	return /* @__PURE__ */ H(_e, {
		py: o === "lg" ? "xl" : "lg",
		"data-testid": "empty-state",
		...s,
		children: /* @__PURE__ */ U(I, {
			align: "center",
			gap: "md",
			maw: 400,
			children: [
				r ? /* @__PURE__ */ H(Oe, {
					src: r,
					alt: "",
					w: c,
					h: c,
					fit: "contain",
					"data-testid": "empty-state-image",
					"aria-hidden": "true"
				}) : /* @__PURE__ */ H(Ve, {
					size: l,
					radius: "xl",
					variant: "light",
					color: "gray",
					"data-testid": "empty-state-icon",
					children: n || /* @__PURE__ */ H(At, { size: u })
				}),
				/* @__PURE__ */ H(Ue, {
					order: d,
					ta: "center",
					"data-testid": "empty-state-title",
					children: e
				}),
				t && /* @__PURE__ */ H(R, {
					c: "dimmed",
					ta: "center",
					size: o === "sm" ? "sm" : "md",
					"data-testid": "empty-state-description",
					children: t
				}),
				(i || a) && /* @__PURE__ */ U(I, {
					gap: "xs",
					mt: "xs",
					align: "center",
					children: [i && /* @__PURE__ */ H(M, {
						variant: i.variant || "light",
						onClick: i.onClick,
						size: f,
						"data-testid": "empty-state-action",
						children: i.label
					}), a && /* @__PURE__ */ H(M, {
						variant: "subtle",
						onClick: a.onClick,
						size: p,
						"data-testid": "empty-state-secondary-action",
						children: a.label
					})]
				})
			]
		})
	});
}
//#endregion
//#region src/components/feedback/ErrorState/ErrorState.tsx
function fi(e, t) {
	return !!(e === "NETWORK_ERROR" || t?.toLowerCase().includes("fetch") || t?.toLowerCase().includes("network"));
}
function pi({ message: e, title: t, code: n, onRetry: r, retryLabel: i = "Reintentar", isRetrying: a = !1, action: o, details: s, showDetails: c = !1, variant: l = "alert", color: u = "red" }) {
	let [d, f] = J(!1), p = fi(n, e), m = p ? dn : Ye, h = t ?? (p ? "Error de conexión" : "Error"), g = c && s ? /* @__PURE__ */ H(M, {
		variant: "subtle",
		size: "xs",
		color: "gray",
		onClick: () => f(!d),
		rightSection: H(d ? st : it, { size: 14 }),
		"data-testid": "error-state-details-toggle",
		children: d ? "Ocultar detalles" : "Ver detalles"
	}) : null, _ = c && s ? /* @__PURE__ */ H(xe, {
		expanded: d,
		children: /* @__PURE__ */ H(be, {
			block: !0,
			mt: "sm",
			style: {
				maxHeight: 200,
				overflow: "auto"
			},
			"data-testid": "error-state-details",
			children: s
		})
	}) : null;
	return l === "alert" ? /* @__PURE__ */ H(pe, {
		icon: /* @__PURE__ */ H(m, { size: 16 }),
		color: u,
		title: h,
		"data-testid": "error-state",
		children: /* @__PURE__ */ U(I, {
			gap: "sm",
			children: [
				/* @__PURE__ */ H(R, {
					size: "sm",
					"data-testid": "error-state-message",
					children: e
				}),
				(r || o) && /* @__PURE__ */ U(I, {
					gap: "xs",
					children: [r && /* @__PURE__ */ H(M, {
						variant: "light",
						color: u,
						size: "xs",
						leftSection: /* @__PURE__ */ H(qt, { size: 14 }),
						onClick: r,
						loading: a,
						"data-testid": "error-state-retry",
						children: i
					}), o && /* @__PURE__ */ H(M, {
						variant: "subtle",
						color: u,
						size: "xs",
						onClick: o.onClick,
						"data-testid": "error-state-action",
						children: o.label
					})]
				}),
				g,
				_
			]
		})
	}) : /* @__PURE__ */ H(_e, {
		py: "xl",
		"data-testid": "error-state",
		children: /* @__PURE__ */ U(I, {
			align: "center",
			gap: "lg",
			maw: 400,
			children: [
				/* @__PURE__ */ H(m, {
					size: 64,
					color: `var(--mantine-color-${u}-6)`,
					"data-testid": "error-state-icon"
				}),
				/* @__PURE__ */ H(R, {
					size: "xl",
					fw: 600,
					ta: "center",
					"data-testid": "error-state-title",
					children: h
				}),
				/* @__PURE__ */ H(R, {
					c: "dimmed",
					ta: "center",
					"data-testid": "error-state-message",
					children: e
				}),
				(r || o) && /* @__PURE__ */ U(I, {
					gap: "xs",
					align: "center",
					children: [r && /* @__PURE__ */ H(M, {
						leftSection: /* @__PURE__ */ H(qt, { size: 18 }),
						onClick: r,
						loading: a,
						"data-testid": "error-state-retry",
						children: i
					}), o && /* @__PURE__ */ H(M, {
						variant: "subtle",
						onClick: o.onClick,
						"data-testid": "error-state-action",
						children: o.label
					})]
				}),
				g,
				_
			]
		})
	});
}
//#endregion
//#region src/components/feedback/ErrorBoundary/ErrorBoundary.tsx
var mi = class extends _n {
	state = {
		hasError: !1,
		error: null,
		errorInfo: null,
		showDetails: !1
	};
	static getDerivedStateFromError(e) {
		return {
			hasError: !0,
			error: e
		};
	}
	componentDidCatch(e, t) {
		this.setState({ errorInfo: t }), this.props.onError?.(e, t), console.error("ErrorBoundary caught an error:", e, t);
	}
	handleRetry = () => {
		this.setState({
			hasError: !1,
			error: null,
			errorInfo: null,
			showDetails: !1
		});
	};
	handleReload = () => {
		window.location.reload();
	};
	toggleDetails = () => {
		this.setState((e) => ({ showDetails: !e.showDetails }));
	};
	render() {
		let { children: e, fallback: t, title: n = "Algo salió mal", message: r = "Lo sentimos, ocurrió un error inesperado. Podés intentar recargar la página.", retryLabel: i = "Reintentar", reloadLabel: a = "Recargar página" } = this.props, { hasError: o, error: s, errorInfo: c, showDetails: l } = this.state;
		return o ? t || /* @__PURE__ */ H(Ce, {
			size: "sm",
			py: "xl",
			"data-testid": "error-boundary-fallback",
			children: /* @__PURE__ */ H(Fe, {
				p: "xl",
				withBorder: !0,
				children: /* @__PURE__ */ U(I, {
					align: "center",
					gap: "lg",
					children: [
						/* @__PURE__ */ H(Xe, {
							size: 64,
							color: "var(--mantine-color-red-6)",
							"data-testid": "error-boundary-icon"
						}),
						/* @__PURE__ */ H(R, {
							size: "xl",
							fw: 600,
							ta: "center",
							"data-testid": "error-boundary-title",
							children: n
						}),
						/* @__PURE__ */ H(R, {
							c: "dimmed",
							ta: "center",
							maw: 400,
							"data-testid": "error-boundary-message",
							children: r
						}),
						/* @__PURE__ */ U(P, { children: [/* @__PURE__ */ H(M, {
							leftSection: /* @__PURE__ */ H(qt, { size: 18 }),
							onClick: this.handleRetry,
							"data-testid": "error-boundary-retry",
							children: i
						}), /* @__PURE__ */ H(M, {
							variant: "light",
							onClick: this.handleReload,
							"data-testid": "error-boundary-reload",
							children: a
						})] }),
						!1
					]
				})
			})
		}) : e;
	}
};
//#endregion
//#region src/components/feedback/FilterChips/FilterChips.tsx
function hi({ filters: e, onClearAll: t, clearAllLabel: n = "Limpiar filtros", clearAllMinFilters: r = 2, size: i = "lg", variant: a = "outline" }) {
	if (e.length === 0) return null;
	let o = t && e.length >= r;
	return /* @__PURE__ */ U(P, {
		gap: "xs",
		"data-testid": "filter-chips",
		children: [e.map((e) => {
			let t = e.value ? `${e.label}: ${e.value}` : e.label;
			return /* @__PURE__ */ H(A, {
				variant: a,
				size: i,
				pr: 3,
				rightSection: /* @__PURE__ */ H(ye, {
					size: "xs",
					variant: "transparent",
					onClick: e.onRemove,
					"aria-label": `Eliminar filtro ${e.label}`,
					"data-testid": `remove-filter-${e.key}`,
					tabIndex: 0,
					onKeyDown: (t) => {
						(t.key === "Enter" || t.key === " ") && (t.preventDefault(), e.onRemove());
					}
				}),
				"data-testid": `filter-chip-${e.key}`,
				children: t
			}, e.key);
		}), o && /* @__PURE__ */ H(M, {
			size: "xs",
			variant: "subtle",
			color: "gray",
			leftSection: /* @__PURE__ */ H(V, { size: 14 }),
			onClick: t,
			"data-testid": "clear-all-filters",
			children: n
		})]
	});
}
//#endregion
//#region src/components/feedback/NotificationIcons/NotificationIcons.tsx
var gi = 18, _i = "\n@keyframes notification-icon-spin {\n  from { transform: rotate(0deg); }\n  to { transform: rotate(360deg); }\n}\n";
typeof document < "u" && (() => {
	if (typeof document > "u") return;
	let e = "notification-icons-spin-keyframes";
	if (document.getElementById(e)) return;
	let t = document.createElement("style");
	t.id = e, t.textContent = _i, document.head.appendChild(t);
})();
var vi = {
	success: /* @__PURE__ */ H(z, { size: 18 }),
	error: /* @__PURE__ */ H(V, { size: 18 }),
	warning: /* @__PURE__ */ H(Xe, { size: 18 }),
	info: /* @__PURE__ */ H(jt, { size: 18 }),
	loading: /* @__PURE__ */ H(Pt, {
		size: 18,
		style: { animation: "notification-icon-spin 1s linear infinite" }
	})
}, yi = [
	"success",
	"error",
	"warning",
	"info",
	"loading"
];
//#endregion
//#region src/components/data-display/Breadcrumbs/Breadcrumbs.tsx
function bi(e, t) {
	if (t <= 0 || e.length <= t) return e;
	let n = Math.max(t - 2, 1);
	return [
		e[0],
		{
			label: "...",
			href: void 0
		},
		...e.slice(-n)
	];
}
function xi({ items: e, separator: t = /* @__PURE__ */ H(ot, {
	size: 14,
	stroke: 1.5
}), renderLink: n, size: r = "sm", maxItems: i }) {
	let a = An("(max-width: 768px)"), o = i ?? (a ? 4 : void 0);
	if (e.length === 0) return null;
	let s = o ? bi(e, o) : e;
	return /* @__PURE__ */ H("nav", {
		"aria-label": "Breadcrumb",
		"data-testid": "breadcrumbs",
		children: /* @__PURE__ */ H(ge, {
			separator: t,
			separatorMargin: "xs",
			children: s.map((e, t) => {
				let i = t === s.length - 1, a = e.label === "...", o = !!e.href;
				return a ? /* @__PURE__ */ H(R, {
					size: r,
					c: "dimmed",
					"data-testid": "breadcrumb-ellipsis",
					children: "..."
				}, "ellipsis") : i || !o ? /* @__PURE__ */ H(R, {
					size: r,
					c: i ? void 0 : "dimmed",
					fw: i ? 500 : void 0,
					"data-testid": `breadcrumb-${t}`,
					"aria-current": i ? "page" : void 0,
					children: e.label
				}, `${e.label}-${t}`) : n ? /* @__PURE__ */ H("span", {
					"data-testid": `breadcrumb-${t}`,
					children: n(e.href, /* @__PURE__ */ H(R, {
						size: r,
						c: "dimmed",
						component: "span",
						style: { cursor: "pointer" },
						children: e.label
					}))
				}, `${e.label}-${t}`) : /* @__PURE__ */ H(me, {
					href: e.href,
					size: r,
					c: "dimmed",
					"data-testid": `breadcrumb-${t}`,
					children: e.label
				}, `${e.label}-${t}`);
			})
		})
	});
}
//#endregion
//#region src/components/data-display/PriceDisplay/PriceDisplay.tsx
var Si = {
	sm: {
		price: "sm",
		compare: "xs",
		badge: "sm"
	},
	md: {
		price: "lg",
		compare: "sm",
		badge: "sm"
	},
	lg: {
		price: "xl",
		compare: "md",
		badge: "md"
	},
	xl: {
		price: "1.75rem",
		compare: "lg",
		badge: "lg"
	}
};
function Ci(e, t, n) {
	return new Intl.NumberFormat(n, {
		style: "currency",
		currency: t,
		minimumFractionDigits: 0,
		maximumFractionDigits: 2
	}).format(e);
}
function wi(e, t) {
	return t <= 0 || e >= t ? 0 : Math.round((t - e) / t * 100);
}
function Ti({ price: e, compareAtPrice: t, currency: n = "ARS", locale: r = "es-AR", size: i = "md", showDiscountBadge: a = !0, layout: o = "horizontal", formatPrice: s, "data-testid": c, displayCurrency: l, exchangeRate: u, showOriginalPrice: d = !0 }) {
	let f = Si[i], p = t ? wi(e, t) : 0, m = p > 0, h = l != null && u != null && l !== n, g = h ? e * u : e, _ = h ? l : n, v = (e, t = _) => s ? s(e, t) : Ci(e, t, r);
	return o === "vertical" ? /* @__PURE__ */ U(I, {
		gap: 4,
		"data-testid": c ?? "price-display",
		children: [
			m && t && /* @__PURE__ */ U(P, {
				gap: "xs",
				align: "center",
				children: [/* @__PURE__ */ H(R, {
					size: f.compare,
					c: "dimmed",
					td: "line-through",
					"data-testid": "price-compare",
					children: v(h ? t * u : t)
				}), a && /* @__PURE__ */ U(A, {
					size: f.badge,
					color: "green",
					variant: "light",
					"data-testid": "price-discount",
					children: [
						"-",
						p,
						"%"
					]
				})]
			}),
			/* @__PURE__ */ H(R, {
				size: f.price,
				fw: 700,
				c: m ? "green" : void 0,
				"data-testid": "price-current",
				children: v(g)
			}),
			h && d && /* @__PURE__ */ U(R, {
				size: f.compare,
				c: "dimmed",
				"data-testid": "price-original",
				children: [
					"(",
					v(e, n),
					")"
				]
			})
		]
	}) : /* @__PURE__ */ U(P, {
		gap: "xs",
		align: "center",
		wrap: "nowrap",
		"data-testid": c ?? "price-display",
		children: [
			/* @__PURE__ */ H(R, {
				size: f.price,
				fw: 700,
				c: m ? "green" : void 0,
				"data-testid": "price-current",
				children: v(g)
			}),
			h && d && /* @__PURE__ */ U(R, {
				size: f.compare,
				c: "dimmed",
				"data-testid": "price-original",
				children: [
					"(",
					v(e, n),
					")"
				]
			}),
			m && t && /* @__PURE__ */ U(mn, { children: [/* @__PURE__ */ H(R, {
				size: f.compare,
				c: "dimmed",
				td: "line-through",
				"data-testid": "price-compare",
				children: v(h ? t * u : t)
			}), a && /* @__PURE__ */ U(A, {
				size: f.badge,
				color: "green",
				variant: "light",
				"data-testid": "price-discount",
				children: [
					"-",
					p,
					"%"
				]
			})] })
		]
	});
}
//#endregion
//#region src/components/data-display/StockBadge/StockBadge.tsx
var Ei = {
	inStock: "In Stock",
	lowStock: "Low Stock",
	outOfStock: "Out of Stock",
	xInStock: "{{count}} in stock",
	onlyXLeft: "Only {{count}} left!",
	units: "units"
}, Di = {
	xs: 10,
	sm: 12,
	md: 14
}, Oi = {
	in_stock: {
		color: "green",
		Icon: z,
		labelKey: "inStock"
	},
	low_stock: {
		color: "orange",
		Icon: Xe,
		labelKey: "lowStock"
	},
	out_of_stock: {
		color: "red",
		Icon: V,
		labelKey: "outOfStock"
	}
};
function ki(e, t = 10) {
	return e <= 0 ? "out_of_stock" : e <= t ? "low_stock" : "in_stock";
}
function Ai(e, t) {
	return e.replace(/\{\{count\}\}/g, String(t));
}
function ji(e, t, n, r) {
	let i = r[Oi[e].labelKey];
	return t === "status" ? i : e === "out_of_stock" ? r.outOfStock : n === void 0 ? i : Ai(e === "low_stock" ? r.onlyXLeft : r.xInStock, n);
}
function Mi({ status: e, displayMode: t = "status", quantity: n, variant: r = "badge", size: i = "sm", showLabel: a = !0, labels: o }) {
	let s = {
		...Ei,
		...o
	}, c = Oi[e], l = Di[i] || 12, u = c.Icon, d = ji(e, t, n, s), f = a ? d : void 0;
	if (r === "icon") {
		let e = /* @__PURE__ */ H(u, {
			size: l + 2,
			color: `var(--mantine-color-${c.color}-6)`,
			"data-testid": "stock-badge-icon"
		});
		return f ? /* @__PURE__ */ H(We, {
			label: f,
			children: /* @__PURE__ */ H("span", {
				"data-testid": "stock-badge",
				children: e
			})
		}) : /* @__PURE__ */ H("span", {
			"data-testid": "stock-badge",
			children: e
		});
	}
	return r === "text" ? /* @__PURE__ */ H(R, {
		size: i,
		c: c.color,
		fw: 500,
		"data-testid": "stock-badge",
		children: f || s[c.labelKey]
	}) : /* @__PURE__ */ H(A, {
		color: c.color,
		size: i,
		variant: e === "out_of_stock" ? "filled" : "light",
		leftSection: /* @__PURE__ */ H(u, { size: l }),
		"data-testid": "stock-badge",
		children: f || s[c.labelKey]
	});
}
//#endregion
//#region src/components/data-display/Timeline/Timeline.tsx
var Ni = (e) => (typeof e == "string" ? new Date(e) : e).toLocaleString("es-AR", {
	day: "2-digit",
	month: "2-digit",
	year: "numeric",
	hour: "2-digit",
	minute: "2-digit"
}), Pi = (e, t) => {
	switch (e) {
		case "completed": return /* @__PURE__ */ H(lt, { size: t * .6 });
		case "current": return /* @__PURE__ */ H(ut, { size: t * .6 });
		default: return /* @__PURE__ */ H(ct, { size: t * .6 });
	}
}, Fi = (e) => {
	switch (e) {
		case "completed": return "green";
		case "current": return "blue";
		default: return "gray";
	}
}, Ii = (e) => e === "pending" ? "light" : "filled";
function Li({ events: e, activeIndex: t, reverseOrder: n = !1, bulletSize: r = 36, lineWidth: i = 2, formatTimestamp: a = Ni, labels: o }) {
	let s = t ?? e.findIndex((e) => e.status === "current"), c = n ? [...e].reverse() : e, l = n ? e.length - 1 - s : s;
	return /* @__PURE__ */ H(He, {
		active: l >= 0 ? l : void 0,
		bulletSize: r,
		lineWidth: i,
		"data-testid": "timeline",
		children: c.map((e) => {
			let t = e.status || "pending", n = e.color || Fi(t), i = Ii(t);
			return /* @__PURE__ */ H(He.Item, {
				"data-testid": `timeline-item-${e.id}`,
				bullet: e.icon ? /* @__PURE__ */ H(Ve, {
					size: r,
					variant: i,
					color: n,
					radius: "xl",
					children: e.icon
				}) : /* @__PURE__ */ H(Ve, {
					size: r,
					variant: i,
					color: n,
					radius: "xl",
					children: Pi(t, r)
				}),
				title: /* @__PURE__ */ U(P, {
					gap: "xs",
					children: [/* @__PURE__ */ H(R, {
						fw: 500,
						"data-testid": `timeline-title-${e.id}`,
						children: e.title
					}), t === "current" && o?.current && /* @__PURE__ */ U(R, {
						size: "sm",
						c: "dimmed",
						children: [
							"(",
							o.current,
							")"
						]
					})]
				}),
				children: /* @__PURE__ */ U(I, {
					gap: 4,
					children: [e.description && /* @__PURE__ */ H(R, {
						size: "sm",
						c: "dimmed",
						"data-testid": `timeline-description-${e.id}`,
						children: e.description
					}), e.timestamp && /* @__PURE__ */ H(R, {
						size: "xs",
						c: "dimmed",
						"data-testid": `timeline-timestamp-${e.id}`,
						children: a(e.timestamp)
					})]
				})
			}, e.id);
		})
	});
}
//#endregion
//#region src/components/data-display/DataTable/DataTableHeader.tsx
function Ri({ sortOrder: e, active: t }) {
	return t ? H(e === "asc" ? st : it, {
		size: 14,
		stroke: 2
	}) : /* @__PURE__ */ H(Xt, {
		size: 14,
		stroke: 1.5,
		style: { opacity: .5 }
	});
}
function zi({ columns: e, sortBy: t, sortOrder: n, onSort: r, selectable: i, allSelected: a, someSelected: o, onSelectAll: s }) {
	return /* @__PURE__ */ U("tr", {
		"data-testid": "datatable-header",
		children: [i && /* @__PURE__ */ H("th", {
			style: { width: 40 },
			children: /* @__PURE__ */ H(_e, { children: /* @__PURE__ */ H("input", {
				type: "checkbox",
				checked: a ?? !1,
				ref: (e) => {
					e && (e.indeterminate = !!(o && !a));
				},
				onChange: s,
				"data-testid": "datatable-select-all",
				"aria-label": "Select all rows"
			}) })
		}), e.map((e) => {
			let i = String(e.key), a = t === i, o = /* @__PURE__ */ U(P, {
				gap: 4,
				wrap: "nowrap",
				children: [/* @__PURE__ */ H(R, {
					fw: 500,
					size: "sm",
					children: e.label
				}), e.sortable && /* @__PURE__ */ H(Ri, {
					sortOrder: n,
					active: a
				})]
			});
			return /* @__PURE__ */ H("th", {
				style: {
					width: e.width,
					textAlign: e.align || "left"
				},
				"data-testid": `datatable-header-${i}`,
				children: e.sortable && r ? /* @__PURE__ */ H(Ge, {
					onClick: () => r(i),
					style: { width: "100%" },
					"data-testid": `datatable-sort-${i}`,
					children: o
				}) : o
			}, i);
		})]
	});
}
//#endregion
//#region src/components/data-display/DataTable/DataTablePagination.tsx
var Bi = [
	{
		value: "10",
		label: "10"
	},
	{
		value: "25",
		label: "25"
	},
	{
		value: "50",
		label: "50"
	},
	{
		value: "100",
		label: "100"
	}
];
function Vi({ pagination: e, onPageChange: t, onLimitChange: n }) {
	let { page: r, limit: i, total: a } = e, o = Math.ceil(a / i), s = a === 0 ? 0 : (r - 1) * i + 1, c = Math.min(r * i, a);
	return /* @__PURE__ */ U(P, {
		justify: "space-between",
		mt: "md",
		"data-testid": "datatable-pagination",
		children: [/* @__PURE__ */ U(P, {
			gap: "xs",
			children: [
				/* @__PURE__ */ H(R, {
					size: "sm",
					c: "dimmed",
					children: "Mostrar"
				}),
				/* @__PURE__ */ H(Re, {
					value: String(i),
					onChange: (e) => {
						e && n && n(Number(e));
					},
					data: Bi,
					size: "xs",
					w: 70,
					"data-testid": "datatable-limit-select",
					"aria-label": "Items per page"
				}),
				/* @__PURE__ */ U(R, {
					size: "sm",
					c: "dimmed",
					children: [
						"de ",
						a,
						" registros"
					]
				})
			]
		}), /* @__PURE__ */ U(P, {
			gap: "md",
			children: [/* @__PURE__ */ U(R, {
				size: "sm",
				c: "dimmed",
				"data-testid": "datatable-range",
				children: [
					s,
					"-",
					c,
					" de ",
					a
				]
			}), o > 1 && /* @__PURE__ */ H(Pe, {
				value: r,
				onChange: (e) => t?.(e),
				total: o,
				size: "sm",
				"data-testid": "datatable-pages"
			})]
		})]
	});
}
//#endregion
//#region src/components/data-display/DataTable/DataTable.tsx
function Hi(e, t) {
	return t.split(".").reduce((e, t) => {
		if (e && typeof e == "object" && t in e) return e[t];
	}, e);
}
function Ui(e, t) {
	let n = e;
	return "guid" in n && typeof n.guid == "string" ? n.guid : "id" in n && typeof n.id == "string" ? n.id : "id" in n && typeof n.id == "number" ? String(n.id) : String(t);
}
function Wi({ data: e, columns: t, loading: n = !1, pagination: r, onPageChange: i, onLimitChange: a, sortBy: o, sortOrder: s, onSort: c, selectable: l = !1, selectedIds: u = [], onSelectionChange: d, getRowId: f, emptyState: p, onRowClick: m, striped: h = !1, highlightOnHover: g = !0, layout: _ = "auto", verticalAlign: v = "middle" }) {
	let y = W((e, t) => f ? f(e) : Ui(e, t), [f]), b = K(() => new Set(u), [u]), x = K(() => e.map((e, t) => y(e, t)), [e, y]), S = x.length > 0 && x.every((e) => b.has(e)), C = x.some((e) => b.has(e)), ee = W(() => {
		d && d(S ? u.filter((e) => !x.includes(e)) : [...new Set([...u, ...x])]);
	}, [
		S,
		u,
		x,
		d
	]), w = W((e) => {
		d && (b.has(e) ? d(u.filter((t) => t !== e)) : d([...u, e]));
	}, [
		b,
		u,
		d
	]), te = W((e, t, n) => {
		let r = Hi(e, String(t.key));
		return t.render ? t.render(r, e, n) : r == null ? "-" : String(r);
	}, []);
	return n ? /* @__PURE__ */ H(j, {
		"data-testid": "datatable-loading",
		children: /* @__PURE__ */ H(ei, {
			rows: r?.limit || 10,
			columns: t.length + +!!l
		})
	}) : e.length === 0 ? /* @__PURE__ */ H(j, {
		"data-testid": "datatable-empty",
		children: p || /* @__PURE__ */ H(di, {
			title: "No hay datos",
			description: "No se encontraron registros"
		})
	}) : /* @__PURE__ */ U(j, {
		"data-testid": "datatable",
		children: [/* @__PURE__ */ U(L, {
			striped: h,
			highlightOnHover: g,
			layout: _,
			verticalSpacing: "sm",
			children: [/* @__PURE__ */ H(L.Thead, { children: /* @__PURE__ */ H(zi, {
				columns: t,
				sortBy: o,
				sortOrder: s,
				onSort: c,
				selectable: l,
				allSelected: S,
				someSelected: C,
				onSelectAll: ee
			}) }), /* @__PURE__ */ H(L.Tbody, { children: e.map((e, n) => {
				let r = y(e, n), i = b.has(r), a = !!m;
				return /* @__PURE__ */ U(L.Tr, {
					"data-testid": `datatable-row-${n}`,
					"data-selected": i,
					style: {
						cursor: a ? "pointer" : void 0,
						backgroundColor: i ? "var(--mantine-color-blue-light)" : void 0
					},
					onClick: a ? (t) => {
						t.target.closest("input[type=\"checkbox\"]") || m(e);
					} : void 0,
					children: [l && /* @__PURE__ */ H(L.Td, {
						style: {
							width: 40,
							verticalAlign: v
						},
						children: /* @__PURE__ */ H(_e, { children: /* @__PURE__ */ H(ve, {
							checked: i,
							onChange: () => w(r),
							"data-testid": `datatable-select-${n}`,
							"aria-label": `Select row ${n + 1}`
						}) })
					}), t.map((t) => /* @__PURE__ */ H(L.Td, {
						style: {
							width: t.width,
							textAlign: t.align || "left",
							verticalAlign: v
						},
						"data-testid": `datatable-cell-${n}-${t.key}`,
						children: te(e, t, n)
					}, String(t.key)))]
				}, r);
			}) })]
		}), r && /* @__PURE__ */ H(Vi, {
			pagination: r,
			onPageChange: i,
			onLimitChange: a
		})]
	});
}
//#endregion
//#region src/components/data-display/KPICard/KPICard.tsx
function Gi(e, t = "number", n = "ARS", r) {
	if (typeof e == "string") return e;
	switch (t) {
		case "currency": return C(e, n, { showCode: !1 });
		case "percentage": return `${x(e, r ?? 1)}%`;
		default: return x(e, r ?? 0);
	}
}
function Ki(e) {
	return e > 0 ? "green" : e < 0 ? "red" : "gray";
}
function qi({ trend: e }) {
	return H(e > 0 ? sn : e < 0 ? on : zt, {
		size: 14,
		stroke: 2
	});
}
function Ji() {
	return /* @__PURE__ */ H(N, {
		withBorder: !0,
		padding: "lg",
		radius: "md",
		"data-testid": "kpicard-loading",
		children: /* @__PURE__ */ U(I, {
			gap: "xs",
			children: [
				/* @__PURE__ */ U(P, {
					justify: "space-between",
					children: [/* @__PURE__ */ H(F, {
						height: 14,
						width: 100
					}), /* @__PURE__ */ H(F, {
						height: 24,
						width: 24,
						radius: "sm"
					})]
				}),
				/* @__PURE__ */ H(F, {
					height: 32,
					width: "60%"
				}),
				/* @__PURE__ */ H(F, {
					height: 12,
					width: "40%"
				})
			]
		})
	});
}
function Yi({ title: e, value: t, format: n = "number", currency: r = "ARS", decimals: i, trend: a, trendPeriod: o, icon: s, color: c = "blue", highlight: l = !1, loading: u = !1 }) {
	if (u) return /* @__PURE__ */ H(Ji, {});
	let d = Gi(t, n, r, i), f = a !== void 0, p = f ? Ki(a) : "gray";
	return /* @__PURE__ */ H(N, {
		withBorder: !0,
		padding: "lg",
		radius: "md",
		"data-testid": "kpicard",
		style: {
			borderColor: l ? `var(--mantine-color-${c}-6)` : void 0,
			borderWidth: l ? 2 : void 0,
			backgroundColor: l ? `var(--mantine-color-${c}-light)` : void 0
		},
		children: /* @__PURE__ */ U(I, {
			gap: "xs",
			children: [
				/* @__PURE__ */ U(P, {
					justify: "space-between",
					align: "flex-start",
					children: [/* @__PURE__ */ H(R, {
						size: "sm",
						c: "dimmed",
						fw: 500,
						"data-testid": "kpicard-title",
						children: e
					}), s && /* @__PURE__ */ H(Ve, {
						variant: "light",
						color: c,
						size: "md",
						radius: "sm",
						"data-testid": "kpicard-icon",
						children: s
					})]
				}),
				/* @__PURE__ */ H(R, {
					size: "xl",
					fw: 700,
					lh: 1.2,
					"data-testid": "kpicard-value",
					children: d
				}),
				f && /* @__PURE__ */ U(P, {
					gap: 4,
					"data-testid": "kpicard-trend",
					children: [
						/* @__PURE__ */ H(j, {
							c: p,
							children: /* @__PURE__ */ H(qi, { trend: a })
						}),
						/* @__PURE__ */ U(R, {
							size: "xs",
							c: p,
							fw: 500,
							children: [
								a > 0 ? "+" : "",
								x(a, 1),
								"%"
							]
						}),
						o && /* @__PURE__ */ H(R, {
							size: "xs",
							c: "dimmed",
							children: o
						})
					]
				})
			]
		})
	});
}
//#endregion
//#region src/components/data-display/Chart/chartConfig.ts
var Xi = {
	primary: "blue.6",
	secondary: "cyan.6",
	success: "green.6",
	warning: "yellow.6",
	danger: "red.6",
	neutral: "gray.6",
	indigo: "indigo.6",
	violet: "violet.6",
	grape: "grape.6",
	pink: "pink.6",
	orange: "orange.6",
	teal: "teal.6",
	lime: "lime.6"
}, Zi = [
	Xi.primary,
	Xi.secondary,
	Xi.success,
	Xi.warning,
	Xi.indigo,
	Xi.violet,
	Xi.orange,
	Xi.teal
], Qi = [
	"blue.5",
	"cyan.5",
	"teal.5",
	"green.5",
	"lime.5",
	"yellow.5",
	"orange.5",
	"red.5",
	"pink.5",
	"grape.5",
	"violet.5",
	"indigo.5"
], Z = {
	withLegend: !0,
	withTooltip: !0,
	gridAxis: "x",
	curveType: "monotone",
	height: 300,
	locale: "es-AR",
	tooltipAnimationDuration: 200
}, $i = { width: 60 }, ea = { tickLine: "x" };
function ta(e) {
	return e in Xi ? Xi[e] : e;
}
function na(e) {
	return e.map((e, t) => ({
		...e,
		color: e.color ?? Zi[t % Zi.length]
	}));
}
function ra(e) {
	return e.map((e, t) => ({
		...e,
		color: e.color ?? Qi[t % Qi.length]
	}));
}
//#endregion
//#region src/components/data-display/Chart/TeleAreaChart.tsx
function ia({ data: e, dataKey: t, series: n, title: r, height: i = Z.height, loading: a = !1, withLegend: o = Z.withLegend, withTooltip: s = Z.withTooltip, withDots: c = !1, withGradient: l = !0, gridAxis: u = Z.gridAxis, curveType: d = Z.curveType, stacked: f = !1, xAxisLabel: p, yAxisLabel: m, valueFormatter: h, chartProps: g }) {
	if (a) return /* @__PURE__ */ H(ri, { height: i });
	let _ = na(n);
	return /* @__PURE__ */ U(I, {
		gap: "xs",
		"data-testid": "tele-area-chart",
		children: [r && /* @__PURE__ */ H(R, {
			fw: 500,
			size: "sm",
			c: "dimmed",
			children: r
		}), /* @__PURE__ */ H(jn, {
			h: i,
			data: e,
			dataKey: t,
			series: _,
			type: f ? "stacked" : "default",
			withLegend: o,
			withTooltip: s,
			withDots: c,
			withGradient: l,
			gridAxis: u,
			curveType: d,
			xAxisLabel: p,
			yAxisLabel: m,
			valueFormatter: h,
			tooltipAnimationDuration: Z.tooltipAnimationDuration,
			yAxisProps: $i,
			...g
		})]
	});
}
//#endregion
//#region src/components/data-display/Chart/TeleBarChart.tsx
function aa({ data: e, dataKey: t, series: n, title: r, height: i = Z.height, loading: a = !1, withLegend: o = Z.withLegend, withTooltip: s = Z.withTooltip, gridAxis: c = Z.gridAxis, stacked: l = !1, orientation: u = "vertical", maxBarWidth: d, xAxisLabel: f, yAxisLabel: p, valueFormatter: m, chartProps: h }) {
	if (a) return /* @__PURE__ */ H(ri, { height: i });
	let g = na(n);
	return /* @__PURE__ */ U(I, {
		gap: "xs",
		"data-testid": "tele-bar-chart",
		children: [r && /* @__PURE__ */ H(R, {
			fw: 500,
			size: "sm",
			c: "dimmed",
			children: r
		}), /* @__PURE__ */ H(Mn, {
			h: i,
			data: e,
			dataKey: t,
			series: g,
			type: l ? "stacked" : "default",
			orientation: u,
			withLegend: o,
			withTooltip: s,
			gridAxis: c,
			xAxisLabel: f,
			yAxisLabel: p,
			valueFormatter: m,
			maxBarWidth: d,
			tooltipAnimationDuration: Z.tooltipAnimationDuration,
			yAxisProps: u === "horizontal" ? { width: 80 } : $i,
			...h
		})]
	});
}
//#endregion
//#region src/components/data-display/Chart/TeleLineChart.tsx
function oa({ data: e, dataKey: t, series: n, title: r, height: i = Z.height, loading: a = !1, withLegend: o = Z.withLegend, withTooltip: s = Z.withTooltip, withDots: c = !0, gridAxis: l = Z.gridAxis, curveType: u = Z.curveType, strokeWidth: d, xAxisLabel: f, yAxisLabel: p, valueFormatter: m, chartProps: h }) {
	if (a) return /* @__PURE__ */ H(ri, { height: i });
	let g = na(n);
	return /* @__PURE__ */ U(I, {
		gap: "xs",
		"data-testid": "tele-line-chart",
		children: [r && /* @__PURE__ */ H(R, {
			fw: 500,
			size: "sm",
			c: "dimmed",
			children: r
		}), /* @__PURE__ */ H(Pn, {
			h: i,
			data: e,
			dataKey: t,
			series: g,
			withLegend: o,
			withTooltip: s,
			withDots: c,
			gridAxis: l,
			curveType: u,
			strokeWidth: d,
			xAxisLabel: f,
			yAxisLabel: p,
			valueFormatter: m,
			tooltipAnimationDuration: Z.tooltipAnimationDuration,
			yAxisProps: $i,
			...h
		})]
	});
}
//#endregion
//#region src/components/data-display/Chart/TelePieChart.tsx
function sa({ size: e }) {
	return /* @__PURE__ */ U(I, {
		gap: "xs",
		align: "center",
		"data-testid": "pie-chart-skeleton",
		children: [/* @__PURE__ */ H(F, {
			height: e,
			width: e,
			circle: !0
		}), /* @__PURE__ */ H(F, {
			height: 16,
			width: 120
		})]
	});
}
function ca({ data: e, title: t, size: n = 200, loading: r = !1, withLabels: i = !1, labelsPosition: a = "outside", labelsType: o = "percent", withTooltip: s = !0, strokeColor: c, strokeWidth: l = 1, valueFormatter: u, chartProps: d }) {
	if (r) return /* @__PURE__ */ H(sa, { size: n });
	let f = ra(e);
	return /* @__PURE__ */ U(I, {
		gap: "xs",
		"data-testid": "tele-pie-chart",
		children: [t && /* @__PURE__ */ H(R, {
			fw: 500,
			size: "sm",
			c: "dimmed",
			ta: "center",
			children: t
		}), /* @__PURE__ */ H(_e, { children: /* @__PURE__ */ H(Fn, {
			data: f,
			size: n,
			withLabels: i,
			labelsPosition: a,
			labelsType: o,
			withTooltip: s,
			strokeColor: c,
			strokeWidth: l,
			valueFormatter: u,
			tooltipDataSource: "segment",
			...d
		}) })]
	});
}
//#endregion
//#region src/components/data-display/Chart/TeleDonutChart.tsx
function la({ size: e }) {
	return /* @__PURE__ */ U(I, {
		gap: "xs",
		align: "center",
		"data-testid": "donut-chart-skeleton",
		children: [/* @__PURE__ */ H(F, {
			height: e,
			width: e,
			circle: !0
		}), /* @__PURE__ */ H(F, {
			height: 16,
			width: 120
		})]
	});
}
function ua({ data: e, title: t, size: n = 200, thickness: r = 20, loading: i = !1, withLabels: a = !1, withLabelsLine: o = !0, withTooltip: s = !0, centerLabel: c, strokeColor: l, strokeWidth: u = 1, valueFormatter: d, chartProps: f }) {
	if (i) return /* @__PURE__ */ H(la, { size: n });
	let p = ra(e);
	return /* @__PURE__ */ U(I, {
		gap: "xs",
		"data-testid": "tele-donut-chart",
		children: [t && /* @__PURE__ */ H(R, {
			fw: 500,
			size: "sm",
			c: "dimmed",
			ta: "center",
			children: t
		}), /* @__PURE__ */ H(_e, { children: /* @__PURE__ */ H(Nn, {
			data: p,
			size: n,
			thickness: r,
			withLabels: a,
			withLabelsLine: o,
			withTooltip: s,
			strokeColor: l,
			strokeWidth: u,
			valueFormatter: d,
			tooltipDataSource: "segment",
			...c ? { chartLabel: c } : {},
			...f
		}) })]
	});
}
//#endregion
//#region src/components/inputs/QuantityInput/QuantityInput.tsx
function da({ value: e, onChange: t, min: n = 1, max: r = 99, step: i = 1, decimalScale: a, disabled: o = !1, size: s = "md" }) {
	let c = () => {
		let r = e - i;
		t(r >= n ? r : n);
	}, l = () => {
		let n = e + i;
		t(n <= r ? n : r);
	}, u = (e) => {
		let i = typeof e == "string" ? parseFloat(e) : e;
		t(isNaN(i) ? n : Math.min(r, Math.max(n, i)));
	}, d = (e) => {
		o || (e.key === "ArrowUp" ? (e.preventDefault(), l()) : e.key === "ArrowDown" && (e.preventDefault(), c()));
	}, f = s === "sm" ? "md" : s === "lg" ? "xl" : "lg", p = s === "sm" ? 50 : s === "lg" ? 70 : 60, m = s === "sm" ? 14 : s === "lg" ? 18 : 16;
	return /* @__PURE__ */ U(P, {
		gap: 0,
		"data-testid": "quantity-input-group",
		children: [
			/* @__PURE__ */ H(k, {
				variant: "default",
				size: f,
				onClick: c,
				disabled: o || e <= n,
				"aria-label": "Decrease quantity",
				style: {
					borderTopRightRadius: 0,
					borderBottomRightRadius: 0
				},
				"data-testid": "quantity-decrease",
				children: /* @__PURE__ */ H(zt, { size: m })
			}),
			/* @__PURE__ */ H(Ne, {
				value: e,
				onChange: u,
				onKeyDown: d,
				min: n,
				max: r,
				step: i,
				decimalScale: a,
				disabled: o,
				hideControls: !0,
				w: p,
				size: s,
				styles: { input: {
					textAlign: "center",
					borderRadius: 0,
					borderLeft: 0,
					borderRight: 0
				} },
				"aria-label": "Quantity",
				"data-testid": "quantity-input"
			}),
			/* @__PURE__ */ H(k, {
				variant: "default",
				size: f,
				onClick: l,
				disabled: o || e >= r,
				"aria-label": "Increase quantity",
				style: {
					borderTopLeftRadius: 0,
					borderBottomLeftRadius: 0
				},
				"data-testid": "quantity-increase",
				children: /* @__PURE__ */ H(Gt, { size: m })
			})
		]
	});
}
//#endregion
//#region src/hooks/useDebounce.ts
function fa(e, t = {}) {
	let { wait: n = 300, leading: r = !1 } = t, [i] = On(e, n, { leading: r });
	return i;
}
function pa(e, t = 300) {
	let n = q(null), r = q(e);
	return G(() => {
		r.current = e;
	}, [e]), G(() => () => {
		n.current && clearTimeout(n.current);
	}, []), W((...e) => {
		n.current && clearTimeout(n.current), n.current = setTimeout(() => {
			r.current(...e);
		}, t);
	}, [t]);
}
//#endregion
//#region src/components/inputs/SearchInput/SearchInput.tsx
function ma({ value: e, onChange: t, debounceMs: n = 300, onDebouncedChange: r, suggestions: i = [], onSuggestionSelect: a, onSearch: o, onClear: s, placeholder: c = "Buscar...", loading: l = !1, disabled: u = !1, size: d = "md", autoFocus: f = !1 }) {
	let p = q(null), [m, h] = J(!1), g = fa(e, { wait: n });
	G(() => {
		r && r(g);
	}, [g, r]);
	let _ = Ke({
		onDropdownClose: () => {
			_.resetSelectedOption(), h(!1);
		},
		onDropdownOpen: () => {
			h(!0);
		}
	});
	G(() => {
		i.length > 0 && e.trim() !== "" && !u ? _.openDropdown() : _.closeDropdown();
	}, [
		i,
		e,
		u,
		_
	]);
	let v = W((e) => {
		t(e.currentTarget.value);
	}, [t]), y = W(() => {
		t(""), s?.(), p.current?.focus();
	}, [t, s]), b = W((t) => {
		if (t.key === "Enter") {
			if (t.preventDefault(), m && _.getSelectedOptionIndex() !== -1) {
				let e = i[_.getSelectedOptionIndex()];
				if (e && a) {
					a(e), _.closeDropdown();
					return;
				}
			}
			o?.(e), _.closeDropdown();
		}
		m && i.length > 0 && (t.key === "ArrowDown" ? (t.preventDefault(), _.selectNextOption()) : t.key === "ArrowUp" ? (t.preventDefault(), _.selectPreviousOption()) : t.key === "Escape" && _.closeDropdown());
	}, [
		e,
		o,
		m,
		i,
		_,
		a
	]), x = W((e) => {
		t(e), a?.(e), _.closeDropdown(), p.current?.focus();
	}, [
		t,
		a,
		_
	]), S = l ? /* @__PURE__ */ H(Ae, {
		size: "xs",
		"data-testid": "search-loading"
	}) : e ? /* @__PURE__ */ H(k, {
		variant: "subtle",
		color: "gray",
		onClick: y,
		disabled: u,
		"data-testid": "search-clear",
		"aria-label": "Clear search",
		children: /* @__PURE__ */ H(V, { size: 16 })
	}) : null, C = i.map((e, t) => /* @__PURE__ */ H(Se.Option, {
		value: e,
		"data-testid": `search-suggestion-${t}`,
		children: e
	}, e));
	return /* @__PURE__ */ U(Se, {
		store: _,
		onOptionSubmit: x,
		children: [/* @__PURE__ */ H(Se.Target, { children: /* @__PURE__ */ H(Be, {
			ref: p,
			value: e,
			onChange: v,
			onKeyDown: b,
			onFocus: () => {
				i.length > 0 && e.trim() !== "" && _.openDropdown();
			},
			onBlur: () => _.closeDropdown(),
			placeholder: c,
			disabled: u,
			size: d,
			autoFocus: f,
			leftSection: /* @__PURE__ */ H(Yt, { size: 16 }),
			rightSection: S,
			"data-testid": "search-input",
			"aria-label": "Search"
		}) }), i.length > 0 && /* @__PURE__ */ H(Se.Dropdown, {
			"data-testid": "search-suggestions",
			children: /* @__PURE__ */ H(Se.Options, { children: /* @__PURE__ */ H(Le.Autosize, {
				mah: 200,
				children: C
			}) })
		})]
	});
}
//#endregion
//#region src/components/inputs/CurrencyInput/CurrencyInput.tsx
var ha = {
	ARS: "$",
	USD: "US$",
	USDT: "USDT "
};
function ga({ value: e, onChange: t, currency: n = "ARS", decimalScale: r = 2, min: i, max: a, placeholder: o, label: s, error: c, disabled: l, required: u, ...d }) {
	let f = (e) => {
		if (e === "" || e === void 0) t(null);
		else if (typeof e == "number") t(e);
		else {
			let n = parseFloat(e);
			t(isNaN(n) ? null : n);
		}
	}, p = ha[n] || "$";
	return /* @__PURE__ */ H(Ne, {
		value: e ?? "",
		onChange: f,
		prefix: p + " ",
		decimalScale: r,
		fixedDecimalScale: !0,
		decimalSeparator: ",",
		thousandSeparator: ".",
		min: i,
		max: a,
		placeholder: o,
		label: s,
		error: c,
		disabled: l,
		required: u,
		allowNegative: i === void 0 || i < 0,
		hideControls: !0,
		"data-testid": "currency-input",
		...d
	});
}
//#endregion
//#region src/components/inputs/DateRangePicker/DateRangePicker.tsx
Y.locale("es");
var _a = (e) => Y(e).startOf("day").toDate(), va = (e) => Y(e).endOf("day").toDate(), ya = {
	today: {
		label: "Hoy",
		getValue: () => [_a(/* @__PURE__ */ new Date()), va(/* @__PURE__ */ new Date())]
	},
	yesterday: {
		label: "Ayer",
		getValue: () => {
			let e = Y().subtract(1, "day");
			return [_a(e.toDate()), va(e.toDate())];
		}
	},
	last7Days: {
		label: "Últimos 7 días",
		getValue: () => [_a(Y().subtract(6, "day").toDate()), va(/* @__PURE__ */ new Date())]
	},
	last30Days: {
		label: "Últimos 30 días",
		getValue: () => [_a(Y().subtract(29, "day").toDate()), va(/* @__PURE__ */ new Date())]
	},
	thisMonth: {
		label: "Este mes",
		getValue: () => [_a(Y().startOf("month").toDate()), va(/* @__PURE__ */ new Date())]
	},
	lastMonth: {
		label: "Mes pasado",
		getValue: () => {
			let e = Y().subtract(1, "month");
			return [_a(e.startOf("month").toDate()), va(e.endOf("month").toDate())];
		}
	},
	thisYear: {
		label: "Este año",
		getValue: () => [_a(Y().startOf("year").toDate()), va(/* @__PURE__ */ new Date())]
	}
}, ba = (e) => {
	let [t, n] = e;
	return !t && !n ? "" : t && !n ? Y(t).format("DD/MM/YYYY") + " - ..." : !t && n ? "... - " + Y(n).format("DD/MM/YYYY") : Y(t).format("DD/MM/YYYY") + " - " + Y(n).format("DD/MM/YYYY");
};
function xa({ value: e, onChange: t, label: n, placeholder: r = "Seleccionar rango", minDate: i, maxDate: a, presets: o, error: s, disabled: c = !1, clearable: l = !0 }) {
	let [u, d] = J(!1), f = (e) => {
		t(e), e[0] && e[1] && d(!1);
	}, p = (e) => {
		t(e.getValue()), d(!1);
	}, m = (e) => {
		e.stopPropagation(), t([null, null]);
	}, h = ba(e), g = e[0] || e[1];
	return /* @__PURE__ */ U(Ie, {
		opened: u,
		onChange: d,
		position: "bottom-start",
		width: "auto",
		shadow: "md",
		children: [/* @__PURE__ */ H(Ie.Target, { children: /* @__PURE__ */ H(Be, {
			value: h,
			label: n,
			placeholder: r,
			error: s,
			disabled: c,
			readOnly: !0,
			onClick: () => !c && d((e) => !e),
			leftSection: /* @__PURE__ */ H(tt, { size: 16 }),
			rightSection: l && g && !c ? /* @__PURE__ */ H(k, {
				size: "sm",
				variant: "subtle",
				color: "gray",
				onClick: m,
				"aria-label": "Clear date range",
				children: /* @__PURE__ */ H(V, { size: 14 })
			}) : null,
			styles: { input: { cursor: c ? "not-allowed" : "pointer" } },
			"data-testid": "date-range-picker-input"
		}) }), /* @__PURE__ */ H(Ie.Dropdown, { children: /* @__PURE__ */ U(I, {
			gap: "md",
			children: [o && o.length > 0 && /* @__PURE__ */ H(P, {
				gap: "xs",
				"data-testid": "date-range-presets",
				children: o.map((e, t) => /* @__PURE__ */ H(M, {
					variant: "light",
					size: "xs",
					onClick: () => p(e),
					"data-testid": `date-range-preset-${t}`,
					children: e.label
				}, t))
			}), /* @__PURE__ */ H(In, {
				type: "range",
				value: [e[0] ? Y(e[0]).format("YYYY-MM-DD") : null, e[1] ? Y(e[1]).format("YYYY-MM-DD") : null],
				onChange: (e) => f([e[0] ? Y(e[0]).toDate() : null, e[1] ? Y(e[1]).toDate() : null]),
				minDate: i,
				maxDate: a,
				locale: "es",
				numberOfColumns: 2,
				"data-testid": "date-range-calendar"
			})]
		}) })]
	});
}
//#endregion
//#region src/components/overlays/ConfirmModal/ConfirmModal.tsx
function Sa({ opened: e, onClose: t, onConfirm: n, title: r, message: i, confirmLabel: a = "Confirmar", cancelLabel: o = "Cancelar", confirmColor: s, loading: c, danger: l = !1 }) {
	let [u, d] = J(!1), f = c ?? u, p = s ?? (l ? "red" : "blue"), m = W(async () => {
		try {
			d(!0), await n();
		} finally {
			d(!1);
		}
	}, [n]);
	return G(() => {
		if (!e) return;
		let t = (e) => {
			e.key === "Enter" && !f && (e.preventDefault(), m());
		};
		return document.addEventListener("keydown", t), () => document.removeEventListener("keydown", t);
	}, [
		e,
		f,
		m
	]), /* @__PURE__ */ H(Me, {
		opened: e,
		onClose: t,
		title: r,
		centered: !0,
		closeOnClickOutside: !f,
		closeOnEscape: !f,
		withCloseButton: !f,
		"data-testid": "confirm-modal",
		children: /* @__PURE__ */ U(I, {
			gap: "lg",
			children: [typeof i == "string" ? /* @__PURE__ */ H(R, {
				size: "sm",
				"data-testid": "confirm-modal-message",
				children: i
			}) : /* @__PURE__ */ H("div", {
				"data-testid": "confirm-modal-message",
				children: i
			}), /* @__PURE__ */ U(P, {
				justify: "flex-end",
				gap: "sm",
				children: [/* @__PURE__ */ H(M, {
					variant: "default",
					onClick: t,
					disabled: f,
					"data-testid": "confirm-modal-cancel",
					children: o
				}), /* @__PURE__ */ H(M, {
					color: p,
					onClick: m,
					loading: f,
					"data-testid": "confirm-modal-confirm",
					children: a
				})]
			})]
		})
	});
}
//#endregion
//#region src/components/overlays/ImageLightbox/ImageLightbox.tsx
function Ca({ images: e, initialIndex: t = 0, opened: n, onClose: r, alt: i }) {
	let [a, o] = J(t), [s, c] = J(1);
	G(() => {
		n && (o(t), c(1));
	}, [n, t]);
	let l = e.length > 1, u = a > 0, d = a < e.length - 1, f = W(() => {
		u && (o((e) => e - 1), c(1));
	}, [u]), p = W(() => {
		d && (o((e) => e + 1), c(1));
	}, [d]), m = W(() => {
		c((e) => e === 1 ? 2 : 1);
	}, []), h = W(() => {
		c((e) => Math.min(e + .5, 3));
	}, []), g = W(() => {
		c((e) => Math.max(e - .5, 1));
	}, []);
	if (G(() => {
		if (!n) return;
		let e = (e) => {
			switch (e.key) {
				case "ArrowLeft":
					e.preventDefault(), f();
					break;
				case "ArrowRight":
					e.preventDefault(), p();
					break;
				case "Escape":
					e.preventDefault(), r();
					break;
				case "+":
				case "=":
					e.preventDefault(), h();
					break;
				case "-":
					e.preventDefault(), g();
					break;
			}
		};
		return document.addEventListener("keydown", e), () => document.removeEventListener("keydown", e);
	}, [
		n,
		f,
		p,
		r,
		h,
		g
	]), e.length === 0) return null;
	let _ = e[a], v = i || `Image ${a + 1}`;
	return /* @__PURE__ */ U(Me, {
		opened: n,
		onClose: r,
		fullScreen: !0,
		withCloseButton: !1,
		padding: 0,
		styles: {
			body: {
				height: "100%",
				display: "flex",
				flexDirection: "column",
				backgroundColor: "rgba(0, 0, 0, 0.95)"
			},
			content: { backgroundColor: "transparent" }
		},
		"data-testid": "image-lightbox",
		children: [
			/* @__PURE__ */ U(P, {
				justify: "space-between",
				p: "md",
				style: {
					position: "absolute",
					top: 0,
					left: 0,
					right: 0,
					zIndex: 10
				},
				children: [/* @__PURE__ */ H(P, {
					gap: "xs",
					children: l && /* @__PURE__ */ U(R, {
						c: "white",
						size: "sm",
						"data-testid": "lightbox-counter",
						children: [
							a + 1,
							" / ",
							e.length
						]
					})
				}), /* @__PURE__ */ U(P, {
					gap: "xs",
					children: [
						/* @__PURE__ */ H(k, {
							variant: "subtle",
							color: "gray",
							size: "lg",
							onClick: g,
							disabled: s <= 1,
							"aria-label": "Zoom out",
							"data-testid": "lightbox-zoom-out",
							children: /* @__PURE__ */ H(pn, {
								size: 20,
								color: "white"
							})
						}),
						/* @__PURE__ */ H(k, {
							variant: "subtle",
							color: "gray",
							size: "lg",
							onClick: h,
							disabled: s >= 3,
							"aria-label": "Zoom in",
							"data-testid": "lightbox-zoom-in",
							children: /* @__PURE__ */ H(fn, {
								size: 20,
								color: "white"
							})
						}),
						/* @__PURE__ */ H(k, {
							variant: "subtle",
							color: "gray",
							size: "lg",
							onClick: r,
							"aria-label": "Close lightbox",
							"data-testid": "lightbox-close",
							children: /* @__PURE__ */ H(V, {
								size: 20,
								color: "white"
							})
						})
					]
				})]
			}),
			/* @__PURE__ */ H(j, {
				style: {
					flex: 1,
					display: "flex",
					alignItems: "center",
					justifyContent: "center",
					overflow: "auto",
					cursor: s > 1 ? "grab" : "default"
				},
				onClick: (e) => {
					e.target === e.currentTarget && r();
				},
				"data-testid": "lightbox-backdrop",
				children: /* @__PURE__ */ H(Oe, {
					src: _,
					alt: v,
					fit: "contain",
					style: {
						maxHeight: "90vh",
						maxWidth: "90vw",
						transform: `scale(${s})`,
						transition: "transform 0.2s ease"
					},
					onClick: m,
					"data-testid": "lightbox-image"
				})
			}),
			l && /* @__PURE__ */ U(mn, { children: [/* @__PURE__ */ H(k, {
				variant: "subtle",
				color: "gray",
				size: "xl",
				onClick: f,
				disabled: !u,
				"aria-label": "Previous image",
				style: {
					position: "absolute",
					left: 16,
					top: "50%",
					transform: "translateY(-50%)"
				},
				"data-testid": "lightbox-prev",
				children: /* @__PURE__ */ H(at, {
					size: 32,
					color: "white"
				})
			}), /* @__PURE__ */ H(k, {
				variant: "subtle",
				color: "gray",
				size: "xl",
				onClick: p,
				disabled: !d,
				"aria-label": "Next image",
				style: {
					position: "absolute",
					right: 16,
					top: "50%",
					transform: "translateY(-50%)"
				},
				"data-testid": "lightbox-next",
				children: /* @__PURE__ */ H(ot, {
					size: 32,
					color: "white"
				})
			})] })
		]
	});
}
//#endregion
//#region src/components/navigation/LanguageSwitcher/LanguageSwitcher.tsx
var wa = [
	{
		code: "es",
		label: "Español",
		flag: "🇦🇷"
	},
	{
		code: "en",
		label: "English",
		flag: "🇺🇸"
	},
	{
		code: "pt",
		label: "Português",
		flag: "🇧🇷"
	},
	{
		code: "ru",
		label: "Русский",
		flag: "🇷🇺"
	}
];
function Ta({ languages: e, currentLanguage: t, onLanguageChange: n, variant: r = "icon", size: i = "md", showFlags: a = !0, showFlagInTrigger: o = !1, showLabels: s = !0, tooltip: c = "Change language", menuLabel: l = "Language", disabled: u = !1 }) {
	let d = e.find((e) => e.code === t), f = i === "xs" ? 14 : i === "sm" ? 16 : 20;
	return r === "icon" ? /* @__PURE__ */ U(je, {
		shadow: "md",
		width: 180,
		children: [/* @__PURE__ */ H(je.Target, { children: /* @__PURE__ */ H(We, {
			label: c,
			disabled: u,
			children: /* @__PURE__ */ H(k, {
				variant: "subtle",
				size: i,
				"aria-label": c,
				disabled: u,
				"data-testid": "language-switcher-button",
				children: o && d?.flag ? /* @__PURE__ */ H("span", {
					style: { fontSize: f },
					children: d.flag
				}) : /* @__PURE__ */ H(Nt, { size: f })
			})
		}) }), /* @__PURE__ */ U(je.Dropdown, {
			"data-testid": "language-switcher-dropdown",
			children: [/* @__PURE__ */ H(je.Label, { children: l }), e.map((e) => /* @__PURE__ */ H(je.Item, {
				onClick: () => n(e.code),
				leftSection: a && e.flag ? /* @__PURE__ */ H("span", { children: e.flag }) : void 0,
				fw: t === e.code ? 700 : 400,
				c: t === e.code ? "blue" : void 0,
				"data-testid": `language-option-${e.code}`,
				children: e.label
			}, e.code))]
		})]
	}) : r === "button-group" ? /* @__PURE__ */ H(M.Group, {
		"data-testid": "language-switcher-button-group",
		children: e.map((e) => /* @__PURE__ */ U(M, {
			variant: t === e.code ? "filled" : "default",
			size: i,
			onClick: () => n(e.code),
			disabled: u,
			"data-testid": `language-button-${e.code}`,
			children: [a && e.flag && /* @__PURE__ */ H("span", {
				style: { marginRight: s ? 4 : 0 },
				children: e.flag
			}), s && e.code.toUpperCase()]
		}, e.code))
	}) : /* @__PURE__ */ H(Re, {
		value: t,
		onChange: (e) => e && n(e),
		data: e.map((e) => ({
			value: e.code,
			label: `${a && e.flag ? e.flag + " " : ""}${e.label}`
		})),
		size: i,
		disabled: u,
		"aria-label": c,
		"data-testid": "language-switcher-select"
	});
}
//#endregion
//#region src/components/navigation/ThemeSwitcher/ThemeSwitcher.tsx
function Ea({ size: e = "lg", lightModeLabel: t = "Light mode", darkModeLabel: n = "Dark mode", ariaLabel: r = "Toggle color scheme", disabled: i = !1, testId: a = "theme-toggle" }) {
	let { setColorScheme: o } = Je(), s = qe("light", { getInitialValueInEffect: !0 }) === "dark";
	return /* @__PURE__ */ H(We, {
		label: s ? t : n,
		disabled: i,
		children: /* @__PURE__ */ H(k, {
			variant: "subtle",
			size: e,
			onClick: () => {
				o(s ? "light" : "dark");
			},
			"aria-label": r,
			disabled: i,
			"data-testid": a,
			children: H(s ? nn : Vt, { size: e === "xs" ? 14 : e === "sm" ? 16 : 20 })
		})
	});
}
//#endregion
//#region src/components/navigation/CurrencySwitcher/CurrencySwitcher.tsx
var Da = [
	{
		code: "ARS",
		label: "Peso Argentino",
		symbol: "AR$",
		flag: "🇦🇷"
	},
	{
		code: "USD",
		label: "US Dollar",
		symbol: "$",
		flag: "🇺🇸"
	},
	{
		code: "EUR",
		label: "Euro",
		symbol: "€",
		flag: "🇪🇺"
	},
	{
		code: "BRL",
		label: "Real Brasileiro",
		symbol: "R$",
		flag: "🇧🇷"
	}
];
function Oa({ currencies: e, currentCurrency: t, onCurrencyChange: n, variant: r = "icon", size: i = "md", showFlags: a = !0, showFlagInTrigger: o = !1, showLabels: s = !0, tooltip: c = "Change currency", menuLabel: l = "Currency", disabled: u = !1 }) {
	let d = e.find((e) => e.code === t), f = i === "xs" ? 14 : i === "sm" ? 16 : 20;
	return r === "icon" ? /* @__PURE__ */ U(je, {
		shadow: "md",
		width: 200,
		children: [/* @__PURE__ */ H(je.Target, { children: /* @__PURE__ */ H(We, {
			label: c,
			disabled: u,
			children: /* @__PURE__ */ H(k, {
				variant: "subtle",
				size: i,
				"aria-label": c,
				disabled: u,
				"data-testid": "currency-switcher-button",
				children: o && d?.flag ? /* @__PURE__ */ H("span", {
					style: { fontSize: f },
					children: d.flag
				}) : /* @__PURE__ */ H(bt, { size: f })
			})
		}) }), /* @__PURE__ */ U(je.Dropdown, {
			"data-testid": "currency-switcher-dropdown",
			children: [/* @__PURE__ */ H(je.Label, { children: l }), e.map((e) => /* @__PURE__ */ H(je.Item, {
				onClick: () => n(e.code),
				leftSection: a && e.flag ? /* @__PURE__ */ H("span", { children: e.flag }) : void 0,
				rightSection: /* @__PURE__ */ H("span", {
					style: { opacity: .6 },
					children: e.symbol
				}),
				fw: t === e.code ? 700 : 400,
				c: t === e.code ? "blue" : void 0,
				"data-testid": `currency-option-${e.code}`,
				children: e.label
			}, e.code))]
		})]
	}) : r === "button-group" ? /* @__PURE__ */ H(M.Group, {
		"data-testid": "currency-switcher-button-group",
		children: e.map((e) => /* @__PURE__ */ U(M, {
			variant: t === e.code ? "filled" : "default",
			size: i,
			onClick: () => n(e.code),
			disabled: u,
			"data-testid": `currency-button-${e.code}`,
			children: [a && e.flag && /* @__PURE__ */ H("span", {
				style: { marginRight: s ? 4 : 0 },
				children: e.flag
			}), s && e.code]
		}, e.code))
	}) : /* @__PURE__ */ H(Re, {
		value: t,
		onChange: (e) => e && n(e),
		data: e.map((e) => ({
			value: e.code,
			label: `${a && e.flag ? e.flag + " " : ""}${e.label} (${e.symbol})`
		})),
		size: i,
		disabled: u,
		"aria-label": c,
		"data-testid": "currency-switcher-select"
	});
}
//#endregion
//#region src/components/layout/Header/HeaderLayout.tsx
var ka = bn(null);
function Aa() {
	let e = Cn(ka);
	if (!e) throw Error("useHeaderLayout must be used within a HeaderLayout");
	return e;
}
function ja({ children: e }) {
	return /* @__PURE__ */ H(j, {
		style: { flex: "0 0 auto" },
		"data-slot": "logo",
		children: e
	});
}
function Ma({ children: e, visibleFrom: t }) {
	return /* @__PURE__ */ H(P, {
		flex: 1,
		justify: "center",
		align: "center",
		visibleFrom: t,
		"data-slot": "center",
		children: e
	});
}
function Na({ children: e, gap: t = "sm" }) {
	return /* @__PURE__ */ H(P, {
		gap: t,
		align: "center",
		wrap: "nowrap",
		"data-slot": "actions",
		children: e
	});
}
function Pa({ children: e, height: t = 70, px: n = "md", testId: r }) {
	return /* @__PURE__ */ H(ka.Provider, {
		value: { height: t },
		children: /* @__PURE__ */ H(P, {
			h: t,
			px: n,
			justify: "space-between",
			align: "center",
			wrap: "nowrap",
			"data-testid": r,
			children: e
		})
	});
}
var Fa = Pa;
Fa.Logo = ja, Fa.Center = Ma, Fa.Actions = Na;
//#endregion
//#region src/components/layout/Header/HeaderDivider.tsx
function Ia({ visibleFrom: e, color: t, height: n = 36, testId: r }) {
	return /* @__PURE__ */ H(j, {
		visibleFrom: e,
		display: "flex",
		style: { alignItems: "center" },
		"data-testid": r,
		children: /* @__PURE__ */ H(we, {
			orientation: "vertical",
			h: n,
			color: t
		})
	});
}
//#endregion
//#region src/components/layout/Header/HeaderNavButton.tsx
function La({ icon: e, label: t, to: n, href: r, onClick: i, external: a = !1, badge: o, badgeColor: s, size: c = "lg", variant: l = "subtle", color: u, disabled: d = !1, visibleFrom: f, testId: p }) {
	let m = {
		variant: l,
		size: c,
		color: u,
		disabled: d,
		"aria-label": t,
		"data-testid": p
	}, h = /* @__PURE__ */ H(e, {
		size: 20,
		stroke: 1.5
	}), g;
	g = n ? /* @__PURE__ */ H(We, {
		label: t,
		children: /* @__PURE__ */ H(k, {
			component: Ln,
			to: n,
			...m,
			children: h
		})
	}) : r ? /* @__PURE__ */ H(We, {
		label: t,
		children: /* @__PURE__ */ H(k, {
			component: "a",
			href: r,
			...a && {
				target: "_blank",
				rel: "noopener noreferrer"
			},
			...m,
			children: h
		})
	}) : /* @__PURE__ */ H(We, {
		label: t,
		children: /* @__PURE__ */ H(k, {
			onClick: i,
			...m,
			children: h
		})
	});
	let _ = o !== void 0 && o !== 0 && o !== "0" ? /* @__PURE__ */ H(ke, {
		label: o,
		size: 16,
		offset: 4,
		color: s,
		children: g
	}) : g;
	return f ? /* @__PURE__ */ H(j, {
		visibleFrom: f,
		"data-testid": p ? `${p}-wrapper` : void 0,
		children: _
	}) : _;
}
//#endregion
//#region src/components/layout/Header/HeaderPreferences.tsx
function Ra({ languages: e = wa, currentLanguage: t, onLanguageChange: n, currencies: r = Da, currentCurrency: i, onCurrencyChange: a, showTheme: o = !0, showLanguage: s = !0, showCurrency: c = !0, size: l = "lg", themeLabels: u, languageTooltip: d, currencyTooltip: f, testId: p }) {
	return !o && !s && !c ? null : /* @__PURE__ */ U(P, {
		gap: "xs",
		"data-testid": p,
		children: [
			o && /* @__PURE__ */ H(Ea, {
				size: l,
				lightModeLabel: u?.light,
				darkModeLabel: u?.dark,
				testId: p ? `${p}-theme` : void 0
			}),
			s && /* @__PURE__ */ H(Ta, {
				languages: e,
				currentLanguage: t,
				onLanguageChange: n,
				variant: "icon",
				size: l,
				tooltip: d,
				menuLabel: d
			}),
			c && /* @__PURE__ */ H(Oa, {
				currencies: r,
				currentCurrency: i,
				onCurrencyChange: a,
				variant: "icon",
				size: l,
				tooltip: f,
				menuLabel: f
			})
		]
	});
}
//#endregion
//#region src/components/layout/Header/HeaderUserSection.tsx
function za({ user: e, profileHref: t = "/profile", openProfileInNewTab: n = !1, onLogout: r, isLoggingOut: i, showNameOnDesktop: a = !0, size: o = "sm", profileTooltip: s = "Profile", logoutTooltip: c = "Logout", logoutConfirmTitle: l = "Confirm Logout", logoutConfirmMessage: u = "Are you sure you want to logout?", cancelLabel: d = "Cancel", confirmLabel: f = "Logout", testId: p }) {
	let [m, { open: h, close: g }] = kn(!1), [_, v] = J(!1), y = e?.name || e?.email?.split("@")[0] || "", b = W(async () => {
		v(!0);
		try {
			await r(), g();
		} catch {} finally {
			v(!1);
		}
	}, [r, g]), x = i ?? _;
	if (!e) return null;
	let S = /* @__PURE__ */ U(P, {
		gap: "xs",
		wrap: "nowrap",
		children: [/* @__PURE__ */ H(Rn, {
			name: y,
			src: e.avatarUrl,
			size: o
		}), a && /* @__PURE__ */ H(R, {
			size: "sm",
			fw: 500,
			visibleFrom: "sm",
			children: y
		})]
	});
	return /* @__PURE__ */ U(mn, { children: [/* @__PURE__ */ U(P, {
		gap: "xs",
		"data-testid": p,
		children: [/* @__PURE__ */ H(We, {
			label: s,
			children: n ? /* @__PURE__ */ H(Ge, {
				component: "a",
				href: t,
				target: "_blank",
				rel: "noopener noreferrer",
				"data-testid": p ? `${p}-profile` : void 0,
				children: S
			}) : /* @__PURE__ */ H(Ge, {
				component: Ln,
				to: t,
				"data-testid": p ? `${p}-profile` : void 0,
				children: S
			})
		}), /* @__PURE__ */ H(We, {
			label: c,
			children: /* @__PURE__ */ H(k, {
				variant: "subtle",
				size: "lg",
				color: "red",
				onClick: h,
				"aria-label": c,
				"data-testid": p ? `${p}-logout` : void 0,
				children: /* @__PURE__ */ H(It, {
					size: 20,
					stroke: 1.5
				})
			})
		})]
	}), /* @__PURE__ */ H(Me, {
		opened: m,
		onClose: g,
		title: l,
		centered: !0,
		size: "sm",
		children: /* @__PURE__ */ U(I, {
			gap: "md",
			children: [/* @__PURE__ */ H(R, {
				size: "sm",
				children: u
			}), /* @__PURE__ */ U(P, {
				justify: "flex-end",
				gap: "sm",
				children: [/* @__PURE__ */ H(M, {
					variant: "default",
					onClick: g,
					disabled: x,
					children: d
				}), /* @__PURE__ */ H(M, {
					color: "red",
					onClick: b,
					loading: x,
					children: f
				})]
			})]
		})
	})] });
}
//#endregion
//#region src/components/layout/Header/MessagesHeaderButton.tsx
function Ba({ unreadCount: e, to: t, href: n, onClick: r, label: i = "Messages", testId: a = "messages-btn" }) {
	return /* @__PURE__ */ H(La, {
		icon: Rt,
		label: i,
		to: t,
		href: n,
		onClick: r,
		external: !!n,
		badge: e,
		badgeColor: "#228be6",
		testId: a
	});
}
var Va = { card: "_card_1s6ng_2" }, Ha = 220, Ua = {
	addToCart: "Agregar al carrito",
	goToStore: "Ir a la tienda",
	outOfStock: "Sin stock"
}, Wa = "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 100 100'%3E%3Ctext font-size='40' text-anchor='middle' dominant-baseline='central' x='50' y='50'%3E📦%3C/text%3E%3C/svg%3E";
function Ga({ product: e, variant: t = "storefront", onAction: n, onClick: r, wishlistSlot: i, showMerchantInfo: a = !0, showCategory: o = !0, stockDisplayMode: s = "status", imageHeight: c = Ha, labels: l, "data-testid": u = "product-card", displayCurrency: d, exchangeRate: f }) {
	let p = {
		...Ua,
		...l
	}, m = t === "marketplace", h = e.images[0]?.url || Wa, g = e.gpc_brick_name ? e.brandName ? `${e.brandName} - ${e.gpc_brick_name}` : e.gpc_brick_name : [e.brandName, e.categoryName].filter(Boolean).join(" - "), _ = () => {
		r && r(e);
	}, v = (t) => {
		t.stopPropagation(), n && n(e);
	}, y = m ? {
		label: p.goToStore,
		icon: /* @__PURE__ */ H(et, { size: 16 }),
		color: "blue"
	} : {
		label: p.addToCart,
		icon: /* @__PURE__ */ H(tn, { size: 16 }),
		color: "blue"
	};
	return /* @__PURE__ */ U(N, {
		shadow: "sm",
		padding: "lg",
		radius: "md",
		withBorder: !0,
		h: "100%",
		className: Va.card,
		style: {
			display: "flex",
			flexDirection: "column",
			cursor: r ? "pointer" : void 0
		},
		onClick: _,
		"data-testid": u,
		children: [
			/* @__PURE__ */ U(N.Section, {
				pos: "relative",
				children: [/* @__PURE__ */ H(Oe, {
					src: h,
					height: c,
					alt: e.name,
					fallbackSrc: Wa,
					"data-testid": "product-card-image"
				}), i && /* @__PURE__ */ H(j, {
					pos: "absolute",
					top: 8,
					right: 8,
					onClick: (e) => e.stopPropagation(),
					"data-testid": "product-card-wishlist-slot",
					children: i
				})]
			}),
			/* @__PURE__ */ U(I, {
				gap: "xs",
				style: { flex: 1 },
				mt: "md",
				children: [
					/* @__PURE__ */ H(R, {
						fw: 500,
						lineClamp: 2,
						"data-testid": "product-card-name",
						children: e.name
					}),
					o && g && /* @__PURE__ */ H(R, {
						size: "sm",
						c: "dimmed",
						lineClamp: 1,
						"data-testid": "product-card-category",
						children: g
					}),
					/* @__PURE__ */ U(I, {
						gap: 4,
						mt: "auto",
						children: [/* @__PURE__ */ H(Ti, {
							price: e.price,
							compareAtPrice: e.compareAtPrice,
							currency: e.currency,
							layout: "vertical",
							size: "md",
							"data-testid": "product-card-price",
							displayCurrency: d,
							exchangeRate: f ?? void 0
						}), /* @__PURE__ */ H(Mi, {
							status: e.stockStatus,
							displayMode: s,
							quantity: e.stockQuantity,
							variant: "text",
							size: "xs"
						})]
					}),
					m && a && e.merchantName && /* @__PURE__ */ U(P, {
						gap: "xs",
						mt: "xs",
						"data-testid": "product-card-merchant",
						children: [/* @__PURE__ */ H(R, {
							size: "sm",
							c: "blue",
							children: e.merchantName
						}), e.merchantLocation && /* @__PURE__ */ H(R, {
							size: "xs",
							c: "dimmed",
							children: e.merchantLocation
						})]
					})
				]
			}),
			/* @__PURE__ */ H(M, {
				fullWidth: !0,
				mt: "md",
				radius: "md",
				color: y.color,
				disabled: e.stockStatus === "out_of_stock" && t === "storefront",
				leftSection: y.icon,
				onClick: v,
				"data-testid": "product-card-cta",
				children: e.stockStatus === "out_of_stock" && t === "storefront" ? p.outOfStock : y.label
			})
		]
	});
}
//#endregion
//#region src/components/commerce/WishlistButton/WishlistButton.tsx
var Ka = {
	sm: {
		button: "sm",
		icon: 16
	},
	md: {
		button: "md",
		icon: 20
	},
	lg: {
		button: "lg",
		icon: 24
	}
}, qa = {
	add: "Agregar a favoritos",
	remove: "Quitar de favoritos"
};
function Ja({ productId: e, isInWishlist: t, isLoading: n = !1, size: r = "md", onToggle: i, labels: a, "data-testid": o = "wishlist-button" }) {
	let [s, c] = J(!1), l = q(null);
	G(() => () => {
		l.current && clearTimeout(l.current);
	}, []);
	let u = {
		...qa,
		...a
	}, d = Ka[r], f = t ? u.remove : u.add, p = W((n) => {
		n.preventDefault(), n.stopPropagation(), t || (c(!0), l.current && clearTimeout(l.current), l.current = setTimeout(() => c(!1), 300)), i(e);
	}, [
		t,
		i,
		e
	]);
	return /* @__PURE__ */ H(We, {
		label: f,
		withArrow: !0,
		position: "top",
		children: /* @__PURE__ */ H(k, {
			variant: t ? "filled" : "default",
			color: t ? "red" : "gray",
			size: d.button,
			radius: "xl",
			onClick: p,
			loading: n,
			"aria-label": f,
			className: s ? "heart-beat" : void 0,
			"data-testid": o,
			"data-in-wishlist": t,
			"data-size": r,
			children: t ? /* @__PURE__ */ H(kt, {
				size: d.icon,
				"data-testid": `${o}-heart-filled`
			}) : /* @__PURE__ */ H(Ot, {
				size: d.icon,
				"data-testid": `${o}-heart-outline`
			})
		})
	});
}
//#endregion
//#region src/components/commerce/MultiCartDrawer/MerchantCartCard.tsx
var Ya = 3, Xa = {
	viewCart: "Ver carrito",
	checkout: "Pagar",
	unavailable: "No disponible",
	items: "productos"
};
function Za({ merchant: e, onViewCart: t, onCheckout: n, formatPrice: r, labels: i, "data-testid": a = "merchant-cart-card" }) {
	let o = {
		...Xa,
		...i
	}, s = (e, t) => r ? r(e, t) : `${t} ${e.toLocaleString("es-AR", {
		minimumFractionDigits: 2,
		maximumFractionDigits: 2
	})}`, c = e.status === "unavailable";
	return /* @__PURE__ */ U(N, {
		withBorder: !0,
		p: "md",
		radius: "md",
		opacity: c ? .6 : 1,
		"data-testid": a,
		children: [
			/* @__PURE__ */ U(P, {
				justify: "space-between",
				mb: "sm",
				children: [/* @__PURE__ */ U(P, {
					gap: "sm",
					children: [/* @__PURE__ */ H(he, {
						src: e.merchantLogo,
						alt: e.merchantName,
						radius: "sm",
						size: "md",
						"data-testid": "merchant-cart-card-logo",
						children: e.merchantName.charAt(0).toUpperCase()
					}), /* @__PURE__ */ U(I, {
						gap: 0,
						children: [/* @__PURE__ */ H(R, {
							fw: 500,
							size: "sm",
							"data-testid": "merchant-cart-card-name",
							children: e.merchantName
						}), /* @__PURE__ */ U(R, {
							size: "xs",
							c: "dimmed",
							"data-testid": "merchant-cart-card-items",
							children: [
								e.itemCount,
								" ",
								o.items
							]
						})]
					})]
				}), c && /* @__PURE__ */ H(A, {
					color: "red",
					variant: "light",
					"data-testid": "merchant-cart-card-unavailable",
					children: o.unavailable
				})]
			}),
			!c && e.items && e.items.length > 0 && /* @__PURE__ */ U(I, {
				gap: 4,
				"data-testid": "merchant-cart-card-items-list",
				children: [e.items.slice(0, Ya).map((e) => /* @__PURE__ */ U(P, {
					gap: "xs",
					wrap: "nowrap",
					children: [
						/* @__PURE__ */ H(he, {
							src: e.imageUrl,
							alt: e.productName,
							size: "sm",
							radius: "sm",
							children: e.productName.charAt(0).toUpperCase()
						}),
						/* @__PURE__ */ H(R, {
							size: "xs",
							lineClamp: 1,
							style: { flex: 1 },
							children: e.productName
						}),
						/* @__PURE__ */ U(R, {
							size: "xs",
							c: "dimmed",
							style: { whiteSpace: "nowrap" },
							children: [
								e.quantity,
								" × ",
								s(e.unitPrice, e.currency)
							]
						})
					]
				}, e.productGuid)), e.items.length > Ya && /* @__PURE__ */ U(R, {
					size: "xs",
					c: "dimmed",
					ta: "center",
					"data-testid": "merchant-cart-card-more-items",
					children: [
						"+",
						e.items.length - Ya,
						" more"
					]
				})]
			}),
			/* @__PURE__ */ U(P, {
				justify: "space-between",
				mt: "md",
				children: [/* @__PURE__ */ H(R, {
					fw: 600,
					size: "md",
					"data-testid": "merchant-cart-card-subtotal",
					children: s(e.subtotal, e.currency)
				}), /* @__PURE__ */ U(P, {
					gap: "xs",
					children: [/* @__PURE__ */ H(M, {
						variant: "light",
						size: "xs",
						leftSection: /* @__PURE__ */ H(tn, { size: 14 }),
						onClick: () => {
							t && t(e);
						},
						disabled: c,
						"data-testid": "merchant-cart-card-view-btn",
						children: o.viewCart
					}), /* @__PURE__ */ H(M, {
						size: "xs",
						leftSection: /* @__PURE__ */ H(vt, { size: 14 }),
						onClick: () => {
							n && n(e);
						},
						disabled: c,
						"data-testid": "merchant-cart-card-checkout-btn",
						children: o.checkout
					})]
				})]
			})
		]
	});
}
//#endregion
//#region src/components/commerce/MultiCartDrawer/EmptyCartState.tsx
var Qa = {
	title: "Tus carritos estan vacios",
	description: "Explora tiendas y agrega productos a tu carrito",
	browseStores: "Explorar tiendas"
};
function $a({ onBrowseStores: e, labels: t, "data-testid": n = "empty-cart-state" }) {
	let r = {
		...Qa,
		...t
	};
	return /* @__PURE__ */ H(_e, {
		h: "100%",
		py: "xl",
		"data-testid": n,
		children: /* @__PURE__ */ U(I, {
			align: "center",
			gap: "md",
			children: [
				/* @__PURE__ */ H(Ve, {
					size: 64,
					variant: "light",
					color: "gray",
					radius: "xl",
					"data-testid": "empty-cart-state-icon",
					children: /* @__PURE__ */ H(tn, { size: 32 })
				}),
				/* @__PURE__ */ H(R, {
					size: "lg",
					fw: 500,
					c: "dimmed",
					ta: "center",
					"data-testid": "empty-cart-state-title",
					children: r.title
				}),
				/* @__PURE__ */ H(R, {
					size: "sm",
					c: "dimmed",
					ta: "center",
					"data-testid": "empty-cart-state-description",
					children: r.description
				}),
				e && /* @__PURE__ */ H(M, {
					variant: "filled",
					onClick: e,
					"data-testid": "empty-cart-state-action",
					children: r.browseStores
				})
			]
		})
	});
}
//#endregion
//#region src/components/commerce/MultiCartDrawer/MultiCartDrawer.tsx
var eo = {
	title: "Mis carritos",
	itemsAcrossStores: "productos en {stores} tiendas",
	total: "Total",
	errorTitle: "Error",
	errorMessage: "No se pudieron cargar los carritos",
	viewAll: "Ver todos los carritos"
};
function to() {
	return /* @__PURE__ */ U(I, {
		gap: "md",
		"data-testid": "multi-cart-drawer-loading",
		children: [
			/* @__PURE__ */ H(F, {
				height: 100,
				radius: "md"
			}),
			/* @__PURE__ */ H(F, {
				height: 100,
				radius: "md"
			}),
			/* @__PURE__ */ H(F, {
				height: 100,
				radius: "md"
			})
		]
	});
}
function no({ labels: e }) {
	return /* @__PURE__ */ H(pe, {
		icon: /* @__PURE__ */ H(Ye, { size: 16 }),
		color: "red",
		title: e.errorTitle,
		"data-testid": "multi-cart-drawer-error",
		children: e.errorMessage
	});
}
function ro({ totalItems: e, totalAmount: t, currency: n, storeCount: r, labels: i, formatPrice: a, onViewAll: o }) {
	let s = i.itemsAcrossStores.replace("{stores}", String(r)), c = a ? a(t, n) : `${n} ${t.toLocaleString("es-AR", {
		minimumFractionDigits: 2,
		maximumFractionDigits: 2
	})}`;
	return /* @__PURE__ */ U(I, {
		gap: "xs",
		"data-testid": "multi-cart-drawer-footer",
		children: [
			/* @__PURE__ */ H(we, {}),
			/* @__PURE__ */ U(P, {
				justify: "space-between",
				py: "xs",
				children: [/* @__PURE__ */ U(R, {
					size: "sm",
					c: "dimmed",
					"data-testid": "multi-cart-drawer-summary",
					children: [
						e,
						" ",
						s
					]
				}), /* @__PURE__ */ U(R, {
					size: "lg",
					fw: 700,
					"data-testid": "multi-cart-drawer-total",
					children: [
						i.total,
						": ",
						c
					]
				})]
			}),
			o && /* @__PURE__ */ H(M, {
				variant: "subtle",
				fullWidth: !0,
				rightSection: /* @__PURE__ */ H(Qe, { size: 16 }),
				onClick: o,
				"data-testid": "multi-cart-drawer-view-all",
				children: i.viewAll
			})
		]
	});
}
function io({ open: e, onClose: t, carts: n, isLoading: r = !1, error: i = null, totalItems: a, totalAmount: o, currency: s = "ARS", onViewCart: c, onCheckout: l, onBrowseStores: u, onViewAll: d, formatPrice: f, labels: p, cardLabels: m, emptyLabels: h, "data-testid": g = "multi-cart-drawer" }) {
	let _ = {
		...eo,
		...p
	}, v = (e) => {
		c ? c(e) : window.open(e.cartUrl, "_blank");
	}, y = (e) => {
		l ? l(e) : window.open(e.checkoutUrl, "_blank");
	}, b = () => {
		u ? u() : (t(), window.location.href = "/merchants");
	}, x = () => {
		d && (t(), d());
	}, S = a ?? n.reduce((e, t) => e + t.itemCount, 0), C = o ?? n.reduce((e, t) => e + t.convertedSubtotal, 0);
	return /* @__PURE__ */ H(Te, {
		opened: e,
		onClose: t,
		title: _.title,
		position: "right",
		size: "md",
		padding: "md",
		"data-testid": g,
		children: r ? /* @__PURE__ */ H(to, {}) : i ? /* @__PURE__ */ H(no, { labels: _ }) : n.length === 0 ? /* @__PURE__ */ H($a, {
			onBrowseStores: b,
			labels: h
		}) : /* @__PURE__ */ U(I, {
			h: "100%",
			gap: 0,
			children: [/* @__PURE__ */ H(Le, {
				flex: 1,
				offsetScrollbars: !0,
				"data-testid": "multi-cart-drawer-scroll",
				children: /* @__PURE__ */ H(I, {
					gap: "md",
					children: n.map((e) => /* @__PURE__ */ H(Za, {
						merchant: e,
						onViewCart: v,
						onCheckout: y,
						formatPrice: f,
						labels: m
					}, e.merchantGuid))
				})
			}), C > 0 && /* @__PURE__ */ H(ro, {
				totalItems: S,
				totalAmount: C,
				currency: s,
				storeCount: n.length,
				labels: _,
				formatPrice: f,
				onViewAll: d ? x : void 0
			})]
		})
	});
}
//#endregion
//#region src/components/commerce/FavoritesDrawer/FavoritesDrawerItem.tsx
var ao = "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 100 100'%3E%3Ctext font-size='40' text-anchor='middle' dominant-baseline='central' x='50' y='50'%3E📦%3C/text%3E%3C/svg%3E";
function oo({ image: e, name: t, subtitle: n, price: r, currency: i, productUrl: a, onRemove: o, onAddToCart: s, isLoading: c = !1, testId: l = "favorites-drawer-item", displayCurrency: u, exchangeRate: d }) {
	let f = () => {
		window.location.href = a;
	};
	return /* @__PURE__ */ U(P, {
		gap: "md",
		wrap: "nowrap",
		align: "flex-start",
		className: "favorites-drawer-item",
		"data-testid": l,
		children: [/* @__PURE__ */ H(Ge, {
			onClick: f,
			"data-testid": `${l}-link`,
			children: /* @__PURE__ */ H(Oe, {
				src: S(e, "thumb"),
				alt: t,
				w: 60,
				h: 60,
				radius: "sm",
				fallbackSrc: ao,
				"data-testid": `${l}-image`
			})
		}), /* @__PURE__ */ U(I, {
			gap: 4,
			style: {
				flex: 1,
				minWidth: 0
			},
			children: [
				/* @__PURE__ */ H(Ge, {
					onClick: f,
					className: "favorites-drawer-item__name-link",
					children: /* @__PURE__ */ H(R, {
						fw: 500,
						lineClamp: 1,
						size: "sm",
						"data-testid": `${l}-name`,
						children: t
					})
				}),
				n && /* @__PURE__ */ H(R, {
					size: "xs",
					c: "dimmed",
					lineClamp: 1,
					"data-testid": `${l}-subtitle`,
					children: n
				}),
				/* @__PURE__ */ U(P, {
					justify: "space-between",
					mt: 4,
					children: [/* @__PURE__ */ H(Ti, {
						price: r,
						currency: i,
						displayCurrency: u,
						exchangeRate: d,
						size: "sm",
						showOriginalPrice: u != null && u !== i,
						showDiscountBadge: !1,
						"data-testid": `${l}-price`
					}), /* @__PURE__ */ U(P, {
						gap: "xs",
						children: [s && /* @__PURE__ */ H(k, {
							variant: "subtle",
							color: "blue",
							size: "sm",
							onClick: s,
							disabled: c,
							"aria-label": "Add to cart",
							"data-testid": `${l}-add-to-cart`,
							children: /* @__PURE__ */ H(tn, { size: 16 })
						}), /* @__PURE__ */ H(k, {
							variant: "subtle",
							color: "red",
							size: "sm",
							onClick: o,
							disabled: c,
							"aria-label": "Remove from favorites",
							"data-testid": `${l}-remove`,
							children: /* @__PURE__ */ H(an, { size: 16 })
						})]
					})]
				})
			]
		})]
	});
}
//#endregion
//#region src/components/commerce/MerchantCard/MerchantCardLayout.tsx
function so(e) {
	let t = e || "#228be6";
	return `linear-gradient(135deg, ${t}, ${t}99)`;
}
function co({ businessName: e, merchantType: t, description: n, address: r, businessHours: i, isOpen: a, bannerUrl: o, logoUrl: s, primaryColor: c, ratingSlot: l, actionsSlot: u, footerSlot: d, compact: f, onCoverClick: p, merchantTypeLabel: m, openLabel: h, closedLabel: g, statusSlot: _ }) {
	return /* @__PURE__ */ U(N, {
		shadow: "sm",
		padding: "lg",
		radius: "md",
		withBorder: !0,
		h: "100%",
		style: {
			display: "flex",
			flexDirection: "column",
			background: "var(--mantine-color-body)"
		},
		children: [/* @__PURE__ */ U(N.Section, {
			pos: "relative",
			children: [
				o ? /* @__PURE__ */ H(Oe, {
					src: o,
					height: 120,
					alt: e,
					fallbackSrc: void 0,
					style: {
						cursor: p ? "pointer" : void 0,
						objectFit: "cover"
					},
					onClick: p
				}) : /* @__PURE__ */ H(j, {
					h: 120,
					style: {
						background: so(c),
						cursor: p ? "pointer" : void 0
					},
					onClick: p
				}),
				u && /* @__PURE__ */ H(P, {
					gap: "xs",
					style: {
						position: "absolute",
						top: 8,
						right: 8
					},
					children: u
				}),
				/* @__PURE__ */ H(he, {
					src: s,
					alt: e,
					size: 48,
					radius: "xl",
					style: {
						position: "absolute",
						bottom: -24,
						left: 12,
						border: "3px solid var(--mantine-color-body)"
					},
					children: e.charAt(0).toUpperCase()
				})
			]
		}), /* @__PURE__ */ U("div", {
			style: {
				flex: 1,
				display: "flex",
				flexDirection: "column",
				paddingTop: 28
			},
			children: [
				/* @__PURE__ */ U(P, {
					justify: "space-between",
					mb: "xs",
					wrap: "nowrap",
					children: [/* @__PURE__ */ H(R, {
						fw: 600,
						size: "lg",
						lineClamp: 1,
						style: { flex: 1 },
						children: e
					}), /* @__PURE__ */ U(P, {
						gap: 4,
						wrap: "nowrap",
						children: [
							/* @__PURE__ */ H(A, {
								variant: "light",
								size: "sm",
								children: m || t
							}),
							_,
							a != null && /* @__PURE__ */ H(A, {
								color: a ? "green" : "red",
								variant: "filled",
								size: "xs",
								children: a ? h || "Open" : g || "Closed"
							})
						]
					})]
				}),
				n && /* @__PURE__ */ H(R, {
					size: "sm",
					c: "dimmed",
					lineClamp: 2,
					mb: "xs",
					children: n
				}),
				/* @__PURE__ */ U(I, {
					gap: "xs",
					mb: "md",
					children: [
						l,
						r && /* @__PURE__ */ U(P, {
							gap: 4,
							children: [/* @__PURE__ */ H(Lt, { size: 14 }), /* @__PURE__ */ H(R, {
								size: "sm",
								c: "dimmed",
								lineClamp: 1,
								children: r
							})]
						}),
						i && i.length > 0 && /* @__PURE__ */ H(I, {
							gap: 2,
							children: i.map((e, t) => /* @__PURE__ */ U(P, {
								gap: 4,
								wrap: "nowrap",
								children: [t === 0 ? /* @__PURE__ */ H(B, {
									size: 14,
									style: { flexShrink: 0 }
								}) : /* @__PURE__ */ H(j, {
									w: 14,
									style: { flexShrink: 0 }
								}), /* @__PURE__ */ H(R, {
									size: "sm",
									c: "dimmed",
									children: e
								})]
							}, t))
						})
					]
				}),
				!f && d && /* @__PURE__ */ H("div", {
					style: { marginTop: "auto" },
					children: d
				})
			]
		})]
	});
}
//#endregion
//#region src/components/commerce/MerchantCard/MerchantCardSkeleton.tsx
function lo() {
	return /* @__PURE__ */ U(N, {
		shadow: "sm",
		padding: "lg",
		radius: "md",
		withBorder: !0,
		children: [
			/* @__PURE__ */ H(N.Section, { children: /* @__PURE__ */ H(F, { height: 120 }) }),
			/* @__PURE__ */ U(P, {
				mt: 30,
				mb: "xs",
				children: [/* @__PURE__ */ H(F, {
					height: 48,
					width: 48,
					circle: !0
				}), /* @__PURE__ */ U(I, {
					gap: 4,
					style: { flex: 1 },
					children: [/* @__PURE__ */ H(F, {
						height: 18,
						width: "70%"
					}), /* @__PURE__ */ H(F, {
						height: 14,
						width: "40%"
					})]
				})]
			}),
			/* @__PURE__ */ H(F, {
				height: 14,
				mt: 6
			}),
			/* @__PURE__ */ H(F, {
				height: 14,
				mt: 6,
				width: "60%"
			}),
			/* @__PURE__ */ H(P, {
				justify: "flex-end",
				mt: "md",
				children: /* @__PURE__ */ H(F, {
					height: 36,
					width: 120
				})
			})
		]
	});
}
//#endregion
//#region src/components/chat/MessageStatus.tsx
var uo = 14;
function fo({ status: e, onRetry: t, size: n = uo }) {
	switch (e) {
		case "sending": return /* @__PURE__ */ H(Ae, {
			size: n,
			type: "dots"
		});
		case "sent": return /* @__PURE__ */ H(z, {
			size: n,
			style: { color: "var(--mantine-color-dimmed)" }
		});
		case "read": return /* @__PURE__ */ H(nt, {
			size: n,
			style: { color: "var(--mantine-color-blue-filled)" }
		});
		case "failed": return t ? /* @__PURE__ */ H(k, {
			variant: "transparent",
			size: n + 4,
			color: "red",
			onClick: t,
			"aria-label": "Retry",
			children: /* @__PURE__ */ H(Ye, { size: n })
		}) : /* @__PURE__ */ H(Ye, {
			size: n,
			style: { color: "var(--mantine-color-red-filled)" }
		});
		default: return null;
	}
}
//#endregion
//#region src/components/chat/ChatAttachmentContext.tsx
var po = bn(null);
function mo({ fetchBlob: e, children: t }) {
	return /* @__PURE__ */ H(po.Provider, {
		value: e,
		children: t
	});
}
function ho() {
	return Cn(po);
}
//#endregion
//#region src/components/chat/ImageThumbnail.tsx
function go({ attachment: e }) {
	let [t, n] = J(null), [r, i] = J(!1), [a, o] = J(!1), s = ho(), c = q(null);
	return G(() => {
		let t = !1;
		return c.current &&= (URL.revokeObjectURL(c.current), null), n(null), i(!1), o(!1), s ? s(e.url).then((e) => {
			if (!t) {
				let t = URL.createObjectURL(e);
				c.current = t, n(t);
			}
		}).catch(() => {
			t || o(!0);
		}) : n(e.url), () => {
			t = !0, c.current &&= (URL.revokeObjectURL(c.current), null);
		};
	}, [e.url, s]), a ? /* @__PURE__ */ H(j, {
		style: {
			width: 120,
			height: 80,
			display: "flex",
			alignItems: "center",
			justifyContent: "center",
			background: "var(--mantine-color-default)",
			borderRadius: "var(--mantine-radius-sm)"
		},
		children: /* @__PURE__ */ H(Wt, {
			size: 32,
			color: "var(--mantine-color-dimmed)"
		})
	}) : /* @__PURE__ */ U(j, {
		style: {
			position: "relative",
			cursor: "pointer"
		},
		children: [!r && /* @__PURE__ */ H(F, {
			width: 200,
			height: 200,
			radius: "sm"
		}), t && /* @__PURE__ */ H("img", {
			src: t,
			alt: e.filename,
			onLoad: () => i(!0),
			onError: () => o(!0),
			onClick: () => {
				t && window.open(t, "_blank");
			},
			style: {
				display: r ? "block" : "none",
				maxWidth: 300,
				maxHeight: 200,
				objectFit: "contain",
				borderRadius: "var(--mantine-radius-sm)"
			}
		})]
	});
}
//#endregion
//#region src/components/chat/AttachmentPreview.tsx
function _o(e) {
	return e < 1024 ? `${e} B` : e < 1024 * 1024 ? `${(e / 1024).toFixed(0)} KB` : `${(e / (1024 * 1024)).toFixed(1)} MB`;
}
function vo({ attachments: e, onRemove: t }) {
	let { t: n } = hn();
	return e.length === 0 ? null : /* @__PURE__ */ H(Le, {
		scrollbarSize: 4,
		type: "auto",
		style: { padding: "8px 12px 0" },
		children: /* @__PURE__ */ H(P, {
			gap: "xs",
			wrap: "nowrap",
			children: e.map((e) => /* @__PURE__ */ U(Fe, {
				p: "xs",
				radius: "sm",
				withBorder: !0,
				style: {
					position: "relative",
					minWidth: 80,
					maxWidth: 120,
					flexShrink: 0
				},
				children: [
					/* @__PURE__ */ H(k, {
						size: "xs",
						variant: "filled",
						color: "red",
						radius: "xl",
						onClick: () => t(e.id),
						"aria-label": n("messages.attachments.remove", {
							filename: e.file.name,
							defaultValue: `Remove attachment: ${e.file.name}`
						}),
						style: {
							position: "absolute",
							top: -6,
							right: -6,
							zIndex: 1
						},
						children: /* @__PURE__ */ H(V, { size: 10 })
					}),
					e.file.type.startsWith("image/") && e.preview ? /* @__PURE__ */ H(Oe, {
						src: e.preview,
						w: 64,
						h: 64,
						fit: "cover",
						radius: "sm",
						alt: e.file.name
					}) : /* @__PURE__ */ H(j, {
						style: {
							display: "flex",
							justifyContent: "center",
							padding: "8px 0"
						},
						children: /* @__PURE__ */ H(St, {
							size: 32,
							color: "var(--mantine-color-dimmed)"
						})
					}),
					/* @__PURE__ */ H(R, {
						size: "xs",
						truncate: !0,
						mt: 4,
						title: e.file.name,
						children: e.file.name
					}),
					/* @__PURE__ */ H(R, {
						size: "xs",
						c: "dimmed",
						children: _o(e.file.size)
					})
				]
			}, e.id))
		})
	});
}
//#endregion
//#region src/components/chat/AttachmentCard.tsx
var yo = 30;
function bo(e) {
	if (e.length <= yo) return e;
	let t = e.lastIndexOf(".");
	if (t > 0) {
		let n = e.slice(t);
		return `${e.slice(0, yo - n.length - 1)}\u2026${n}`;
	}
	return e.slice(0, yo) + "…";
}
function xo(e) {
	return e === "application/pdf" ? Tt : e.includes("zip") || e.includes("compressed") || e.includes("archive") ? Et : e.includes("spreadsheet") || e.includes("excel") || e === "text/csv" ? Ct : e.startsWith("text/") ? wt : St;
}
function So({ attachment: e }) {
	let { t } = hn(), n = xo(e.type), r = ho(), [i, a] = J(!1), o = W(async () => {
		if (!r) {
			window.open(e.url, "_blank");
			return;
		}
		a(!0);
		try {
			let t = await r(e.url), n = URL.createObjectURL(t), i = document.createElement("a");
			i.href = n, i.download = e.filename, document.body.appendChild(i), i.click(), document.body.removeChild(i), URL.revokeObjectURL(n);
		} catch {
			window.open(e.url, "_blank");
		} finally {
			a(!1);
		}
	}, [e, r]);
	return /* @__PURE__ */ H(Fe, {
		p: "xs",
		radius: "sm",
		withBorder: !0,
		children: /* @__PURE__ */ U(P, {
			gap: "xs",
			wrap: "nowrap",
			children: [
				/* @__PURE__ */ H(n, {
					size: 24,
					color: "var(--mantine-color-dimmed)",
					style: { flexShrink: 0 }
				}),
				/* @__PURE__ */ U("div", {
					style: {
						flex: 1,
						minWidth: 0
					},
					children: [/* @__PURE__ */ H(R, {
						size: "sm",
						truncate: !0,
						title: e.filename,
						children: bo(e.filename)
					}), /* @__PURE__ */ H(R, {
						size: "xs",
						c: "dimmed",
						children: _o(e.size)
					})]
				}),
				/* @__PURE__ */ H(k, {
					onClick: o,
					loading: i,
					variant: "subtle",
					size: "sm",
					"aria-label": t("messages.attachment.download", {
						filename: e.filename,
						defaultValue: `Download ${e.filename}`
					}),
					children: /* @__PURE__ */ H(xt, { size: 16 })
				})
			]
		})
	});
}
//#endregion
//#region src/components/chat/ContextCard.tsx
function Co(e, t, n) {
	try {
		return new Intl.NumberFormat(n, {
			style: "currency",
			currency: t,
			minimumFractionDigits: 2
		}).format(e);
	} catch {
		return `${e.toFixed(2)} ${t}`;
	}
}
function wo({ snapshot: e, locale: t, t: n }) {
	let r = e.orderNumber, i = e.orderTotal, a = e.orderCurrency || "ARS", o = e.orderStatus, s = e.orderItemCount;
	return /* @__PURE__ */ U(Ee, {
		align: "center",
		gap: "sm",
		children: [/* @__PURE__ */ H(Ht, {
			size: 28,
			stroke: 1.5,
			style: { flexShrink: 0 }
		}), /* @__PURE__ */ U(j, {
			style: { minWidth: 0 },
			children: [/* @__PURE__ */ U(R, {
				size: "sm",
				fw: 600,
				truncate: !0,
				children: [
					n("chat.context.orderTitle"),
					" ",
					r || "—"
				]
			}), /* @__PURE__ */ U(Ee, {
				align: "center",
				gap: "xs",
				wrap: "wrap",
				children: [
					i != null && /* @__PURE__ */ H(R, {
						size: "xs",
						c: "dimmed",
						children: Co(i, a, t)
					}),
					s != null && /* @__PURE__ */ U(R, {
						size: "xs",
						c: "dimmed",
						children: [
							"· ",
							s,
							" ",
							n("chat.context.items")
						]
					}),
					o && /* @__PURE__ */ H(A, {
						size: "xs",
						variant: "light",
						radius: "sm",
						children: o
					})
				]
			})]
		})]
	});
}
function To({ snapshot: e, locale: t, t: n }) {
	let r = e.productName, i = e.productImage, a = e.productPrice, o = e.productCurrency || "ARS";
	return /* @__PURE__ */ U(Ee, {
		align: "center",
		gap: "sm",
		children: [
			i ? /* @__PURE__ */ H(Oe, {
				src: i,
				w: 48,
				h: 48,
				radius: "sm",
				fit: "cover",
				style: { flexShrink: 0 },
				fallbackSrc: void 0,
				onError: (e) => {
					e.currentTarget.style.display = "none";
					let t = e.currentTarget.nextElementSibling;
					t && (t.style.display = "flex");
				}
			}) : null,
			/* @__PURE__ */ H(Ee, {
				align: "center",
				justify: "center",
				w: 48,
				h: 48,
				style: {
					flexShrink: 0,
					borderRadius: "var(--mantine-radius-sm)",
					background: "var(--mantine-color-gray-2)",
					display: i ? "none" : "flex"
				},
				children: /* @__PURE__ */ H(en, {
					size: 24,
					stroke: 1.5
				})
			}),
			/* @__PURE__ */ U(j, {
				style: { minWidth: 0 },
				children: [/* @__PURE__ */ H(R, {
					size: "sm",
					fw: 600,
					truncate: !0,
					children: r || n("chat.context.productInquiry")
				}), a != null && /* @__PURE__ */ H(R, {
					size: "xs",
					c: "dimmed",
					children: Co(a, o, t)
				})]
			})
		]
	});
}
function Eo({ type: e, snapshot: t, onClick: n, hoverContent: r, compact: i }) {
	let { t: a, i18n: o } = hn(), s = o.language, c = e === "order_context" ? /* @__PURE__ */ H(wo, {
		snapshot: t,
		locale: s,
		t: a
	}) : e === "product_context" ? /* @__PURE__ */ H(To, {
		snapshot: t,
		locale: s,
		t: a
	}) : null;
	if (!c) return null;
	if (i) return /* @__PURE__ */ H(j, {
		"data-testid": "context-card",
		style: { fontSize: "0.9em" },
		children: c
	});
	let l = /* @__PURE__ */ H(Fe, {
		radius: "md",
		px: "md",
		py: "sm",
		bg: "var(--mantine-color-default)",
		withBorder: !0,
		maw: 400,
		w: "100%",
		style: n ? { cursor: "pointer" } : void 0,
		"data-testid": "context-card",
		children: c
	}), u = n ? /* @__PURE__ */ H(Ge, {
		onClick: n,
		maw: 400,
		w: "100%",
		children: l
	}) : l;
	return /* @__PURE__ */ H(Ee, {
		justify: "center",
		my: "xs",
		"data-testid": "context-card-wrapper",
		children: r ? /* @__PURE__ */ U(De, {
			position: "top",
			withArrow: !0,
			shadow: "md",
			openDelay: 300,
			closeDelay: 100,
			children: [/* @__PURE__ */ H(De.Target, { children: u }), /* @__PURE__ */ H(De.Dropdown, { children: r })]
		}) : u
	});
}
var Do = { messageContent: "_messageContent_wy4n7_3" }, Oo = [
	"p",
	"br",
	"strong",
	"em",
	"code",
	"pre",
	"ul",
	"ol",
	"li",
	"a"
], ko = { a: ({ href: e, children: t }) => /* @__PURE__ */ H("a", {
	href: e,
	target: "_blank",
	rel: "noopener noreferrer",
	children: t
}) };
function Ao(e) {
	try {
		return new Date(e).toLocaleTimeString(void 0, {
			hour: "2-digit",
			minute: "2-digit"
		});
	} catch {
		return "";
	}
}
function jo(e) {
	try {
		let t = JSON.parse(e);
		if (t && typeof t.type == "string" && t.type.endsWith("_context") && typeof t.entityGuid == "string" && t.snapshot && typeof t.snapshot == "object") return {
			type: t.type,
			entityGuid: t.entityGuid,
			snapshot: t.snapshot
		};
	} catch {}
	return null;
}
function Mo({ message: e, isOutgoing: t, onRetry: n, getContextCardProps: r }) {
	let i = n ? () => n(e.messageId) : void 0;
	if (e.messageType === "system_notification") {
		let t = jo(e.content);
		if (t) {
			let n = r?.(t);
			return /* @__PURE__ */ U(j, {
				"data-testid": "message-bubble-system",
				children: [/* @__PURE__ */ H(Eo, {
					...t,
					onClick: n?.onClick,
					hoverContent: n?.hoverContent
				}), /* @__PURE__ */ H(R, {
					size: "xs",
					c: "dimmed",
					ta: "center",
					mt: -4,
					mb: "xs",
					children: Ao(e.createdAt)
				})]
			});
		}
		return /* @__PURE__ */ H(j, {
			"data-testid": "message-bubble-system",
			children: /* @__PURE__ */ H(R, {
				size: "xs",
				c: "dimmed",
				ta: "center",
				my: "xs",
				children: e.content
			})
		});
	}
	return /* @__PURE__ */ H(Ee, {
		justify: t ? "flex-end" : "flex-start",
		"data-testid": `message-bubble-${t ? "outgoing" : "incoming"}`,
		children: /* @__PURE__ */ U(j, {
			maw: "70%",
			px: "sm",
			py: "xs",
			style: {
				background: t ? "var(--mantine-color-blue-light)" : "var(--mantine-color-default)",
				borderRadius: "var(--mantine-radius-md) var(--mantine-radius-md) " + (t ? "0 var(--mantine-radius-md)" : "var(--mantine-radius-md) 0")
			},
			children: [
				!t && e.senderName && /* @__PURE__ */ H(R, {
					size: "xs",
					fw: 600,
					c: "dimmed",
					mb: 2,
					children: e.senderName
				}),
				/* @__PURE__ */ H(j, {
					className: Do.messageContent,
					c: t ? "var(--mantine-color-blue-light-color)" : void 0,
					children: /* @__PURE__ */ H(zn, {
						remarkPlugins: [Bn],
						allowedElements: Oo,
						unwrapDisallowed: !0,
						components: ko,
						urlTransform: (e) => e,
						children: e.content
					})
				}),
				e.attachments && e.attachments.length > 0 && /* @__PURE__ */ H(I, {
					gap: "xs",
					mt: "xs",
					children: e.attachments.map((e) => e.type.startsWith("image/") ? /* @__PURE__ */ H(go, { attachment: e }, e.url) : /* @__PURE__ */ H(So, { attachment: e }, e.url))
				}),
				/* @__PURE__ */ U(P, {
					gap: 4,
					justify: "flex-end",
					mt: 2,
					children: [/* @__PURE__ */ H(R, {
						size: "xs",
						c: "dimmed",
						children: Ao(e.createdAt)
					}), t && /* @__PURE__ */ H(fo, {
						status: e.status,
						onRetry: i
					})]
				})
			]
		})
	});
}
//#endregion
//#region src/components/chat/DateSeparator.tsx
function No(e, t) {
	return e.getFullYear() === t.getFullYear() && e.getMonth() === t.getMonth() && e.getDate() === t.getDate();
}
function Po(e, t, n) {
	let r = /* @__PURE__ */ new Date();
	if (No(e, r)) return t("messages.today");
	let i = new Date(r);
	return i.setDate(i.getDate() - 1), No(e, i) ? t("messages.yesterday") : new Intl.DateTimeFormat(n, {
		day: "numeric",
		month: "long",
		year: e.getFullYear() === r.getFullYear() ? void 0 : "numeric"
	}).format(e);
}
function Fo({ date: e }) {
	let { t, i18n: n } = hn();
	return /* @__PURE__ */ H(we, {
		my: "sm",
		label: Po(new Date(e), t, n.language),
		labelPosition: "center",
		color: "dimmed",
		"data-testid": "date-separator"
	});
}
//#endregion
//#region src/components/chat/MessageList.tsx
function Io(e) {
	let t = new Date(e);
	return `${t.getFullYear()}-${t.getMonth()}-${t.getDate()}`;
}
function Lo() {
	return typeof window > "u" ? !1 : window.matchMedia("(prefers-reduced-motion: reduce)").matches;
}
function Ro({ messages: e, currentUserGuid: t, onLoadMore: n, isLoadingMore: r, hasMore: i, onRetry: a, conversationId: o, getContextCardProps: s }) {
	let { t: c } = hn(), l = q(null), u = q(null), d = q(void 0), f = q(o), p = q(0), m = q(0), h = Lo();
	G(() => {
		o !== f.current && (d.current = void 0, p.current = 0, f.current = o);
	}, [o]), Tn(() => {
		let t = l.current;
		if (!t || e.length === 0) return;
		let n = e[e.length - 1]?.messageId, r = p.current;
		return d.current ? n && n !== d.current ? t.scrollTo({
			top: t.scrollHeight,
			behavior: h ? "instant" : "smooth"
		}) : r > 0 && t.scrollHeight > r && (t.scrollTop += t.scrollHeight - r) : (t.scrollTop = t.scrollHeight, cancelAnimationFrame(m.current), m.current = requestAnimationFrame(() => {
			t.scrollTop = t.scrollHeight;
		})), d.current = n, p.current = t.scrollHeight, () => cancelAnimationFrame(m.current);
	}, [e, h]), G(() => {
		let e = u.current, t = l.current;
		if (!e || !t || !n || !i) return;
		let a = new IntersectionObserver((e) => {
			e[0].isIntersecting && !r && n();
		}, {
			root: t,
			threshold: .1
		});
		return a.observe(e), () => a.disconnect();
	}, [
		n,
		i,
		r
	]);
	let g = W(() => {
		let n = [], r = "";
		for (let i of e) {
			let e = Io(i.createdAt);
			e !== r && (r = e, n.push(/* @__PURE__ */ H(Fo, { date: i.createdAt }, `date-${e}`))), n.push(/* @__PURE__ */ H(Mo, {
				message: i,
				isOutgoing: i.senderGuid === t,
				onRetry: a,
				getContextCardProps: s
			}, i.messageId));
		}
		return n;
	}, [
		e,
		t,
		a,
		s
	]);
	return /* @__PURE__ */ H(Le, {
		h: "100%",
		viewportRef: l,
		role: "log",
		"aria-live": "polite",
		"aria-label": c("messages.aria.message_list"),
		"data-testid": "message-list",
		children: /* @__PURE__ */ U(I, {
			gap: "xs",
			px: "md",
			py: "sm",
			children: [
				i && /* @__PURE__ */ H("div", {
					ref: u,
					style: { height: 1 }
				}),
				r && /* @__PURE__ */ H(_e, {
					py: "xs",
					children: /* @__PURE__ */ H(Ae, { size: "sm" })
				}),
				g()
			]
		})
	});
}
//#endregion
//#region ../node_modules/prop-types/node_modules/react-is/cjs/react-is.production.min.js
var zo = /* @__PURE__ */ or(((e) => {
	var t = typeof Symbol == "function" && Symbol.for, n = t ? Symbol.for("react.element") : 60103, r = t ? Symbol.for("react.portal") : 60106, i = t ? Symbol.for("react.fragment") : 60107, a = t ? Symbol.for("react.strict_mode") : 60108, o = t ? Symbol.for("react.profiler") : 60114, s = t ? Symbol.for("react.provider") : 60109, c = t ? Symbol.for("react.context") : 60110, l = t ? Symbol.for("react.async_mode") : 60111, u = t ? Symbol.for("react.concurrent_mode") : 60111, d = t ? Symbol.for("react.forward_ref") : 60112, f = t ? Symbol.for("react.suspense") : 60113, p = t ? Symbol.for("react.suspense_list") : 60120, m = t ? Symbol.for("react.memo") : 60115, h = t ? Symbol.for("react.lazy") : 60116, g = t ? Symbol.for("react.block") : 60121, _ = t ? Symbol.for("react.fundamental") : 60117, v = t ? Symbol.for("react.responder") : 60118, y = t ? Symbol.for("react.scope") : 60119;
	function b(e) {
		if (typeof e == "object" && e) {
			var t = e.$$typeof;
			switch (t) {
				case n: switch (e = e.type, e) {
					case l:
					case u:
					case i:
					case o:
					case a:
					case f: return e;
					default: switch (e &&= e.$$typeof, e) {
						case c:
						case d:
						case h:
						case m:
						case s: return e;
						default: return t;
					}
				}
				case r: return t;
			}
		}
	}
	function x(e) {
		return b(e) === u;
	}
	e.AsyncMode = l, e.ConcurrentMode = u, e.ContextConsumer = c, e.ContextProvider = s, e.Element = n, e.ForwardRef = d, e.Fragment = i, e.Lazy = h, e.Memo = m, e.Portal = r, e.Profiler = o, e.StrictMode = a, e.Suspense = f, e.isAsyncMode = function(e) {
		return x(e) || b(e) === l;
	}, e.isConcurrentMode = x, e.isContextConsumer = function(e) {
		return b(e) === c;
	}, e.isContextProvider = function(e) {
		return b(e) === s;
	}, e.isElement = function(e) {
		return typeof e == "object" && !!e && e.$$typeof === n;
	}, e.isForwardRef = function(e) {
		return b(e) === d;
	}, e.isFragment = function(e) {
		return b(e) === i;
	}, e.isLazy = function(e) {
		return b(e) === h;
	}, e.isMemo = function(e) {
		return b(e) === m;
	}, e.isPortal = function(e) {
		return b(e) === r;
	}, e.isProfiler = function(e) {
		return b(e) === o;
	}, e.isStrictMode = function(e) {
		return b(e) === a;
	}, e.isSuspense = function(e) {
		return b(e) === f;
	}, e.isValidElementType = function(e) {
		return typeof e == "string" || typeof e == "function" || e === i || e === u || e === o || e === a || e === f || e === p || typeof e == "object" && !!e && (e.$$typeof === h || e.$$typeof === m || e.$$typeof === s || e.$$typeof === c || e.$$typeof === d || e.$$typeof === _ || e.$$typeof === v || e.$$typeof === y || e.$$typeof === g);
	}, e.typeOf = b;
})), Bo = /* @__PURE__ */ or(((e) => {
	process.env.NODE_ENV !== "production" && (function() {
		var t = typeof Symbol == "function" && Symbol.for, n = t ? Symbol.for("react.element") : 60103, r = t ? Symbol.for("react.portal") : 60106, i = t ? Symbol.for("react.fragment") : 60107, a = t ? Symbol.for("react.strict_mode") : 60108, o = t ? Symbol.for("react.profiler") : 60114, s = t ? Symbol.for("react.provider") : 60109, c = t ? Symbol.for("react.context") : 60110, l = t ? Symbol.for("react.async_mode") : 60111, u = t ? Symbol.for("react.concurrent_mode") : 60111, d = t ? Symbol.for("react.forward_ref") : 60112, f = t ? Symbol.for("react.suspense") : 60113, p = t ? Symbol.for("react.suspense_list") : 60120, m = t ? Symbol.for("react.memo") : 60115, h = t ? Symbol.for("react.lazy") : 60116, g = t ? Symbol.for("react.block") : 60121, _ = t ? Symbol.for("react.fundamental") : 60117, v = t ? Symbol.for("react.responder") : 60118, y = t ? Symbol.for("react.scope") : 60119;
		function b(e) {
			return typeof e == "string" || typeof e == "function" || e === i || e === u || e === o || e === a || e === f || e === p || typeof e == "object" && !!e && (e.$$typeof === h || e.$$typeof === m || e.$$typeof === s || e.$$typeof === c || e.$$typeof === d || e.$$typeof === _ || e.$$typeof === v || e.$$typeof === y || e.$$typeof === g);
		}
		function x(e) {
			if (typeof e == "object" && e) {
				var t = e.$$typeof;
				switch (t) {
					case n:
						var p = e.type;
						switch (p) {
							case l:
							case u:
							case i:
							case o:
							case a:
							case f: return p;
							default:
								var g = p && p.$$typeof;
								switch (g) {
									case c:
									case d:
									case h:
									case m:
									case s: return g;
									default: return t;
								}
						}
					case r: return t;
				}
			}
		}
		var S = l, C = u, ee = c, w = s, te = n, ne = d, re = i, ie = h, T = m, E = r, D = o, ae = a, O = f, oe = !1;
		function se(e) {
			return oe || (oe = !0, console.warn("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 17+. Update your code to use ReactIs.isConcurrentMode() instead. It has the exact same API.")), ce(e) || x(e) === l;
		}
		function ce(e) {
			return x(e) === u;
		}
		function le(e) {
			return x(e) === c;
		}
		function ue(e) {
			return x(e) === s;
		}
		function de(e) {
			return typeof e == "object" && !!e && e.$$typeof === n;
		}
		function fe(e) {
			return x(e) === d;
		}
		function k(e) {
			return x(e) === i;
		}
		function pe(e) {
			return x(e) === h;
		}
		function me(e) {
			return x(e) === m;
		}
		function he(e) {
			return x(e) === r;
		}
		function A(e) {
			return x(e) === o;
		}
		function j(e) {
			return x(e) === a;
		}
		function ge(e) {
			return x(e) === f;
		}
		e.AsyncMode = S, e.ConcurrentMode = C, e.ContextConsumer = ee, e.ContextProvider = w, e.Element = te, e.ForwardRef = ne, e.Fragment = re, e.Lazy = ie, e.Memo = T, e.Portal = E, e.Profiler = D, e.StrictMode = ae, e.Suspense = O, e.isAsyncMode = se, e.isConcurrentMode = ce, e.isContextConsumer = le, e.isContextProvider = ue, e.isElement = de, e.isForwardRef = fe, e.isFragment = k, e.isLazy = pe, e.isMemo = me, e.isPortal = he, e.isProfiler = A, e.isStrictMode = j, e.isSuspense = ge, e.isValidElementType = b, e.typeOf = x;
	})();
})), Vo = /* @__PURE__ */ or(((e, t) => {
	process.env.NODE_ENV === "production" ? t.exports = zo() : t.exports = Bo();
})), Ho = /* @__PURE__ */ or(((e, t) => {
	var n = Object.getOwnPropertySymbols, r = Object.prototype.hasOwnProperty, i = Object.prototype.propertyIsEnumerable;
	function a(e) {
		if (e == null) throw TypeError("Object.assign cannot be called with null or undefined");
		return Object(e);
	}
	function o() {
		try {
			if (!Object.assign) return !1;
			var e = /* @__PURE__ */ new String("abc");
			if (e[5] = "de", Object.getOwnPropertyNames(e)[0] === "5") return !1;
			for (var t = {}, n = 0; n < 10; n++) t["_" + String.fromCharCode(n)] = n;
			if (Object.getOwnPropertyNames(t).map(function(e) {
				return t[e];
			}).join("") !== "0123456789") return !1;
			var r = {};
			return "abcdefghijklmnopqrst".split("").forEach(function(e) {
				r[e] = e;
			}), Object.keys(Object.assign({}, r)).join("") === "abcdefghijklmnopqrst";
		} catch {
			return !1;
		}
	}
	t.exports = o() ? Object.assign : function(e, t) {
		for (var o, s = a(e), c, l = 1; l < arguments.length; l++) {
			for (var u in o = Object(arguments[l]), o) r.call(o, u) && (s[u] = o[u]);
			if (n) {
				c = n(o);
				for (var d = 0; d < c.length; d++) i.call(o, c[d]) && (s[c[d]] = o[c[d]]);
			}
		}
		return s;
	};
})), Uo = /* @__PURE__ */ or(((e, t) => {
	t.exports = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
})), Wo = /* @__PURE__ */ or(((e, t) => {
	t.exports = Function.call.bind(Object.prototype.hasOwnProperty);
})), Go = /* @__PURE__ */ or(((e, t) => {
	var n = function() {};
	if (process.env.NODE_ENV !== "production") {
		var r = Uo(), i = {}, a = Wo();
		n = function(e) {
			var t = "Warning: " + e;
			typeof console < "u" && console.error(t);
			try {
				throw Error(t);
			} catch {}
		};
	}
	function o(e, t, o, s, c) {
		if (process.env.NODE_ENV !== "production") {
			for (var l in e) if (a(e, l)) {
				var u;
				try {
					if (typeof e[l] != "function") {
						var d = Error((s || "React class") + ": " + o + " type `" + l + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof e[l] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
						throw d.name = "Invariant Violation", d;
					}
					u = e[l](t, l, s, o, null, r);
				} catch (e) {
					u = e;
				}
				if (u && !(u instanceof Error) && n((s || "React class") + ": type specification of " + o + " `" + l + "` is invalid; the type checker function must return `null` or an `Error` but returned a " + typeof u + ". You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument)."), u instanceof Error && !(u.message in i)) {
					i[u.message] = !0;
					var f = c ? c() : "";
					n("Failed " + o + " type: " + u.message + (f ?? ""));
				}
			}
		}
	}
	o.resetWarningCache = function() {
		process.env.NODE_ENV !== "production" && (i = {});
	}, t.exports = o;
})), Ko = /* @__PURE__ */ or(((e, t) => {
	var n = Vo(), r = Ho(), i = Uo(), a = Wo(), o = Go(), s = function() {};
	process.env.NODE_ENV !== "production" && (s = function(e) {
		var t = "Warning: " + e;
		typeof console < "u" && console.error(t);
		try {
			throw Error(t);
		} catch {}
	});
	function c() {
		return null;
	}
	t.exports = function(e, t) {
		var l = typeof Symbol == "function" && Symbol.iterator, u = "@@iterator";
		function d(e) {
			var t = e && (l && e[l] || e[u]);
			if (typeof t == "function") return t;
		}
		var f = "<<anonymous>>", p = {
			array: _("array"),
			bigint: _("bigint"),
			bool: _("boolean"),
			func: _("function"),
			number: _("number"),
			object: _("object"),
			string: _("string"),
			symbol: _("symbol"),
			any: v(),
			arrayOf: y,
			element: b(),
			elementType: x(),
			instanceOf: S,
			node: te(),
			objectOf: ee,
			oneOf: C,
			oneOfType: w,
			shape: re,
			exact: ie
		};
		function m(e, t) {
			return e === t ? e !== 0 || 1 / e == 1 / t : e !== e && t !== t;
		}
		function h(e, t) {
			this.message = e, this.data = t && typeof t == "object" ? t : {}, this.stack = "";
		}
		h.prototype = Error.prototype;
		function g(e) {
			if (process.env.NODE_ENV !== "production") var n = {}, r = 0;
			function a(a, o, c, l, u, d, p) {
				if (l ||= f, d ||= c, p !== i) {
					if (t) {
						var m = /* @__PURE__ */ Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use `PropTypes.checkPropTypes()` to call them. Read more at http://fb.me/use-check-prop-types");
						throw m.name = "Invariant Violation", m;
					} else if (process.env.NODE_ENV !== "production" && typeof console < "u") {
						var g = l + ":" + c;
						!n[g] && r < 3 && (s("You are manually calling a React.PropTypes validation function for the `" + d + "` prop on `" + l + "`. This is deprecated and will throw in the standalone `prop-types` package. You may be seeing this warning due to a third-party PropTypes library. See https://fb.me/react-warning-dont-call-proptypes for details."), n[g] = !0, r++);
					}
				}
				return o[c] == null ? a ? o[c] === null ? new h("The " + u + " `" + d + "` is marked as required " + ("in `" + l + "`, but its value is `null`.")) : new h("The " + u + " `" + d + "` is marked as required in " + ("`" + l + "`, but its value is `undefined`.")) : null : e(o, c, l, u, d);
			}
			var o = a.bind(null, !1);
			return o.isRequired = a.bind(null, !0), o;
		}
		function _(e) {
			function t(t, n, r, i, a, o) {
				var s = t[n];
				if (D(s) !== e) {
					var c = ae(s);
					return new h("Invalid " + i + " `" + a + "` of type " + ("`" + c + "` supplied to `" + r + "`, expected ") + ("`" + e + "`."), { expectedType: e });
				}
				return null;
			}
			return g(t);
		}
		function v() {
			return g(c);
		}
		function y(e) {
			function t(t, n, r, a, o) {
				if (typeof e != "function") return new h("Property `" + o + "` of component `" + r + "` has invalid PropType notation inside arrayOf.");
				var s = t[n];
				if (!Array.isArray(s)) {
					var c = D(s);
					return new h("Invalid " + a + " `" + o + "` of type " + ("`" + c + "` supplied to `" + r + "`, expected an array."));
				}
				for (var l = 0; l < s.length; l++) {
					var u = e(s, l, r, a, o + "[" + l + "]", i);
					if (u instanceof Error) return u;
				}
				return null;
			}
			return g(t);
		}
		function b() {
			function t(t, n, r, i, a) {
				var o = t[n];
				if (!e(o)) {
					var s = D(o);
					return new h("Invalid " + i + " `" + a + "` of type " + ("`" + s + "` supplied to `" + r + "`, expected a single ReactElement."));
				}
				return null;
			}
			return g(t);
		}
		function x() {
			function e(e, t, r, i, a) {
				var o = e[t];
				if (!n.isValidElementType(o)) {
					var s = D(o);
					return new h("Invalid " + i + " `" + a + "` of type " + ("`" + s + "` supplied to `" + r + "`, expected a single ReactElement type."));
				}
				return null;
			}
			return g(e);
		}
		function S(e) {
			function t(t, n, r, i, a) {
				if (!(t[n] instanceof e)) {
					var o = e.name || f, s = oe(t[n]);
					return new h("Invalid " + i + " `" + a + "` of type " + ("`" + s + "` supplied to `" + r + "`, expected ") + ("instance of `" + o + "`."));
				}
				return null;
			}
			return g(t);
		}
		function C(e) {
			if (!Array.isArray(e)) return process.env.NODE_ENV !== "production" && (arguments.length > 1 ? s("Invalid arguments supplied to oneOf, expected an array, got " + arguments.length + " arguments. A common mistake is to write oneOf(x, y, z) instead of oneOf([x, y, z]).") : s("Invalid argument supplied to oneOf, expected an array.")), c;
			function t(t, n, r, i, a) {
				for (var o = t[n], s = 0; s < e.length; s++) if (m(o, e[s])) return null;
				var c = JSON.stringify(e, function(e, t) {
					return ae(t) === "symbol" ? String(t) : t;
				});
				return new h("Invalid " + i + " `" + a + "` of value `" + String(o) + "` " + ("supplied to `" + r + "`, expected one of " + c + "."));
			}
			return g(t);
		}
		function ee(e) {
			function t(t, n, r, o, s) {
				if (typeof e != "function") return new h("Property `" + s + "` of component `" + r + "` has invalid PropType notation inside objectOf.");
				var c = t[n], l = D(c);
				if (l !== "object") return new h("Invalid " + o + " `" + s + "` of type " + ("`" + l + "` supplied to `" + r + "`, expected an object."));
				for (var u in c) if (a(c, u)) {
					var d = e(c, u, r, o, s + "." + u, i);
					if (d instanceof Error) return d;
				}
				return null;
			}
			return g(t);
		}
		function w(e) {
			if (!Array.isArray(e)) return process.env.NODE_ENV !== "production" && s("Invalid argument supplied to oneOfType, expected an instance of array."), c;
			for (var t = 0; t < e.length; t++) {
				var n = e[t];
				if (typeof n != "function") return s("Invalid argument supplied to oneOfType. Expected an array of check functions, but received " + O(n) + " at index " + t + "."), c;
			}
			function r(t, n, r, o, s) {
				for (var c = [], l = 0; l < e.length; l++) {
					var u = e[l], d = u(t, n, r, o, s, i);
					if (d == null) return null;
					d.data && a(d.data, "expectedType") && c.push(d.data.expectedType);
				}
				var f = c.length > 0 ? ", expected one of type [" + c.join(", ") + "]" : "";
				return new h("Invalid " + o + " `" + s + "` supplied to " + ("`" + r + "`" + f + "."));
			}
			return g(r);
		}
		function te() {
			function e(e, t, n, r, i) {
				return T(e[t]) ? null : new h("Invalid " + r + " `" + i + "` supplied to " + ("`" + n + "`, expected a ReactNode."));
			}
			return g(e);
		}
		function ne(e, t, n, r, i) {
			return new h((e || "React class") + ": " + t + " type `" + n + "." + r + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + i + "`.");
		}
		function re(e) {
			function t(t, n, r, a, o) {
				var s = t[n], c = D(s);
				if (c !== "object") return new h("Invalid " + a + " `" + o + "` of type `" + c + "` " + ("supplied to `" + r + "`, expected `object`."));
				for (var l in e) {
					var u = e[l];
					if (typeof u != "function") return ne(r, a, o, l, ae(u));
					var d = u(s, l, r, a, o + "." + l, i);
					if (d) return d;
				}
				return null;
			}
			return g(t);
		}
		function ie(e) {
			function t(t, n, o, s, c) {
				var l = t[n], u = D(l);
				if (u !== "object") return new h("Invalid " + s + " `" + c + "` of type `" + u + "` " + ("supplied to `" + o + "`, expected `object`."));
				for (var d in r({}, t[n], e)) {
					var f = e[d];
					if (a(e, d) && typeof f != "function") return ne(o, s, c, d, ae(f));
					if (!f) return new h("Invalid " + s + " `" + c + "` key `" + d + "` supplied to `" + o + "`.\nBad object: " + JSON.stringify(t[n], null, "  ") + "\nValid keys: " + JSON.stringify(Object.keys(e), null, "  "));
					var p = f(l, d, o, s, c + "." + d, i);
					if (p) return p;
				}
				return null;
			}
			return g(t);
		}
		function T(t) {
			switch (typeof t) {
				case "number":
				case "string":
				case "undefined": return !0;
				case "boolean": return !t;
				case "object":
					if (Array.isArray(t)) return t.every(T);
					if (t === null || e(t)) return !0;
					var n = d(t);
					if (n) {
						var r = n.call(t), i;
						if (n !== t.entries) {
							for (; !(i = r.next()).done;) if (!T(i.value)) return !1;
						} else for (; !(i = r.next()).done;) {
							var a = i.value;
							if (a && !T(a[1])) return !1;
						}
					} else return !1;
					return !0;
				default: return !1;
			}
		}
		function E(e, t) {
			return e === "symbol" ? !0 : t ? t["@@toStringTag"] === "Symbol" || typeof Symbol == "function" && t instanceof Symbol : !1;
		}
		function D(e) {
			var t = typeof e;
			return Array.isArray(e) ? "array" : e instanceof RegExp ? "object" : E(t, e) ? "symbol" : t;
		}
		function ae(e) {
			if (e == null) return "" + e;
			var t = D(e);
			if (t === "object") {
				if (e instanceof Date) return "date";
				if (e instanceof RegExp) return "regexp";
			}
			return t;
		}
		function O(e) {
			var t = ae(e);
			switch (t) {
				case "array":
				case "object": return "an " + t;
				case "boolean":
				case "date":
				case "regexp": return "a " + t;
				default: return t;
			}
		}
		function oe(e) {
			return !e.constructor || !e.constructor.name ? f : e.constructor.name;
		}
		return p.checkPropTypes = o, p.resetWarningCache = o.resetWarningCache, p.PropTypes = p, p;
	};
})), qo = /* @__PURE__ */ or(((e, t) => {
	var n = Uo();
	function r() {}
	function i() {}
	i.resetWarningCache = r, t.exports = function() {
		function e(e, t, r, i, a, o) {
			if (o !== n) {
				var s = /* @__PURE__ */ Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");
				throw s.name = "Invariant Violation", s;
			}
		}
		e.isRequired = e;
		function t() {
			return e;
		}
		var a = {
			array: e,
			bigint: e,
			bool: e,
			func: e,
			number: e,
			object: e,
			string: e,
			symbol: e,
			any: e,
			arrayOf: t,
			element: e,
			elementType: e,
			instanceOf: t,
			node: e,
			objectOf: t,
			oneOf: t,
			oneOfType: t,
			shape: t,
			exact: t,
			checkPropTypes: i,
			resetWarningCache: r
		};
		return a.PropTypes = a, a;
	};
})), Jo = /* @__PURE__ */ or(((e, t) => {
	if (process.env.NODE_ENV !== "production") {
		var n = Vo();
		t.exports = Ko()(n.isElement, !0);
	} else t.exports = qo()();
}));
//#endregion
//#region ../node_modules/tslib/tslib.es6.mjs
function Yo(e, t, n, r) {
	function i(e) {
		return e instanceof n ? e : new n(function(t) {
			t(e);
		});
	}
	return new (n ||= Promise)(function(n, a) {
		function o(e) {
			try {
				c(r.next(e));
			} catch (e) {
				a(e);
			}
		}
		function s(e) {
			try {
				c(r.throw(e));
			} catch (e) {
				a(e);
			}
		}
		function c(e) {
			e.done ? n(e.value) : i(e.value).then(o, s);
		}
		c((r = r.apply(e, t || [])).next());
	});
}
//#endregion
//#region ../node_modules/file-selector/dist/es2015/file.js
var Xo = new Map([
	["1km", "application/vnd.1000minds.decision-model+xml"],
	["3dml", "text/vnd.in3d.3dml"],
	["3ds", "image/x-3ds"],
	["3g2", "video/3gpp2"],
	["3gp", "video/3gp"],
	["3gpp", "video/3gpp"],
	["3mf", "model/3mf"],
	["7z", "application/x-7z-compressed"],
	["7zip", "application/x-7z-compressed"],
	["123", "application/vnd.lotus-1-2-3"],
	["aab", "application/x-authorware-bin"],
	["aac", "audio/x-acc"],
	["aam", "application/x-authorware-map"],
	["aas", "application/x-authorware-seg"],
	["abw", "application/x-abiword"],
	["ac", "application/vnd.nokia.n-gage.ac+xml"],
	["ac3", "audio/ac3"],
	["acc", "application/vnd.americandynamics.acc"],
	["ace", "application/x-ace-compressed"],
	["acu", "application/vnd.acucobol"],
	["acutc", "application/vnd.acucorp"],
	["adp", "audio/adpcm"],
	["aep", "application/vnd.audiograph"],
	["afm", "application/x-font-type1"],
	["afp", "application/vnd.ibm.modcap"],
	["ahead", "application/vnd.ahead.space"],
	["ai", "application/pdf"],
	["aif", "audio/x-aiff"],
	["aifc", "audio/x-aiff"],
	["aiff", "audio/x-aiff"],
	["air", "application/vnd.adobe.air-application-installer-package+zip"],
	["ait", "application/vnd.dvb.ait"],
	["ami", "application/vnd.amiga.ami"],
	["amr", "audio/amr"],
	["apk", "application/vnd.android.package-archive"],
	["apng", "image/apng"],
	["appcache", "text/cache-manifest"],
	["application", "application/x-ms-application"],
	["apr", "application/vnd.lotus-approach"],
	["arc", "application/x-freearc"],
	["arj", "application/x-arj"],
	["asc", "application/pgp-signature"],
	["asf", "video/x-ms-asf"],
	["asm", "text/x-asm"],
	["aso", "application/vnd.accpac.simply.aso"],
	["asx", "video/x-ms-asf"],
	["atc", "application/vnd.acucorp"],
	["atom", "application/atom+xml"],
	["atomcat", "application/atomcat+xml"],
	["atomdeleted", "application/atomdeleted+xml"],
	["atomsvc", "application/atomsvc+xml"],
	["atx", "application/vnd.antix.game-component"],
	["au", "audio/x-au"],
	["avi", "video/x-msvideo"],
	["avif", "image/avif"],
	["aw", "application/applixware"],
	["azf", "application/vnd.airzip.filesecure.azf"],
	["azs", "application/vnd.airzip.filesecure.azs"],
	["azv", "image/vnd.airzip.accelerator.azv"],
	["azw", "application/vnd.amazon.ebook"],
	["b16", "image/vnd.pco.b16"],
	["bat", "application/x-msdownload"],
	["bcpio", "application/x-bcpio"],
	["bdf", "application/x-font-bdf"],
	["bdm", "application/vnd.syncml.dm+wbxml"],
	["bdoc", "application/x-bdoc"],
	["bed", "application/vnd.realvnc.bed"],
	["bh2", "application/vnd.fujitsu.oasysprs"],
	["bin", "application/octet-stream"],
	["blb", "application/x-blorb"],
	["blorb", "application/x-blorb"],
	["bmi", "application/vnd.bmi"],
	["bmml", "application/vnd.balsamiq.bmml+xml"],
	["bmp", "image/bmp"],
	["book", "application/vnd.framemaker"],
	["box", "application/vnd.previewsystems.box"],
	["boz", "application/x-bzip2"],
	["bpk", "application/octet-stream"],
	["bpmn", "application/octet-stream"],
	["bsp", "model/vnd.valve.source.compiled-map"],
	["btif", "image/prs.btif"],
	["buffer", "application/octet-stream"],
	["bz", "application/x-bzip"],
	["bz2", "application/x-bzip2"],
	["c", "text/x-c"],
	["c4d", "application/vnd.clonk.c4group"],
	["c4f", "application/vnd.clonk.c4group"],
	["c4g", "application/vnd.clonk.c4group"],
	["c4p", "application/vnd.clonk.c4group"],
	["c4u", "application/vnd.clonk.c4group"],
	["c11amc", "application/vnd.cluetrust.cartomobile-config"],
	["c11amz", "application/vnd.cluetrust.cartomobile-config-pkg"],
	["cab", "application/vnd.ms-cab-compressed"],
	["caf", "audio/x-caf"],
	["cap", "application/vnd.tcpdump.pcap"],
	["car", "application/vnd.curl.car"],
	["cat", "application/vnd.ms-pki.seccat"],
	["cb7", "application/x-cbr"],
	["cba", "application/x-cbr"],
	["cbr", "application/x-cbr"],
	["cbt", "application/x-cbr"],
	["cbz", "application/x-cbr"],
	["cc", "text/x-c"],
	["cco", "application/x-cocoa"],
	["cct", "application/x-director"],
	["ccxml", "application/ccxml+xml"],
	["cdbcmsg", "application/vnd.contact.cmsg"],
	["cda", "application/x-cdf"],
	["cdf", "application/x-netcdf"],
	["cdfx", "application/cdfx+xml"],
	["cdkey", "application/vnd.mediastation.cdkey"],
	["cdmia", "application/cdmi-capability"],
	["cdmic", "application/cdmi-container"],
	["cdmid", "application/cdmi-domain"],
	["cdmio", "application/cdmi-object"],
	["cdmiq", "application/cdmi-queue"],
	["cdr", "application/cdr"],
	["cdx", "chemical/x-cdx"],
	["cdxml", "application/vnd.chemdraw+xml"],
	["cdy", "application/vnd.cinderella"],
	["cer", "application/pkix-cert"],
	["cfs", "application/x-cfs-compressed"],
	["cgm", "image/cgm"],
	["chat", "application/x-chat"],
	["chm", "application/vnd.ms-htmlhelp"],
	["chrt", "application/vnd.kde.kchart"],
	["cif", "chemical/x-cif"],
	["cii", "application/vnd.anser-web-certificate-issue-initiation"],
	["cil", "application/vnd.ms-artgalry"],
	["cjs", "application/node"],
	["cla", "application/vnd.claymore"],
	["class", "application/octet-stream"],
	["clkk", "application/vnd.crick.clicker.keyboard"],
	["clkp", "application/vnd.crick.clicker.palette"],
	["clkt", "application/vnd.crick.clicker.template"],
	["clkw", "application/vnd.crick.clicker.wordbank"],
	["clkx", "application/vnd.crick.clicker"],
	["clp", "application/x-msclip"],
	["cmc", "application/vnd.cosmocaller"],
	["cmdf", "chemical/x-cmdf"],
	["cml", "chemical/x-cml"],
	["cmp", "application/vnd.yellowriver-custom-menu"],
	["cmx", "image/x-cmx"],
	["cod", "application/vnd.rim.cod"],
	["coffee", "text/coffeescript"],
	["com", "application/x-msdownload"],
	["conf", "text/plain"],
	["cpio", "application/x-cpio"],
	["cpp", "text/x-c"],
	["cpt", "application/mac-compactpro"],
	["crd", "application/x-mscardfile"],
	["crl", "application/pkix-crl"],
	["crt", "application/x-x509-ca-cert"],
	["crx", "application/x-chrome-extension"],
	["cryptonote", "application/vnd.rig.cryptonote"],
	["csh", "application/x-csh"],
	["csl", "application/vnd.citationstyles.style+xml"],
	["csml", "chemical/x-csml"],
	["csp", "application/vnd.commonspace"],
	["csr", "application/octet-stream"],
	["css", "text/css"],
	["cst", "application/x-director"],
	["csv", "text/csv"],
	["cu", "application/cu-seeme"],
	["curl", "text/vnd.curl"],
	["cww", "application/prs.cww"],
	["cxt", "application/x-director"],
	["cxx", "text/x-c"],
	["dae", "model/vnd.collada+xml"],
	["daf", "application/vnd.mobius.daf"],
	["dart", "application/vnd.dart"],
	["dataless", "application/vnd.fdsn.seed"],
	["davmount", "application/davmount+xml"],
	["dbf", "application/vnd.dbf"],
	["dbk", "application/docbook+xml"],
	["dcr", "application/x-director"],
	["dcurl", "text/vnd.curl.dcurl"],
	["dd2", "application/vnd.oma.dd2+xml"],
	["ddd", "application/vnd.fujixerox.ddd"],
	["ddf", "application/vnd.syncml.dmddf+xml"],
	["dds", "image/vnd.ms-dds"],
	["deb", "application/x-debian-package"],
	["def", "text/plain"],
	["deploy", "application/octet-stream"],
	["der", "application/x-x509-ca-cert"],
	["dfac", "application/vnd.dreamfactory"],
	["dgc", "application/x-dgc-compressed"],
	["dic", "text/x-c"],
	["dir", "application/x-director"],
	["dis", "application/vnd.mobius.dis"],
	["disposition-notification", "message/disposition-notification"],
	["dist", "application/octet-stream"],
	["distz", "application/octet-stream"],
	["djv", "image/vnd.djvu"],
	["djvu", "image/vnd.djvu"],
	["dll", "application/octet-stream"],
	["dmg", "application/x-apple-diskimage"],
	["dmn", "application/octet-stream"],
	["dmp", "application/vnd.tcpdump.pcap"],
	["dms", "application/octet-stream"],
	["dna", "application/vnd.dna"],
	["doc", "application/msword"],
	["docm", "application/vnd.ms-word.template.macroEnabled.12"],
	["docx", "application/vnd.openxmlformats-officedocument.wordprocessingml.document"],
	["dot", "application/msword"],
	["dotm", "application/vnd.ms-word.template.macroEnabled.12"],
	["dotx", "application/vnd.openxmlformats-officedocument.wordprocessingml.template"],
	["dp", "application/vnd.osgi.dp"],
	["dpg", "application/vnd.dpgraph"],
	["dra", "audio/vnd.dra"],
	["drle", "image/dicom-rle"],
	["dsc", "text/prs.lines.tag"],
	["dssc", "application/dssc+der"],
	["dtb", "application/x-dtbook+xml"],
	["dtd", "application/xml-dtd"],
	["dts", "audio/vnd.dts"],
	["dtshd", "audio/vnd.dts.hd"],
	["dump", "application/octet-stream"],
	["dvb", "video/vnd.dvb.file"],
	["dvi", "application/x-dvi"],
	["dwd", "application/atsc-dwd+xml"],
	["dwf", "model/vnd.dwf"],
	["dwg", "image/vnd.dwg"],
	["dxf", "image/vnd.dxf"],
	["dxp", "application/vnd.spotfire.dxp"],
	["dxr", "application/x-director"],
	["ear", "application/java-archive"],
	["ecelp4800", "audio/vnd.nuera.ecelp4800"],
	["ecelp7470", "audio/vnd.nuera.ecelp7470"],
	["ecelp9600", "audio/vnd.nuera.ecelp9600"],
	["ecma", "application/ecmascript"],
	["edm", "application/vnd.novadigm.edm"],
	["edx", "application/vnd.novadigm.edx"],
	["efif", "application/vnd.picsel"],
	["ei6", "application/vnd.pg.osasli"],
	["elc", "application/octet-stream"],
	["emf", "image/emf"],
	["eml", "message/rfc822"],
	["emma", "application/emma+xml"],
	["emotionml", "application/emotionml+xml"],
	["emz", "application/x-msmetafile"],
	["eol", "audio/vnd.digital-winds"],
	["eot", "application/vnd.ms-fontobject"],
	["eps", "application/postscript"],
	["epub", "application/epub+zip"],
	["es", "application/ecmascript"],
	["es3", "application/vnd.eszigno3+xml"],
	["esa", "application/vnd.osgi.subsystem"],
	["esf", "application/vnd.epson.esf"],
	["et3", "application/vnd.eszigno3+xml"],
	["etx", "text/x-setext"],
	["eva", "application/x-eva"],
	["evy", "application/x-envoy"],
	["exe", "application/octet-stream"],
	["exi", "application/exi"],
	["exp", "application/express"],
	["exr", "image/aces"],
	["ext", "application/vnd.novadigm.ext"],
	["ez", "application/andrew-inset"],
	["ez2", "application/vnd.ezpix-album"],
	["ez3", "application/vnd.ezpix-package"],
	["f", "text/x-fortran"],
	["f4v", "video/mp4"],
	["f77", "text/x-fortran"],
	["f90", "text/x-fortran"],
	["fbs", "image/vnd.fastbidsheet"],
	["fcdt", "application/vnd.adobe.formscentral.fcdt"],
	["fcs", "application/vnd.isac.fcs"],
	["fdf", "application/vnd.fdf"],
	["fdt", "application/fdt+xml"],
	["fe_launch", "application/vnd.denovo.fcselayout-link"],
	["fg5", "application/vnd.fujitsu.oasysgp"],
	["fgd", "application/x-director"],
	["fh", "image/x-freehand"],
	["fh4", "image/x-freehand"],
	["fh5", "image/x-freehand"],
	["fh7", "image/x-freehand"],
	["fhc", "image/x-freehand"],
	["fig", "application/x-xfig"],
	["fits", "image/fits"],
	["flac", "audio/x-flac"],
	["fli", "video/x-fli"],
	["flo", "application/vnd.micrografx.flo"],
	["flv", "video/x-flv"],
	["flw", "application/vnd.kde.kivio"],
	["flx", "text/vnd.fmi.flexstor"],
	["fly", "text/vnd.fly"],
	["fm", "application/vnd.framemaker"],
	["fnc", "application/vnd.frogans.fnc"],
	["fo", "application/vnd.software602.filler.form+xml"],
	["for", "text/x-fortran"],
	["fpx", "image/vnd.fpx"],
	["frame", "application/vnd.framemaker"],
	["fsc", "application/vnd.fsc.weblaunch"],
	["fst", "image/vnd.fst"],
	["ftc", "application/vnd.fluxtime.clip"],
	["fti", "application/vnd.anser-web-funds-transfer-initiation"],
	["fvt", "video/vnd.fvt"],
	["fxp", "application/vnd.adobe.fxp"],
	["fxpl", "application/vnd.adobe.fxp"],
	["fzs", "application/vnd.fuzzysheet"],
	["g2w", "application/vnd.geoplan"],
	["g3", "image/g3fax"],
	["g3w", "application/vnd.geospace"],
	["gac", "application/vnd.groove-account"],
	["gam", "application/x-tads"],
	["gbr", "application/rpki-ghostbusters"],
	["gca", "application/x-gca-compressed"],
	["gdl", "model/vnd.gdl"],
	["gdoc", "application/vnd.google-apps.document"],
	["geo", "application/vnd.dynageo"],
	["geojson", "application/geo+json"],
	["gex", "application/vnd.geometry-explorer"],
	["ggb", "application/vnd.geogebra.file"],
	["ggt", "application/vnd.geogebra.tool"],
	["ghf", "application/vnd.groove-help"],
	["gif", "image/gif"],
	["gim", "application/vnd.groove-identity-message"],
	["glb", "model/gltf-binary"],
	["gltf", "model/gltf+json"],
	["gml", "application/gml+xml"],
	["gmx", "application/vnd.gmx"],
	["gnumeric", "application/x-gnumeric"],
	["gpg", "application/gpg-keys"],
	["gph", "application/vnd.flographit"],
	["gpx", "application/gpx+xml"],
	["gqf", "application/vnd.grafeq"],
	["gqs", "application/vnd.grafeq"],
	["gram", "application/srgs"],
	["gramps", "application/x-gramps-xml"],
	["gre", "application/vnd.geometry-explorer"],
	["grv", "application/vnd.groove-injector"],
	["grxml", "application/srgs+xml"],
	["gsf", "application/x-font-ghostscript"],
	["gsheet", "application/vnd.google-apps.spreadsheet"],
	["gslides", "application/vnd.google-apps.presentation"],
	["gtar", "application/x-gtar"],
	["gtm", "application/vnd.groove-tool-message"],
	["gtw", "model/vnd.gtw"],
	["gv", "text/vnd.graphviz"],
	["gxf", "application/gxf"],
	["gxt", "application/vnd.geonext"],
	["gz", "application/gzip"],
	["gzip", "application/gzip"],
	["h", "text/x-c"],
	["h261", "video/h261"],
	["h263", "video/h263"],
	["h264", "video/h264"],
	["hal", "application/vnd.hal+xml"],
	["hbci", "application/vnd.hbci"],
	["hbs", "text/x-handlebars-template"],
	["hdd", "application/x-virtualbox-hdd"],
	["hdf", "application/x-hdf"],
	["heic", "image/heic"],
	["heics", "image/heic-sequence"],
	["heif", "image/heif"],
	["heifs", "image/heif-sequence"],
	["hej2", "image/hej2k"],
	["held", "application/atsc-held+xml"],
	["hh", "text/x-c"],
	["hjson", "application/hjson"],
	["hlp", "application/winhlp"],
	["hpgl", "application/vnd.hp-hpgl"],
	["hpid", "application/vnd.hp-hpid"],
	["hps", "application/vnd.hp-hps"],
	["hqx", "application/mac-binhex40"],
	["hsj2", "image/hsj2"],
	["htc", "text/x-component"],
	["htke", "application/vnd.kenameaapp"],
	["htm", "text/html"],
	["html", "text/html"],
	["hvd", "application/vnd.yamaha.hv-dic"],
	["hvp", "application/vnd.yamaha.hv-voice"],
	["hvs", "application/vnd.yamaha.hv-script"],
	["i2g", "application/vnd.intergeo"],
	["icc", "application/vnd.iccprofile"],
	["ice", "x-conference/x-cooltalk"],
	["icm", "application/vnd.iccprofile"],
	["ico", "image/x-icon"],
	["ics", "text/calendar"],
	["ief", "image/ief"],
	["ifb", "text/calendar"],
	["ifm", "application/vnd.shana.informed.formdata"],
	["iges", "model/iges"],
	["igl", "application/vnd.igloader"],
	["igm", "application/vnd.insors.igm"],
	["igs", "model/iges"],
	["igx", "application/vnd.micrografx.igx"],
	["iif", "application/vnd.shana.informed.interchange"],
	["img", "application/octet-stream"],
	["imp", "application/vnd.accpac.simply.imp"],
	["ims", "application/vnd.ms-ims"],
	["in", "text/plain"],
	["ini", "text/plain"],
	["ink", "application/inkml+xml"],
	["inkml", "application/inkml+xml"],
	["install", "application/x-install-instructions"],
	["iota", "application/vnd.astraea-software.iota"],
	["ipfix", "application/ipfix"],
	["ipk", "application/vnd.shana.informed.package"],
	["irm", "application/vnd.ibm.rights-management"],
	["irp", "application/vnd.irepository.package+xml"],
	["iso", "application/x-iso9660-image"],
	["itp", "application/vnd.shana.informed.formtemplate"],
	["its", "application/its+xml"],
	["ivp", "application/vnd.immervision-ivp"],
	["ivu", "application/vnd.immervision-ivu"],
	["jad", "text/vnd.sun.j2me.app-descriptor"],
	["jade", "text/jade"],
	["jam", "application/vnd.jam"],
	["jar", "application/java-archive"],
	["jardiff", "application/x-java-archive-diff"],
	["java", "text/x-java-source"],
	["jhc", "image/jphc"],
	["jisp", "application/vnd.jisp"],
	["jls", "image/jls"],
	["jlt", "application/vnd.hp-jlyt"],
	["jng", "image/x-jng"],
	["jnlp", "application/x-java-jnlp-file"],
	["joda", "application/vnd.joost.joda-archive"],
	["jp2", "image/jp2"],
	["jpe", "image/jpeg"],
	["jpeg", "image/jpeg"],
	["jpf", "image/jpx"],
	["jpg", "image/jpeg"],
	["jpg2", "image/jp2"],
	["jpgm", "video/jpm"],
	["jpgv", "video/jpeg"],
	["jph", "image/jph"],
	["jpm", "video/jpm"],
	["jpx", "image/jpx"],
	["js", "application/javascript"],
	["json", "application/json"],
	["json5", "application/json5"],
	["jsonld", "application/ld+json"],
	["jsonl", "application/jsonl"],
	["jsonml", "application/jsonml+json"],
	["jsx", "text/jsx"],
	["jxr", "image/jxr"],
	["jxra", "image/jxra"],
	["jxrs", "image/jxrs"],
	["jxs", "image/jxs"],
	["jxsc", "image/jxsc"],
	["jxsi", "image/jxsi"],
	["jxss", "image/jxss"],
	["kar", "audio/midi"],
	["karbon", "application/vnd.kde.karbon"],
	["kdb", "application/octet-stream"],
	["kdbx", "application/x-keepass2"],
	["key", "application/x-iwork-keynote-sffkey"],
	["kfo", "application/vnd.kde.kformula"],
	["kia", "application/vnd.kidspiration"],
	["kml", "application/vnd.google-earth.kml+xml"],
	["kmz", "application/vnd.google-earth.kmz"],
	["kne", "application/vnd.kinar"],
	["knp", "application/vnd.kinar"],
	["kon", "application/vnd.kde.kontour"],
	["kpr", "application/vnd.kde.kpresenter"],
	["kpt", "application/vnd.kde.kpresenter"],
	["kpxx", "application/vnd.ds-keypoint"],
	["ksp", "application/vnd.kde.kspread"],
	["ktr", "application/vnd.kahootz"],
	["ktx", "image/ktx"],
	["ktx2", "image/ktx2"],
	["ktz", "application/vnd.kahootz"],
	["kwd", "application/vnd.kde.kword"],
	["kwt", "application/vnd.kde.kword"],
	["lasxml", "application/vnd.las.las+xml"],
	["latex", "application/x-latex"],
	["lbd", "application/vnd.llamagraphics.life-balance.desktop"],
	["lbe", "application/vnd.llamagraphics.life-balance.exchange+xml"],
	["les", "application/vnd.hhe.lesson-player"],
	["less", "text/less"],
	["lgr", "application/lgr+xml"],
	["lha", "application/octet-stream"],
	["link66", "application/vnd.route66.link66+xml"],
	["list", "text/plain"],
	["list3820", "application/vnd.ibm.modcap"],
	["listafp", "application/vnd.ibm.modcap"],
	["litcoffee", "text/coffeescript"],
	["lnk", "application/x-ms-shortcut"],
	["log", "text/plain"],
	["lostxml", "application/lost+xml"],
	["lrf", "application/octet-stream"],
	["lrm", "application/vnd.ms-lrm"],
	["ltf", "application/vnd.frogans.ltf"],
	["lua", "text/x-lua"],
	["luac", "application/x-lua-bytecode"],
	["lvp", "audio/vnd.lucent.voice"],
	["lwp", "application/vnd.lotus-wordpro"],
	["lzh", "application/octet-stream"],
	["m1v", "video/mpeg"],
	["m2a", "audio/mpeg"],
	["m2v", "video/mpeg"],
	["m3a", "audio/mpeg"],
	["m3u", "text/plain"],
	["m3u8", "application/vnd.apple.mpegurl"],
	["m4a", "audio/x-m4a"],
	["m4p", "application/mp4"],
	["m4s", "video/iso.segment"],
	["m4u", "application/vnd.mpegurl"],
	["m4v", "video/x-m4v"],
	["m13", "application/x-msmediaview"],
	["m14", "application/x-msmediaview"],
	["m21", "application/mp21"],
	["ma", "application/mathematica"],
	["mads", "application/mads+xml"],
	["maei", "application/mmt-aei+xml"],
	["mag", "application/vnd.ecowin.chart"],
	["maker", "application/vnd.framemaker"],
	["man", "text/troff"],
	["manifest", "text/cache-manifest"],
	["map", "application/json"],
	["mar", "application/octet-stream"],
	["markdown", "text/markdown"],
	["mathml", "application/mathml+xml"],
	["mb", "application/mathematica"],
	["mbk", "application/vnd.mobius.mbk"],
	["mbox", "application/mbox"],
	["mc1", "application/vnd.medcalcdata"],
	["mcd", "application/vnd.mcd"],
	["mcurl", "text/vnd.curl.mcurl"],
	["md", "text/markdown"],
	["mdb", "application/x-msaccess"],
	["mdi", "image/vnd.ms-modi"],
	["mdx", "text/mdx"],
	["me", "text/troff"],
	["mesh", "model/mesh"],
	["meta4", "application/metalink4+xml"],
	["metalink", "application/metalink+xml"],
	["mets", "application/mets+xml"],
	["mfm", "application/vnd.mfmp"],
	["mft", "application/rpki-manifest"],
	["mgp", "application/vnd.osgeo.mapguide.package"],
	["mgz", "application/vnd.proteus.magazine"],
	["mid", "audio/midi"],
	["midi", "audio/midi"],
	["mie", "application/x-mie"],
	["mif", "application/vnd.mif"],
	["mime", "message/rfc822"],
	["mj2", "video/mj2"],
	["mjp2", "video/mj2"],
	["mjs", "application/javascript"],
	["mk3d", "video/x-matroska"],
	["mka", "audio/x-matroska"],
	["mkd", "text/x-markdown"],
	["mks", "video/x-matroska"],
	["mkv", "video/x-matroska"],
	["mlp", "application/vnd.dolby.mlp"],
	["mmd", "application/vnd.chipnuts.karaoke-mmd"],
	["mmf", "application/vnd.smaf"],
	["mml", "text/mathml"],
	["mmr", "image/vnd.fujixerox.edmics-mmr"],
	["mng", "video/x-mng"],
	["mny", "application/x-msmoney"],
	["mobi", "application/x-mobipocket-ebook"],
	["mods", "application/mods+xml"],
	["mov", "video/quicktime"],
	["movie", "video/x-sgi-movie"],
	["mp2", "audio/mpeg"],
	["mp2a", "audio/mpeg"],
	["mp3", "audio/mpeg"],
	["mp4", "video/mp4"],
	["mp4a", "audio/mp4"],
	["mp4s", "application/mp4"],
	["mp4v", "video/mp4"],
	["mp21", "application/mp21"],
	["mpc", "application/vnd.mophun.certificate"],
	["mpd", "application/dash+xml"],
	["mpe", "video/mpeg"],
	["mpeg", "video/mpeg"],
	["mpg", "video/mpeg"],
	["mpg4", "video/mp4"],
	["mpga", "audio/mpeg"],
	["mpkg", "application/vnd.apple.installer+xml"],
	["mpm", "application/vnd.blueice.multipass"],
	["mpn", "application/vnd.mophun.application"],
	["mpp", "application/vnd.ms-project"],
	["mpt", "application/vnd.ms-project"],
	["mpy", "application/vnd.ibm.minipay"],
	["mqy", "application/vnd.mobius.mqy"],
	["mrc", "application/marc"],
	["mrcx", "application/marcxml+xml"],
	["ms", "text/troff"],
	["mscml", "application/mediaservercontrol+xml"],
	["mseed", "application/vnd.fdsn.mseed"],
	["mseq", "application/vnd.mseq"],
	["msf", "application/vnd.epson.msf"],
	["msg", "application/vnd.ms-outlook"],
	["msh", "model/mesh"],
	["msi", "application/x-msdownload"],
	["msl", "application/vnd.mobius.msl"],
	["msm", "application/octet-stream"],
	["msp", "application/octet-stream"],
	["msty", "application/vnd.muvee.style"],
	["mtl", "model/mtl"],
	["mts", "model/vnd.mts"],
	["mus", "application/vnd.musician"],
	["musd", "application/mmt-usd+xml"],
	["musicxml", "application/vnd.recordare.musicxml+xml"],
	["mvb", "application/x-msmediaview"],
	["mvt", "application/vnd.mapbox-vector-tile"],
	["mwf", "application/vnd.mfer"],
	["mxf", "application/mxf"],
	["mxl", "application/vnd.recordare.musicxml"],
	["mxmf", "audio/mobile-xmf"],
	["mxml", "application/xv+xml"],
	["mxs", "application/vnd.triscape.mxs"],
	["mxu", "video/vnd.mpegurl"],
	["n-gage", "application/vnd.nokia.n-gage.symbian.install"],
	["n3", "text/n3"],
	["nb", "application/mathematica"],
	["nbp", "application/vnd.wolfram.player"],
	["nc", "application/x-netcdf"],
	["ncx", "application/x-dtbncx+xml"],
	["nfo", "text/x-nfo"],
	["ngdat", "application/vnd.nokia.n-gage.data"],
	["nitf", "application/vnd.nitf"],
	["nlu", "application/vnd.neurolanguage.nlu"],
	["nml", "application/vnd.enliven"],
	["nnd", "application/vnd.noblenet-directory"],
	["nns", "application/vnd.noblenet-sealer"],
	["nnw", "application/vnd.noblenet-web"],
	["npx", "image/vnd.net-fpx"],
	["nq", "application/n-quads"],
	["nsc", "application/x-conference"],
	["nsf", "application/vnd.lotus-notes"],
	["nt", "application/n-triples"],
	["ntf", "application/vnd.nitf"],
	["numbers", "application/x-iwork-numbers-sffnumbers"],
	["nzb", "application/x-nzb"],
	["oa2", "application/vnd.fujitsu.oasys2"],
	["oa3", "application/vnd.fujitsu.oasys3"],
	["oas", "application/vnd.fujitsu.oasys"],
	["obd", "application/x-msbinder"],
	["obgx", "application/vnd.openblox.game+xml"],
	["obj", "model/obj"],
	["oda", "application/oda"],
	["odb", "application/vnd.oasis.opendocument.database"],
	["odc", "application/vnd.oasis.opendocument.chart"],
	["odf", "application/vnd.oasis.opendocument.formula"],
	["odft", "application/vnd.oasis.opendocument.formula-template"],
	["odg", "application/vnd.oasis.opendocument.graphics"],
	["odi", "application/vnd.oasis.opendocument.image"],
	["odm", "application/vnd.oasis.opendocument.text-master"],
	["odp", "application/vnd.oasis.opendocument.presentation"],
	["ods", "application/vnd.oasis.opendocument.spreadsheet"],
	["odt", "application/vnd.oasis.opendocument.text"],
	["oga", "audio/ogg"],
	["ogex", "model/vnd.opengex"],
	["ogg", "audio/ogg"],
	["ogv", "video/ogg"],
	["ogx", "application/ogg"],
	["omdoc", "application/omdoc+xml"],
	["onepkg", "application/onenote"],
	["onetmp", "application/onenote"],
	["onetoc", "application/onenote"],
	["onetoc2", "application/onenote"],
	["opf", "application/oebps-package+xml"],
	["opml", "text/x-opml"],
	["oprc", "application/vnd.palm"],
	["opus", "audio/ogg"],
	["org", "text/x-org"],
	["osf", "application/vnd.yamaha.openscoreformat"],
	["osfpvg", "application/vnd.yamaha.openscoreformat.osfpvg+xml"],
	["osm", "application/vnd.openstreetmap.data+xml"],
	["otc", "application/vnd.oasis.opendocument.chart-template"],
	["otf", "font/otf"],
	["otg", "application/vnd.oasis.opendocument.graphics-template"],
	["oth", "application/vnd.oasis.opendocument.text-web"],
	["oti", "application/vnd.oasis.opendocument.image-template"],
	["otp", "application/vnd.oasis.opendocument.presentation-template"],
	["ots", "application/vnd.oasis.opendocument.spreadsheet-template"],
	["ott", "application/vnd.oasis.opendocument.text-template"],
	["ova", "application/x-virtualbox-ova"],
	["ovf", "application/x-virtualbox-ovf"],
	["owl", "application/rdf+xml"],
	["oxps", "application/oxps"],
	["oxt", "application/vnd.openofficeorg.extension"],
	["p", "text/x-pascal"],
	["p7a", "application/x-pkcs7-signature"],
	["p7b", "application/x-pkcs7-certificates"],
	["p7c", "application/pkcs7-mime"],
	["p7m", "application/pkcs7-mime"],
	["p7r", "application/x-pkcs7-certreqresp"],
	["p7s", "application/pkcs7-signature"],
	["p8", "application/pkcs8"],
	["p10", "application/x-pkcs10"],
	["p12", "application/x-pkcs12"],
	["pac", "application/x-ns-proxy-autoconfig"],
	["pages", "application/x-iwork-pages-sffpages"],
	["pas", "text/x-pascal"],
	["paw", "application/vnd.pawaafile"],
	["pbd", "application/vnd.powerbuilder6"],
	["pbm", "image/x-portable-bitmap"],
	["pcap", "application/vnd.tcpdump.pcap"],
	["pcf", "application/x-font-pcf"],
	["pcl", "application/vnd.hp-pcl"],
	["pclxl", "application/vnd.hp-pclxl"],
	["pct", "image/x-pict"],
	["pcurl", "application/vnd.curl.pcurl"],
	["pcx", "image/x-pcx"],
	["pdb", "application/x-pilot"],
	["pde", "text/x-processing"],
	["pdf", "application/pdf"],
	["pem", "application/x-x509-user-cert"],
	["pfa", "application/x-font-type1"],
	["pfb", "application/x-font-type1"],
	["pfm", "application/x-font-type1"],
	["pfr", "application/font-tdpfr"],
	["pfx", "application/x-pkcs12"],
	["pgm", "image/x-portable-graymap"],
	["pgn", "application/x-chess-pgn"],
	["pgp", "application/pgp"],
	["php", "application/x-httpd-php"],
	["php3", "application/x-httpd-php"],
	["php4", "application/x-httpd-php"],
	["phps", "application/x-httpd-php-source"],
	["phtml", "application/x-httpd-php"],
	["pic", "image/x-pict"],
	["pkg", "application/octet-stream"],
	["pki", "application/pkixcmp"],
	["pkipath", "application/pkix-pkipath"],
	["pkpass", "application/vnd.apple.pkpass"],
	["pl", "application/x-perl"],
	["plb", "application/vnd.3gpp.pic-bw-large"],
	["plc", "application/vnd.mobius.plc"],
	["plf", "application/vnd.pocketlearn"],
	["pls", "application/pls+xml"],
	["pm", "application/x-perl"],
	["pml", "application/vnd.ctc-posml"],
	["png", "image/png"],
	["pnm", "image/x-portable-anymap"],
	["portpkg", "application/vnd.macports.portpkg"],
	["pot", "application/vnd.ms-powerpoint"],
	["potm", "application/vnd.ms-powerpoint.presentation.macroEnabled.12"],
	["potx", "application/vnd.openxmlformats-officedocument.presentationml.template"],
	["ppa", "application/vnd.ms-powerpoint"],
	["ppam", "application/vnd.ms-powerpoint.addin.macroEnabled.12"],
	["ppd", "application/vnd.cups-ppd"],
	["ppm", "image/x-portable-pixmap"],
	["pps", "application/vnd.ms-powerpoint"],
	["ppsm", "application/vnd.ms-powerpoint.slideshow.macroEnabled.12"],
	["ppsx", "application/vnd.openxmlformats-officedocument.presentationml.slideshow"],
	["ppt", "application/powerpoint"],
	["pptm", "application/vnd.ms-powerpoint.presentation.macroEnabled.12"],
	["pptx", "application/vnd.openxmlformats-officedocument.presentationml.presentation"],
	["pqa", "application/vnd.palm"],
	["prc", "application/x-pilot"],
	["pre", "application/vnd.lotus-freelance"],
	["prf", "application/pics-rules"],
	["provx", "application/provenance+xml"],
	["ps", "application/postscript"],
	["psb", "application/vnd.3gpp.pic-bw-small"],
	["psd", "application/x-photoshop"],
	["psf", "application/x-font-linux-psf"],
	["pskcxml", "application/pskc+xml"],
	["pti", "image/prs.pti"],
	["ptid", "application/vnd.pvi.ptid1"],
	["pub", "application/x-mspublisher"],
	["pvb", "application/vnd.3gpp.pic-bw-var"],
	["pwn", "application/vnd.3m.post-it-notes"],
	["pya", "audio/vnd.ms-playready.media.pya"],
	["pyv", "video/vnd.ms-playready.media.pyv"],
	["qam", "application/vnd.epson.quickanime"],
	["qbo", "application/vnd.intu.qbo"],
	["qfx", "application/vnd.intu.qfx"],
	["qps", "application/vnd.publishare-delta-tree"],
	["qt", "video/quicktime"],
	["qwd", "application/vnd.quark.quarkxpress"],
	["qwt", "application/vnd.quark.quarkxpress"],
	["qxb", "application/vnd.quark.quarkxpress"],
	["qxd", "application/vnd.quark.quarkxpress"],
	["qxl", "application/vnd.quark.quarkxpress"],
	["qxt", "application/vnd.quark.quarkxpress"],
	["ra", "audio/x-realaudio"],
	["ram", "audio/x-pn-realaudio"],
	["raml", "application/raml+yaml"],
	["rapd", "application/route-apd+xml"],
	["rar", "application/x-rar"],
	["ras", "image/x-cmu-raster"],
	["rcprofile", "application/vnd.ipunplugged.rcprofile"],
	["rdf", "application/rdf+xml"],
	["rdz", "application/vnd.data-vision.rdz"],
	["relo", "application/p2p-overlay+xml"],
	["rep", "application/vnd.businessobjects"],
	["res", "application/x-dtbresource+xml"],
	["rgb", "image/x-rgb"],
	["rif", "application/reginfo+xml"],
	["rip", "audio/vnd.rip"],
	["ris", "application/x-research-info-systems"],
	["rl", "application/resource-lists+xml"],
	["rlc", "image/vnd.fujixerox.edmics-rlc"],
	["rld", "application/resource-lists-diff+xml"],
	["rm", "audio/x-pn-realaudio"],
	["rmi", "audio/midi"],
	["rmp", "audio/x-pn-realaudio-plugin"],
	["rms", "application/vnd.jcp.javame.midlet-rms"],
	["rmvb", "application/vnd.rn-realmedia-vbr"],
	["rnc", "application/relax-ng-compact-syntax"],
	["rng", "application/xml"],
	["roa", "application/rpki-roa"],
	["roff", "text/troff"],
	["rp9", "application/vnd.cloanto.rp9"],
	["rpm", "audio/x-pn-realaudio-plugin"],
	["rpss", "application/vnd.nokia.radio-presets"],
	["rpst", "application/vnd.nokia.radio-preset"],
	["rq", "application/sparql-query"],
	["rs", "application/rls-services+xml"],
	["rsa", "application/x-pkcs7"],
	["rsat", "application/atsc-rsat+xml"],
	["rsd", "application/rsd+xml"],
	["rsheet", "application/urc-ressheet+xml"],
	["rss", "application/rss+xml"],
	["rtf", "text/rtf"],
	["rtx", "text/richtext"],
	["run", "application/x-makeself"],
	["rusd", "application/route-usd+xml"],
	["rv", "video/vnd.rn-realvideo"],
	["s", "text/x-asm"],
	["s3m", "audio/s3m"],
	["saf", "application/vnd.yamaha.smaf-audio"],
	["sass", "text/x-sass"],
	["sbml", "application/sbml+xml"],
	["sc", "application/vnd.ibm.secure-container"],
	["scd", "application/x-msschedule"],
	["scm", "application/vnd.lotus-screencam"],
	["scq", "application/scvp-cv-request"],
	["scs", "application/scvp-cv-response"],
	["scss", "text/x-scss"],
	["scurl", "text/vnd.curl.scurl"],
	["sda", "application/vnd.stardivision.draw"],
	["sdc", "application/vnd.stardivision.calc"],
	["sdd", "application/vnd.stardivision.impress"],
	["sdkd", "application/vnd.solent.sdkm+xml"],
	["sdkm", "application/vnd.solent.sdkm+xml"],
	["sdp", "application/sdp"],
	["sdw", "application/vnd.stardivision.writer"],
	["sea", "application/octet-stream"],
	["see", "application/vnd.seemail"],
	["seed", "application/vnd.fdsn.seed"],
	["sema", "application/vnd.sema"],
	["semd", "application/vnd.semd"],
	["semf", "application/vnd.semf"],
	["senmlx", "application/senml+xml"],
	["sensmlx", "application/sensml+xml"],
	["ser", "application/java-serialized-object"],
	["setpay", "application/set-payment-initiation"],
	["setreg", "application/set-registration-initiation"],
	["sfd-hdstx", "application/vnd.hydrostatix.sof-data"],
	["sfs", "application/vnd.spotfire.sfs"],
	["sfv", "text/x-sfv"],
	["sgi", "image/sgi"],
	["sgl", "application/vnd.stardivision.writer-global"],
	["sgm", "text/sgml"],
	["sgml", "text/sgml"],
	["sh", "application/x-sh"],
	["shar", "application/x-shar"],
	["shex", "text/shex"],
	["shf", "application/shf+xml"],
	["shtml", "text/html"],
	["sid", "image/x-mrsid-image"],
	["sieve", "application/sieve"],
	["sig", "application/pgp-signature"],
	["sil", "audio/silk"],
	["silo", "model/mesh"],
	["sis", "application/vnd.symbian.install"],
	["sisx", "application/vnd.symbian.install"],
	["sit", "application/x-stuffit"],
	["sitx", "application/x-stuffitx"],
	["siv", "application/sieve"],
	["skd", "application/vnd.koan"],
	["skm", "application/vnd.koan"],
	["skp", "application/vnd.koan"],
	["skt", "application/vnd.koan"],
	["sldm", "application/vnd.ms-powerpoint.slide.macroenabled.12"],
	["sldx", "application/vnd.openxmlformats-officedocument.presentationml.slide"],
	["slim", "text/slim"],
	["slm", "text/slim"],
	["sls", "application/route-s-tsid+xml"],
	["slt", "application/vnd.epson.salt"],
	["sm", "application/vnd.stepmania.stepchart"],
	["smf", "application/vnd.stardivision.math"],
	["smi", "application/smil"],
	["smil", "application/smil"],
	["smv", "video/x-smv"],
	["smzip", "application/vnd.stepmania.package"],
	["snd", "audio/basic"],
	["snf", "application/x-font-snf"],
	["so", "application/octet-stream"],
	["spc", "application/x-pkcs7-certificates"],
	["spdx", "text/spdx"],
	["spf", "application/vnd.yamaha.smaf-phrase"],
	["spl", "application/x-futuresplash"],
	["spot", "text/vnd.in3d.spot"],
	["spp", "application/scvp-vp-response"],
	["spq", "application/scvp-vp-request"],
	["spx", "audio/ogg"],
	["sql", "application/x-sql"],
	["src", "application/x-wais-source"],
	["srt", "application/x-subrip"],
	["sru", "application/sru+xml"],
	["srx", "application/sparql-results+xml"],
	["ssdl", "application/ssdl+xml"],
	["sse", "application/vnd.kodak-descriptor"],
	["ssf", "application/vnd.epson.ssf"],
	["ssml", "application/ssml+xml"],
	["sst", "application/octet-stream"],
	["st", "application/vnd.sailingtracker.track"],
	["stc", "application/vnd.sun.xml.calc.template"],
	["std", "application/vnd.sun.xml.draw.template"],
	["stf", "application/vnd.wt.stf"],
	["sti", "application/vnd.sun.xml.impress.template"],
	["stk", "application/hyperstudio"],
	["stl", "model/stl"],
	["stpx", "model/step+xml"],
	["stpxz", "model/step-xml+zip"],
	["stpz", "model/step+zip"],
	["str", "application/vnd.pg.format"],
	["stw", "application/vnd.sun.xml.writer.template"],
	["styl", "text/stylus"],
	["stylus", "text/stylus"],
	["sub", "text/vnd.dvb.subtitle"],
	["sus", "application/vnd.sus-calendar"],
	["susp", "application/vnd.sus-calendar"],
	["sv4cpio", "application/x-sv4cpio"],
	["sv4crc", "application/x-sv4crc"],
	["svc", "application/vnd.dvb.service"],
	["svd", "application/vnd.svd"],
	["svg", "image/svg+xml"],
	["svgz", "image/svg+xml"],
	["swa", "application/x-director"],
	["swf", "application/x-shockwave-flash"],
	["swi", "application/vnd.aristanetworks.swi"],
	["swidtag", "application/swid+xml"],
	["sxc", "application/vnd.sun.xml.calc"],
	["sxd", "application/vnd.sun.xml.draw"],
	["sxg", "application/vnd.sun.xml.writer.global"],
	["sxi", "application/vnd.sun.xml.impress"],
	["sxm", "application/vnd.sun.xml.math"],
	["sxw", "application/vnd.sun.xml.writer"],
	["t", "text/troff"],
	["t3", "application/x-t3vm-image"],
	["t38", "image/t38"],
	["taglet", "application/vnd.mynfc"],
	["tao", "application/vnd.tao.intent-module-archive"],
	["tap", "image/vnd.tencent.tap"],
	["tar", "application/x-tar"],
	["tcap", "application/vnd.3gpp2.tcap"],
	["tcl", "application/x-tcl"],
	["td", "application/urc-targetdesc+xml"],
	["teacher", "application/vnd.smart.teacher"],
	["tei", "application/tei+xml"],
	["teicorpus", "application/tei+xml"],
	["tex", "application/x-tex"],
	["texi", "application/x-texinfo"],
	["texinfo", "application/x-texinfo"],
	["text", "text/plain"],
	["tfi", "application/thraud+xml"],
	["tfm", "application/x-tex-tfm"],
	["tfx", "image/tiff-fx"],
	["tga", "image/x-tga"],
	["tgz", "application/x-tar"],
	["thmx", "application/vnd.ms-officetheme"],
	["tif", "image/tiff"],
	["tiff", "image/tiff"],
	["tk", "application/x-tcl"],
	["tmo", "application/vnd.tmobile-livetv"],
	["toml", "application/toml"],
	["torrent", "application/x-bittorrent"],
	["tpl", "application/vnd.groove-tool-template"],
	["tpt", "application/vnd.trid.tpt"],
	["tr", "text/troff"],
	["tra", "application/vnd.trueapp"],
	["trig", "application/trig"],
	["trm", "application/x-msterminal"],
	["ts", "video/mp2t"],
	["tsd", "application/timestamped-data"],
	["tsv", "text/tab-separated-values"],
	["ttc", "font/collection"],
	["ttf", "font/ttf"],
	["ttl", "text/turtle"],
	["ttml", "application/ttml+xml"],
	["twd", "application/vnd.simtech-mindmapper"],
	["twds", "application/vnd.simtech-mindmapper"],
	["txd", "application/vnd.genomatix.tuxedo"],
	["txf", "application/vnd.mobius.txf"],
	["txt", "text/plain"],
	["u8dsn", "message/global-delivery-status"],
	["u8hdr", "message/global-headers"],
	["u8mdn", "message/global-disposition-notification"],
	["u8msg", "message/global"],
	["u32", "application/x-authorware-bin"],
	["ubj", "application/ubjson"],
	["udeb", "application/x-debian-package"],
	["ufd", "application/vnd.ufdl"],
	["ufdl", "application/vnd.ufdl"],
	["ulx", "application/x-glulx"],
	["umj", "application/vnd.umajin"],
	["unityweb", "application/vnd.unity"],
	["uoml", "application/vnd.uoml+xml"],
	["uri", "text/uri-list"],
	["uris", "text/uri-list"],
	["urls", "text/uri-list"],
	["usdz", "model/vnd.usdz+zip"],
	["ustar", "application/x-ustar"],
	["utz", "application/vnd.uiq.theme"],
	["uu", "text/x-uuencode"],
	["uva", "audio/vnd.dece.audio"],
	["uvd", "application/vnd.dece.data"],
	["uvf", "application/vnd.dece.data"],
	["uvg", "image/vnd.dece.graphic"],
	["uvh", "video/vnd.dece.hd"],
	["uvi", "image/vnd.dece.graphic"],
	["uvm", "video/vnd.dece.mobile"],
	["uvp", "video/vnd.dece.pd"],
	["uvs", "video/vnd.dece.sd"],
	["uvt", "application/vnd.dece.ttml+xml"],
	["uvu", "video/vnd.uvvu.mp4"],
	["uvv", "video/vnd.dece.video"],
	["uvva", "audio/vnd.dece.audio"],
	["uvvd", "application/vnd.dece.data"],
	["uvvf", "application/vnd.dece.data"],
	["uvvg", "image/vnd.dece.graphic"],
	["uvvh", "video/vnd.dece.hd"],
	["uvvi", "image/vnd.dece.graphic"],
	["uvvm", "video/vnd.dece.mobile"],
	["uvvp", "video/vnd.dece.pd"],
	["uvvs", "video/vnd.dece.sd"],
	["uvvt", "application/vnd.dece.ttml+xml"],
	["uvvu", "video/vnd.uvvu.mp4"],
	["uvvv", "video/vnd.dece.video"],
	["uvvx", "application/vnd.dece.unspecified"],
	["uvvz", "application/vnd.dece.zip"],
	["uvx", "application/vnd.dece.unspecified"],
	["uvz", "application/vnd.dece.zip"],
	["vbox", "application/x-virtualbox-vbox"],
	["vbox-extpack", "application/x-virtualbox-vbox-extpack"],
	["vcard", "text/vcard"],
	["vcd", "application/x-cdlink"],
	["vcf", "text/x-vcard"],
	["vcg", "application/vnd.groove-vcard"],
	["vcs", "text/x-vcalendar"],
	["vcx", "application/vnd.vcx"],
	["vdi", "application/x-virtualbox-vdi"],
	["vds", "model/vnd.sap.vds"],
	["vhd", "application/x-virtualbox-vhd"],
	["vis", "application/vnd.visionary"],
	["viv", "video/vnd.vivo"],
	["vlc", "application/videolan"],
	["vmdk", "application/x-virtualbox-vmdk"],
	["vob", "video/x-ms-vob"],
	["vor", "application/vnd.stardivision.writer"],
	["vox", "application/x-authorware-bin"],
	["vrml", "model/vrml"],
	["vsd", "application/vnd.visio"],
	["vsf", "application/vnd.vsf"],
	["vss", "application/vnd.visio"],
	["vst", "application/vnd.visio"],
	["vsw", "application/vnd.visio"],
	["vtf", "image/vnd.valve.source.texture"],
	["vtt", "text/vtt"],
	["vtu", "model/vnd.vtu"],
	["vxml", "application/voicexml+xml"],
	["w3d", "application/x-director"],
	["wad", "application/x-doom"],
	["wadl", "application/vnd.sun.wadl+xml"],
	["war", "application/java-archive"],
	["wasm", "application/wasm"],
	["wav", "audio/x-wav"],
	["wax", "audio/x-ms-wax"],
	["wbmp", "image/vnd.wap.wbmp"],
	["wbs", "application/vnd.criticaltools.wbs+xml"],
	["wbxml", "application/wbxml"],
	["wcm", "application/vnd.ms-works"],
	["wdb", "application/vnd.ms-works"],
	["wdp", "image/vnd.ms-photo"],
	["weba", "audio/webm"],
	["webapp", "application/x-web-app-manifest+json"],
	["webm", "video/webm"],
	["webmanifest", "application/manifest+json"],
	["webp", "image/webp"],
	["wg", "application/vnd.pmi.widget"],
	["wgt", "application/widget"],
	["wks", "application/vnd.ms-works"],
	["wm", "video/x-ms-wm"],
	["wma", "audio/x-ms-wma"],
	["wmd", "application/x-ms-wmd"],
	["wmf", "image/wmf"],
	["wml", "text/vnd.wap.wml"],
	["wmlc", "application/wmlc"],
	["wmls", "text/vnd.wap.wmlscript"],
	["wmlsc", "application/vnd.wap.wmlscriptc"],
	["wmv", "video/x-ms-wmv"],
	["wmx", "video/x-ms-wmx"],
	["wmz", "application/x-msmetafile"],
	["woff", "font/woff"],
	["woff2", "font/woff2"],
	["word", "application/msword"],
	["wpd", "application/vnd.wordperfect"],
	["wpl", "application/vnd.ms-wpl"],
	["wps", "application/vnd.ms-works"],
	["wqd", "application/vnd.wqd"],
	["wri", "application/x-mswrite"],
	["wrl", "model/vrml"],
	["wsc", "message/vnd.wfa.wsc"],
	["wsdl", "application/wsdl+xml"],
	["wspolicy", "application/wspolicy+xml"],
	["wtb", "application/vnd.webturbo"],
	["wvx", "video/x-ms-wvx"],
	["x3d", "model/x3d+xml"],
	["x3db", "model/x3d+fastinfoset"],
	["x3dbz", "model/x3d+binary"],
	["x3dv", "model/x3d-vrml"],
	["x3dvz", "model/x3d+vrml"],
	["x3dz", "model/x3d+xml"],
	["x32", "application/x-authorware-bin"],
	["x_b", "model/vnd.parasolid.transmit.binary"],
	["x_t", "model/vnd.parasolid.transmit.text"],
	["xaml", "application/xaml+xml"],
	["xap", "application/x-silverlight-app"],
	["xar", "application/vnd.xara"],
	["xav", "application/xcap-att+xml"],
	["xbap", "application/x-ms-xbap"],
	["xbd", "application/vnd.fujixerox.docuworks.binder"],
	["xbm", "image/x-xbitmap"],
	["xca", "application/xcap-caps+xml"],
	["xcs", "application/calendar+xml"],
	["xdf", "application/xcap-diff+xml"],
	["xdm", "application/vnd.syncml.dm+xml"],
	["xdp", "application/vnd.adobe.xdp+xml"],
	["xdssc", "application/dssc+xml"],
	["xdw", "application/vnd.fujixerox.docuworks"],
	["xel", "application/xcap-el+xml"],
	["xenc", "application/xenc+xml"],
	["xer", "application/patch-ops-error+xml"],
	["xfdf", "application/vnd.adobe.xfdf"],
	["xfdl", "application/vnd.xfdl"],
	["xht", "application/xhtml+xml"],
	["xhtml", "application/xhtml+xml"],
	["xhvml", "application/xv+xml"],
	["xif", "image/vnd.xiff"],
	["xl", "application/excel"],
	["xla", "application/vnd.ms-excel"],
	["xlam", "application/vnd.ms-excel.addin.macroEnabled.12"],
	["xlc", "application/vnd.ms-excel"],
	["xlf", "application/xliff+xml"],
	["xlm", "application/vnd.ms-excel"],
	["xls", "application/vnd.ms-excel"],
	["xlsb", "application/vnd.ms-excel.sheet.binary.macroEnabled.12"],
	["xlsm", "application/vnd.ms-excel.sheet.macroEnabled.12"],
	["xlsx", "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"],
	["xlt", "application/vnd.ms-excel"],
	["xltm", "application/vnd.ms-excel.template.macroEnabled.12"],
	["xltx", "application/vnd.openxmlformats-officedocument.spreadsheetml.template"],
	["xlw", "application/vnd.ms-excel"],
	["xm", "audio/xm"],
	["xml", "application/xml"],
	["xns", "application/xcap-ns+xml"],
	["xo", "application/vnd.olpc-sugar"],
	["xop", "application/xop+xml"],
	["xpi", "application/x-xpinstall"],
	["xpl", "application/xproc+xml"],
	["xpm", "image/x-xpixmap"],
	["xpr", "application/vnd.is-xpr"],
	["xps", "application/vnd.ms-xpsdocument"],
	["xpw", "application/vnd.intercon.formnet"],
	["xpx", "application/vnd.intercon.formnet"],
	["xsd", "application/xml"],
	["xsl", "application/xml"],
	["xslt", "application/xslt+xml"],
	["xsm", "application/vnd.syncml+xml"],
	["xspf", "application/xspf+xml"],
	["xul", "application/vnd.mozilla.xul+xml"],
	["xvm", "application/xv+xml"],
	["xvml", "application/xv+xml"],
	["xwd", "image/x-xwindowdump"],
	["xyz", "chemical/x-xyz"],
	["xz", "application/x-xz"],
	["yaml", "text/yaml"],
	["yang", "application/yang"],
	["yin", "application/yin+xml"],
	["yml", "text/yaml"],
	["ymp", "text/x-suse-ymp"],
	["z", "application/x-compress"],
	["z1", "application/x-zmachine"],
	["z2", "application/x-zmachine"],
	["z3", "application/x-zmachine"],
	["z4", "application/x-zmachine"],
	["z5", "application/x-zmachine"],
	["z6", "application/x-zmachine"],
	["z7", "application/x-zmachine"],
	["z8", "application/x-zmachine"],
	["zaz", "application/vnd.zzazz.deck+xml"],
	["zip", "application/zip"],
	["zir", "application/vnd.zul"],
	["zirz", "application/vnd.zul"],
	["zmm", "application/vnd.handheld-entertainment+xml"],
	["zsh", "text/x-scriptzsh"]
]);
function Zo(e, t, n) {
	let r = Qo(e), { webkitRelativePath: i } = e, a = typeof t == "string" ? t : typeof i == "string" && i.length > 0 ? i : `./${e.name}`;
	return typeof r.path != "string" && $o(r, "path", a), n !== void 0 && Object.defineProperty(r, "handle", {
		value: n,
		writable: !1,
		configurable: !1,
		enumerable: !0
	}), $o(r, "relativePath", a), r;
}
function Qo(e) {
	let { name: t } = e;
	if (t && t.lastIndexOf(".") !== -1 && !e.type) {
		let n = t.split(".").pop().toLowerCase(), r = Xo.get(n);
		r && Object.defineProperty(e, "type", {
			value: r,
			writable: !1,
			configurable: !1,
			enumerable: !0
		});
	}
	return e;
}
function $o(e, t, n) {
	Object.defineProperty(e, t, {
		value: n,
		writable: !1,
		configurable: !1,
		enumerable: !0
	});
}
//#endregion
//#region ../node_modules/file-selector/dist/es2015/file-selector.js
var es = [".DS_Store", "Thumbs.db"];
function ts(e) {
	return Yo(this, void 0, void 0, function* () {
		return is(e) && ns(e.dataTransfer) ? ss(e.dataTransfer, e.type) : rs(e) ? as(e) : Array.isArray(e) && e.every((e) => "getFile" in e && typeof e.getFile == "function") ? os(e) : [];
	});
}
function ns(e) {
	return is(e);
}
function rs(e) {
	return is(e) && is(e.target);
}
function is(e) {
	return typeof e == "object" && !!e;
}
function as(e) {
	return ls(e.target.files).map((e) => Zo(e));
}
function os(e) {
	return Yo(this, void 0, void 0, function* () {
		return (yield Promise.all(e.map((e) => e.getFile()))).map((e) => Zo(e));
	});
}
function ss(e, t) {
	return Yo(this, void 0, void 0, function* () {
		if (e.items) {
			let n = ls(e.items).filter((e) => e.kind === "file");
			return t === "drop" ? cs(ds(yield Promise.all(n.map(us)))) : n;
		}
		return cs(ls(e.files).map((e) => Zo(e)));
	});
}
function cs(e) {
	return e.filter((e) => es.indexOf(e.name) === -1);
}
function ls(e) {
	if (e === null) return [];
	let t = [];
	for (let n = 0; n < e.length; n++) {
		let r = e[n];
		t.push(r);
	}
	return t;
}
function us(e) {
	if (typeof e.webkitGetAsEntry != "function") return fs(e);
	let t = e.webkitGetAsEntry();
	return t && t.isDirectory ? ms(t) : fs(e, t);
}
function ds(e) {
	return e.reduce((e, t) => [...e, ...Array.isArray(t) ? ds(t) : [t]], []);
}
function fs(e, t) {
	return Yo(this, void 0, void 0, function* () {
		if (globalThis.isSecureContext && typeof e.getAsFileSystemHandle == "function") {
			let t = yield e.getAsFileSystemHandle();
			if (t === null) throw Error(`${e} is not a File`);
			if (t !== void 0) {
				let e = yield t.getFile();
				return e.handle = t, Zo(e);
			}
		}
		let n = e.getAsFile();
		if (!n) throw Error(`${e} is not a File`);
		return Zo(n, t?.fullPath ?? void 0);
	});
}
function ps(e) {
	return Yo(this, void 0, void 0, function* () {
		return e.isDirectory ? ms(e) : hs(e);
	});
}
function ms(e) {
	let t = e.createReader();
	return new Promise((e, n) => {
		let r = [];
		function i() {
			t.readEntries((t) => Yo(this, void 0, void 0, function* () {
				if (t.length) {
					let e = Promise.all(t.map(ps));
					r.push(e), i();
				} else try {
					e(yield Promise.all(r));
				} catch (e) {
					n(e);
				}
			}), (e) => {
				n(e);
			});
		}
		i();
	});
}
function hs(e) {
	return Yo(this, void 0, void 0, function* () {
		return new Promise((t, n) => {
			e.file((n) => {
				t(Zo(n, e.fullPath));
			}, (e) => {
				n(e);
			});
		});
	});
}
//#endregion
//#region ../node_modules/react-dropzone/dist/es/utils/index.js
var gs = /* @__PURE__ */ cr((/* @__PURE__ */ or(((e) => {
	e.__esModule = !0, e.default = function(e, t) {
		if (e && t) {
			var n = Array.isArray(t) ? t : t.split(",");
			if (n.length === 0) return !0;
			var r = e.name || "", i = (e.type || "").toLowerCase(), a = i.replace(/\/.*$/, "");
			return n.some(function(e) {
				var t = e.trim().toLowerCase();
				return t.charAt(0) === "." ? r.toLowerCase().endsWith(t) : t.endsWith("/*") ? a === t.replace(/\/.*$/, "") : i === t;
			});
		}
		return !0;
	};
})))());
function _s(e) {
	return bs(e) || ys(e) || Es(e) || vs();
}
function vs() {
	throw TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function ys(e) {
	if (typeof Symbol < "u" && e[Symbol.iterator] != null || e["@@iterator"] != null) return Array.from(e);
}
function bs(e) {
	if (Array.isArray(e)) return Ds(e);
}
function xs(e, t) {
	var n = Object.keys(e);
	if (Object.getOwnPropertySymbols) {
		var r = Object.getOwnPropertySymbols(e);
		t && (r = r.filter(function(t) {
			return Object.getOwnPropertyDescriptor(e, t).enumerable;
		})), n.push.apply(n, r);
	}
	return n;
}
function Ss(e) {
	for (var t = 1; t < arguments.length; t++) {
		var n = arguments[t] == null ? {} : arguments[t];
		t % 2 ? xs(Object(n), !0).forEach(function(t) {
			Cs(e, t, n[t]);
		}) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : xs(Object(n)).forEach(function(t) {
			Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
		});
	}
	return e;
}
function Cs(e, t, n) {
	return t in e ? Object.defineProperty(e, t, {
		value: n,
		enumerable: !0,
		configurable: !0,
		writable: !0
	}) : e[t] = n, e;
}
function ws(e, t) {
	return ks(e) || Os(e, t) || Es(e, t) || Ts();
}
function Ts() {
	throw TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function Es(e, t) {
	if (e) {
		if (typeof e == "string") return Ds(e, t);
		var n = Object.prototype.toString.call(e).slice(8, -1);
		if (n === "Object" && e.constructor && (n = e.constructor.name), n === "Map" || n === "Set") return Array.from(e);
		if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return Ds(e, t);
	}
}
function Ds(e, t) {
	(t == null || t > e.length) && (t = e.length);
	for (var n = 0, r = Array(t); n < t; n++) r[n] = e[n];
	return r;
}
function Os(e, t) {
	var n = e == null ? null : typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
	if (n != null) {
		var r = [], i = !0, a = !1, o, s;
		try {
			for (n = n.call(e); !(i = (o = n.next()).done) && (r.push(o.value), !(t && r.length === t)); i = !0);
		} catch (e) {
			a = !0, s = e;
		} finally {
			try {
				!i && n.return != null && n.return();
			} finally {
				if (a) throw s;
			}
		}
		return r;
	}
}
function ks(e) {
	if (Array.isArray(e)) return e;
}
var As = typeof gs.default == "function" ? gs.default : gs.default.default, js = "file-invalid-type", Ms = "file-too-large", Ns = "file-too-small", Ps = "too-many-files", Fs = function() {
	var e = (arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "").split(",");
	return {
		code: js,
		message: `File type must be ${e.length > 1 ? `one of ${e.join(", ")}` : e[0]}`
	};
}, Is = function(e) {
	return {
		code: Ms,
		message: `File is larger than ${e} ${e === 1 ? "byte" : "bytes"}`
	};
}, Ls = function(e) {
	return {
		code: Ns,
		message: `File is smaller than ${e} ${e === 1 ? "byte" : "bytes"}`
	};
}, Rs = {
	code: Ps,
	message: "Too many files"
};
function zs(e) {
	return e.type === "" && typeof e.getAsFile == "function";
}
function Bs(e, t) {
	var n = e.type === "application/x-moz-file" || As(e, t) || zs(e);
	return [n, n ? null : Fs(t)];
}
function Vs(e, t, n) {
	if (Hs(e.size)) {
		if (Hs(t) && Hs(n)) {
			if (e.size > n) return [!1, Is(n)];
			if (e.size < t) return [!1, Ls(t)];
		} else if (Hs(t) && e.size < t) return [!1, Ls(t)];
		else if (Hs(n) && e.size > n) return [!1, Is(n)];
	}
	return [!0, null];
}
function Hs(e) {
	return e != null;
}
function Us(e) {
	var t = e.files, n = e.accept, r = e.minSize, i = e.maxSize, a = e.multiple, o = e.maxFiles, s = e.validator;
	return !a && t.length > 1 || a && o >= 1 && t.length > o ? !1 : t.every(function(e) {
		var t = ws(Bs(e, n), 1)[0], a = ws(Vs(e, r, i), 1)[0], o = s ? s(e) : null;
		return t && a && !o;
	});
}
function Ws(e) {
	return typeof e.isPropagationStopped == "function" ? e.isPropagationStopped() : e.cancelBubble === void 0 ? !1 : e.cancelBubble;
}
function Gs(e) {
	return e.dataTransfer ? Array.prototype.some.call(e.dataTransfer.types, function(e) {
		return e === "Files" || e === "application/x-moz-file";
	}) : !!e.target && !!e.target.files;
}
function Ks(e) {
	e.preventDefault();
}
function qs(e) {
	return e.indexOf("MSIE") !== -1 || e.indexOf("Trident/") !== -1;
}
function Js(e) {
	return e.indexOf("Edge/") !== -1;
}
function Ys() {
	var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : window.navigator.userAgent;
	return qs(e) || Js(e);
}
function Xs() {
	var e = [...arguments];
	return function(t) {
		var n = [...arguments].slice(1);
		return e.some(function(e) {
			return !Ws(t) && e && e.apply(void 0, [t].concat(n)), Ws(t);
		});
	};
}
function Zs() {
	return "showOpenFilePicker" in window;
}
function Qs(e) {
	return Hs(e) ? [{
		description: "Files",
		accept: Object.entries(e).filter(function(e) {
			var t = ws(e, 2), n = t[0], r = t[1], i = !0;
			return nc(n) || (console.warn(`Skipped "${n}" because it is not a valid MIME type. Check https://developer.mozilla.org/en-US/docs/Web/HTTP/Basics_of_HTTP/MIME_types/Common_types for a list of valid MIME types.`), i = !1), (!Array.isArray(r) || !r.every(rc)) && (console.warn(`Skipped "${n}" because an invalid file extension was provided.`), i = !1), i;
		}).reduce(function(e, t) {
			var n = ws(t, 2), r = n[0], i = n[1];
			return Ss(Ss({}, e), {}, Cs({}, r, i));
		}, {})
	}] : e;
}
function $s(e) {
	if (Hs(e)) return Object.entries(e).reduce(function(e, t) {
		var n = ws(t, 2), r = n[0], i = n[1];
		return [].concat(_s(e), [r], _s(i));
	}, []).filter(function(e) {
		return nc(e) || rc(e);
	}).join(",");
}
function ec(e) {
	return e instanceof DOMException && (e.name === "AbortError" || e.code === e.ABORT_ERR);
}
function tc(e) {
	return e instanceof DOMException && (e.name === "SecurityError" || e.code === e.SECURITY_ERR);
}
function nc(e) {
	return e === "audio/*" || e === "video/*" || e === "image/*" || e === "text/*" || e === "application/*" || /\w+\/[-+.\w]+/g.test(e);
}
function rc(e) {
	return /^.*\.[\w]+$/.test(e);
}
//#endregion
//#region ../node_modules/react-dropzone/dist/es/index.js
var Q = /* @__PURE__ */ cr(Jo()), ic = ["children"], ac = ["open"], oc = [
	"refKey",
	"role",
	"onKeyDown",
	"onFocus",
	"onBlur",
	"onClick",
	"onDragEnter",
	"onDragOver",
	"onDragLeave",
	"onDrop"
], sc = [
	"refKey",
	"onChange",
	"onClick"
];
function cc(e) {
	return dc(e) || uc(e) || mc(e) || lc();
}
function lc() {
	throw TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function uc(e) {
	if (typeof Symbol < "u" && e[Symbol.iterator] != null || e["@@iterator"] != null) return Array.from(e);
}
function dc(e) {
	if (Array.isArray(e)) return hc(e);
}
function fc(e, t) {
	return _c(e) || gc(e, t) || mc(e, t) || pc();
}
function pc() {
	throw TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function mc(e, t) {
	if (e) {
		if (typeof e == "string") return hc(e, t);
		var n = Object.prototype.toString.call(e).slice(8, -1);
		if (n === "Object" && e.constructor && (n = e.constructor.name), n === "Map" || n === "Set") return Array.from(e);
		if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return hc(e, t);
	}
}
function hc(e, t) {
	(t == null || t > e.length) && (t = e.length);
	for (var n = 0, r = Array(t); n < t; n++) r[n] = e[n];
	return r;
}
function gc(e, t) {
	var n = e == null ? null : typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
	if (n != null) {
		var r = [], i = !0, a = !1, o, s;
		try {
			for (n = n.call(e); !(i = (o = n.next()).done) && (r.push(o.value), !(t && r.length === t)); i = !0);
		} catch (e) {
			a = !0, s = e;
		} finally {
			try {
				!i && n.return != null && n.return();
			} finally {
				if (a) throw s;
			}
		}
		return r;
	}
}
function _c(e) {
	if (Array.isArray(e)) return e;
}
function vc(e, t) {
	var n = Object.keys(e);
	if (Object.getOwnPropertySymbols) {
		var r = Object.getOwnPropertySymbols(e);
		t && (r = r.filter(function(t) {
			return Object.getOwnPropertyDescriptor(e, t).enumerable;
		})), n.push.apply(n, r);
	}
	return n;
}
function $(e) {
	for (var t = 1; t < arguments.length; t++) {
		var n = arguments[t] == null ? {} : arguments[t];
		t % 2 ? vc(Object(n), !0).forEach(function(t) {
			yc(e, t, n[t]);
		}) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : vc(Object(n)).forEach(function(t) {
			Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
		});
	}
	return e;
}
function yc(e, t, n) {
	return t in e ? Object.defineProperty(e, t, {
		value: n,
		enumerable: !0,
		configurable: !0,
		writable: !0
	}) : e[t] = n, e;
}
function bc(e, t) {
	if (e == null) return {};
	var n = xc(e, t), r, i;
	if (Object.getOwnPropertySymbols) {
		var a = Object.getOwnPropertySymbols(e);
		for (i = 0; i < a.length; i++) r = a[i], !(t.indexOf(r) >= 0) && Object.prototype.propertyIsEnumerable.call(e, r) && (n[r] = e[r]);
	}
	return n;
}
function xc(e, t) {
	if (e == null) return {};
	var n = {}, r = Object.keys(e), i, a;
	for (a = 0; a < r.length; a++) i = r[a], !(t.indexOf(i) >= 0) && (n[i] = e[i]);
	return n;
}
var Sc = /* @__PURE__ */ xn(function(e, t) {
	var n = e.children, r = Tc(bc(e, ic)), i = r.open, a = bc(r, ac);
	return wn(t, function() {
		return { open: i };
	}, [i]), /* @__PURE__ */ gn.createElement(vn, null, n($($({}, a), {}, { open: i })));
});
Sc.displayName = "Dropzone";
var Cc = {
	disabled: !1,
	getFilesFromEvent: ts,
	maxSize: Infinity,
	minSize: 0,
	multiple: !0,
	maxFiles: 0,
	preventDropOnDocument: !0,
	noClick: !1,
	noKeyboard: !1,
	noDrag: !1,
	noDragEventsBubbling: !1,
	validator: null,
	useFsAccessApi: !1,
	autoFocus: !1
};
Sc.defaultProps = Cc, Sc.propTypes = {
	children: Q.default.func,
	accept: Q.default.objectOf(Q.default.arrayOf(Q.default.string)),
	multiple: Q.default.bool,
	preventDropOnDocument: Q.default.bool,
	noClick: Q.default.bool,
	noKeyboard: Q.default.bool,
	noDrag: Q.default.bool,
	noDragEventsBubbling: Q.default.bool,
	minSize: Q.default.number,
	maxSize: Q.default.number,
	maxFiles: Q.default.number,
	disabled: Q.default.bool,
	getFilesFromEvent: Q.default.func,
	onFileDialogCancel: Q.default.func,
	onFileDialogOpen: Q.default.func,
	useFsAccessApi: Q.default.bool,
	autoFocus: Q.default.bool,
	onDragEnter: Q.default.func,
	onDragLeave: Q.default.func,
	onDragOver: Q.default.func,
	onDrop: Q.default.func,
	onDropAccepted: Q.default.func,
	onDropRejected: Q.default.func,
	onError: Q.default.func,
	validator: Q.default.func
};
var wc = {
	isFocused: !1,
	isFileDialogActive: !1,
	isDragActive: !1,
	isDragAccept: !1,
	isDragReject: !1,
	isDragGlobal: !1,
	acceptedFiles: [],
	fileRejections: []
};
function Tc() {
	var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, t = $($({}, Cc), e), n = t.accept, r = t.disabled, i = t.getFilesFromEvent, a = t.maxSize, o = t.minSize, s = t.multiple, c = t.maxFiles, l = t.onDragEnter, u = t.onDragLeave, d = t.onDragOver, f = t.onDrop, p = t.onDropAccepted, m = t.onDropRejected, h = t.onFileDialogCancel, g = t.onFileDialogOpen, _ = t.useFsAccessApi, v = t.autoFocus, y = t.preventDropOnDocument, b = t.noClick, x = t.noKeyboard, S = t.noDrag, C = t.noDragEventsBubbling, ee = t.onError, w = t.validator, te = K(function() {
		return $s(n);
	}, [n]), ne = K(function() {
		return Qs(n);
	}, [n]), re = K(function() {
		return typeof g == "function" ? g : Dc;
	}, [g]), ie = K(function() {
		return typeof h == "function" ? h : Dc;
	}, [h]), T = q(null), E = q(null), D = fc(En(Ec, wc), 2), ae = D[0], O = D[1], oe = ae.isFocused, se = ae.isFileDialogActive, ce = q(typeof window < "u" && window.isSecureContext && _ && Zs()), le = function() {
		!ce.current && se && setTimeout(function() {
			E.current && (E.current.files.length || (O({ type: "closeDialog" }), ie()));
		}, 300);
	};
	G(function() {
		return window.addEventListener("focus", le, !1), function() {
			window.removeEventListener("focus", le, !1);
		};
	}, [
		E,
		se,
		ie,
		ce
	]);
	var ue = q([]), de = q([]), fe = function(e) {
		T.current && T.current.contains(e.target) || (e.preventDefault(), ue.current = []);
	};
	G(function() {
		return y && (document.addEventListener("dragover", Ks, !1), document.addEventListener("drop", fe, !1)), function() {
			y && (document.removeEventListener("dragover", Ks), document.removeEventListener("drop", fe));
		};
	}, [T, y]), G(function() {
		var e = function(e) {
			de.current = [].concat(cc(de.current), [e.target]), Gs(e) && O({
				isDragGlobal: !0,
				type: "setDragGlobal"
			});
		}, t = function(e) {
			de.current = de.current.filter(function(t) {
				return t !== e.target && t !== null;
			}), !(de.current.length > 0) && O({
				isDragGlobal: !1,
				type: "setDragGlobal"
			});
		}, n = function() {
			de.current = [], O({
				isDragGlobal: !1,
				type: "setDragGlobal"
			});
		}, r = function() {
			de.current = [], O({
				isDragGlobal: !1,
				type: "setDragGlobal"
			});
		};
		return document.addEventListener("dragenter", e, !1), document.addEventListener("dragleave", t, !1), document.addEventListener("dragend", n, !1), document.addEventListener("drop", r, !1), function() {
			document.removeEventListener("dragenter", e), document.removeEventListener("dragleave", t), document.removeEventListener("dragend", n), document.removeEventListener("drop", r);
		};
	}, [T]), G(function() {
		return !r && v && T.current && T.current.focus(), function() {};
	}, [
		T,
		v,
		r
	]);
	var k = W(function(e) {
		ee ? ee(e) : console.error(e);
	}, [ee]), pe = W(function(e) {
		e.preventDefault(), e.persist(), Se(e), ue.current = [].concat(cc(ue.current), [e.target]), Gs(e) && Promise.resolve(i(e)).then(function(t) {
			if (!(Ws(e) && !C)) {
				var n = t.length, r = n > 0 && Us({
					files: t,
					accept: te,
					minSize: o,
					maxSize: a,
					multiple: s,
					maxFiles: c,
					validator: w
				});
				O({
					isDragAccept: r,
					isDragReject: n > 0 && !r,
					isDragActive: !0,
					type: "setDraggedFiles"
				}), l && l(e);
			}
		}).catch(function(e) {
			return k(e);
		});
	}, [
		i,
		l,
		k,
		C,
		te,
		o,
		a,
		s,
		c,
		w
	]), me = W(function(e) {
		e.preventDefault(), e.persist(), Se(e);
		var t = Gs(e);
		if (t && e.dataTransfer) try {
			e.dataTransfer.dropEffect = "copy";
		} catch {}
		return t && d && d(e), !1;
	}, [d, C]), he = W(function(e) {
		e.preventDefault(), e.persist(), Se(e);
		var t = ue.current.filter(function(e) {
			return T.current && T.current.contains(e);
		}), n = t.indexOf(e.target);
		n !== -1 && t.splice(n, 1), ue.current = t, !(t.length > 0) && (O({
			type: "setDraggedFiles",
			isDragActive: !1,
			isDragAccept: !1,
			isDragReject: !1
		}), Gs(e) && u && u(e));
	}, [
		T,
		u,
		C
	]), A = W(function(e, t) {
		var n = [], r = [];
		e.forEach(function(e) {
			var t = fc(Bs(e, te), 2), i = t[0], s = t[1], c = fc(Vs(e, o, a), 2), l = c[0], u = c[1], d = w ? w(e) : null;
			if (i && l && !d) n.push(e);
			else {
				var f = [s, u];
				d && (f = f.concat(d)), r.push({
					file: e,
					errors: f.filter(function(e) {
						return e;
					})
				});
			}
		}), (!s && n.length > 1 || s && c >= 1 && n.length > c) && (n.forEach(function(e) {
			r.push({
				file: e,
				errors: [Rs]
			});
		}), n.splice(0)), O({
			acceptedFiles: n,
			fileRejections: r,
			type: "setFiles"
		}), f && f(n, r, t), r.length > 0 && m && m(r, t), n.length > 0 && p && p(n, t);
	}, [
		O,
		s,
		te,
		o,
		a,
		c,
		f,
		p,
		m,
		w
	]), j = W(function(e) {
		e.preventDefault(), e.persist(), Se(e), ue.current = [], Gs(e) && Promise.resolve(i(e)).then(function(t) {
			Ws(e) && !C || A(t, e);
		}).catch(function(e) {
			return k(e);
		}), O({ type: "reset" });
	}, [
		i,
		A,
		k,
		C
	]), ge = W(function() {
		if (ce.current) {
			O({ type: "openDialog" }), re();
			var e = {
				multiple: s,
				types: ne
			};
			window.showOpenFilePicker(e).then(function(e) {
				return i(e);
			}).then(function(e) {
				A(e, null), O({ type: "closeDialog" });
			}).catch(function(e) {
				ec(e) ? (ie(e), O({ type: "closeDialog" })) : tc(e) ? (ce.current = !1, E.current ? (E.current.value = null, E.current.click()) : k(/* @__PURE__ */ Error("Cannot open the file picker because the https://developer.mozilla.org/en-US/docs/Web/API/File_System_Access_API is not supported and no <input> was provided."))) : k(e);
			});
			return;
		}
		E.current && (O({ type: "openDialog" }), re(), E.current.value = null, E.current.click());
	}, [
		O,
		re,
		ie,
		_,
		A,
		k,
		ne,
		s
	]), M = W(function(e) {
		!T.current || !T.current.isEqualNode(e.target) || (e.key === " " || e.key === "Enter" || e.keyCode === 32 || e.keyCode === 13) && (e.preventDefault(), ge());
	}, [T, ge]), N = W(function() {
		O({ type: "focus" });
	}, []), _e = W(function() {
		O({ type: "blur" });
	}, []), ve = W(function() {
		b || (Ys() ? setTimeout(ge, 0) : ge());
	}, [b, ge]), ye = function(e) {
		return r ? null : e;
	}, be = function(e) {
		return x ? null : ye(e);
	}, xe = function(e) {
		return S ? null : ye(e);
	}, Se = function(e) {
		C && e.stopPropagation();
	}, Ce = K(function() {
		return function() {
			var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, t = e.refKey, n = t === void 0 ? "ref" : t, i = e.role, a = e.onKeyDown, o = e.onFocus, s = e.onBlur, c = e.onClick, l = e.onDragEnter, u = e.onDragOver, d = e.onDragLeave, f = e.onDrop, p = bc(e, oc);
			return $($(yc({
				onKeyDown: be(Xs(a, M)),
				onFocus: be(Xs(o, N)),
				onBlur: be(Xs(s, _e)),
				onClick: ye(Xs(c, ve)),
				onDragEnter: xe(Xs(l, pe)),
				onDragOver: xe(Xs(u, me)),
				onDragLeave: xe(Xs(d, he)),
				onDrop: xe(Xs(f, j)),
				role: typeof i == "string" && i !== "" ? i : "presentation"
			}, n, T), !r && !x ? { tabIndex: 0 } : {}), p);
		};
	}, [
		T,
		M,
		N,
		_e,
		ve,
		pe,
		me,
		he,
		j,
		x,
		S,
		r
	]), we = W(function(e) {
		e.stopPropagation();
	}, []), Te = K(function() {
		return function() {
			var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, t = e.refKey, n = t === void 0 ? "ref" : t, r = e.onChange, i = e.onClick, a = bc(e, sc);
			return $($({}, yc({
				accept: te,
				multiple: s,
				type: "file",
				style: {
					border: 0,
					clip: "rect(0, 0, 0, 0)",
					clipPath: "inset(50%)",
					height: "1px",
					margin: "0 -1px -1px 0",
					overflow: "hidden",
					padding: 0,
					position: "absolute",
					width: "1px",
					whiteSpace: "nowrap"
				},
				onChange: ye(Xs(r, j)),
				onClick: ye(Xs(i, we)),
				tabIndex: -1
			}, n, E)), a);
		};
	}, [
		E,
		n,
		s,
		j,
		r
	]);
	return $($({}, ae), {}, {
		isFocused: oe && !r,
		getRootProps: Ce,
		getInputProps: Te,
		rootRef: T,
		inputRef: E,
		open: ye(ge)
	});
}
function Ec(e, t) {
	/* istanbul ignore next */
	switch (t.type) {
		case "focus": return $($({}, e), {}, { isFocused: !0 });
		case "blur": return $($({}, e), {}, { isFocused: !1 });
		case "openDialog": return $($({}, wc), {}, { isFileDialogActive: !0 });
		case "closeDialog": return $($({}, e), {}, { isFileDialogActive: !1 });
		case "setDraggedFiles": return $($({}, e), {}, {
			isDragActive: t.isDragActive,
			isDragAccept: t.isDragAccept,
			isDragReject: t.isDragReject
		});
		case "setFiles": return $($({}, e), {}, {
			acceptedFiles: t.acceptedFiles,
			fileRejections: t.fileRejections,
			isDragReject: !1
		});
		case "setDragGlobal": return $($({}, e), {}, { isDragGlobal: t.isDragGlobal });
		case "reset": return $({}, wc);
		default: return e;
	}
}
function Dc() {}
//#endregion
//#region src/components/chat/DropZoneOverlay.tsx
function Oc({ active: e }) {
	let { t } = hn();
	return e ? /* @__PURE__ */ U(j, {
		"aria-dropeffect": "copy",
		style: {
			position: "absolute",
			inset: 0,
			zIndex: 10,
			display: "flex",
			alignItems: "center",
			justifyContent: "center",
			flexDirection: "column",
			gap: 8,
			background: "color-mix(in srgb, var(--mantine-color-blue-1) 80%, transparent)",
			border: "2px dashed var(--mantine-color-blue-6)",
			borderRadius: "var(--mantine-radius-md)",
			pointerEvents: "none"
		},
		children: [/* @__PURE__ */ H(mt, {
			size: 32,
			color: "var(--mantine-color-blue-6)"
		}), /* @__PURE__ */ H(R, {
			c: "blue.6",
			fw: 500,
			children: t("messages.dropzone.text", "Drop files here")
		})]
	}) : null;
}
//#endregion
//#region src/components/chat/MessageComposer.tsx
var kc = Sn(() => import("emoji-picker-react")), Ac = 3e3, jc = 10 * 1024 * 1024, Mc = 5, Nc = {
	"image/*": [],
	"application/pdf": [".pdf"],
	"application/msword": [".doc"],
	"application/vnd.openxmlformats-officedocument.wordprocessingml.document": [".docx"],
	"application/vnd.ms-excel": [".xls"],
	"application/vnd.openxmlformats-officedocument.spreadsheetml.sheet": [".xlsx"],
	"text/plain": [".txt"]
}, Pc = Hn.create({
	name: "enterToSend",
	addOptions() {
		return { onSend: void 0 };
	},
	addKeyboardShortcuts() {
		return {
			Enter: () => (this.options.onSend?.(), !0),
			"Shift-Enter": () => (this.editor.commands.setHardBreak(), !0)
		};
	}
});
function Fc(e) {
	return e ? e.isEmpty : !0;
}
function Ic(e) {
	return e ? e.storage.markdown.getMarkdown().trim() : "";
}
function Lc(e) {
	return e < 1024 ? `${e} B` : e < 1024 * 1024 ? `${(e / 1024).toFixed(0)} KB` : `${(e / (1024 * 1024)).toFixed(1)} MB`;
}
function Rc(e) {
	e.forEach((e) => {
		e.preview && URL.revokeObjectURL(e.preview);
	});
}
function zc({ onSend: e, onTyping: t, disabled: n = !1, placeholder: r, autoFocus: i = !1, focusKey: a, maxFileSize: o = jc, acceptedFileTypes: s, maxAttachments: c = Mc, hideToolbar: l = !1, onFileError: u, pendingContext: d, onDismissContext: f }) {
	let { t: p } = hn(), m = q(0), [h, { close: g, toggle: _ }] = kn(!1), [v, y] = J([]), b = q(e);
	b.current = e;
	let x = q(t);
	x.current = t;
	let S = q(u);
	S.current = u;
	let C = q(v);
	C.current = v;
	let ee = q(void 0), w = Un({
		shouldRerenderOnTransaction: !0,
		extensions: [
			Wn.configure({
				heading: !1,
				blockquote: !1,
				orderedList: !1,
				horizontalRule: !1,
				link: !1
			}),
			Gn.configure({
				openOnClick: !1,
				autolink: !0
			}),
			Kn.configure({ placeholder: r ?? p("messages.composerPlaceholder") }),
			qn.configure({
				html: !1,
				bulletListMarker: "-",
				transformPastedText: !0
			}),
			Pc.configure({ onSend: () => ee.current?.() })
		],
		editable: !n,
		onUpdate: () => {
			if (x.current) {
				let e = Date.now();
				e - m.current >= Ac && (m.current = e, x.current());
			}
		}
	});
	ee.current = W(() => {
		if (!w) return;
		let e = !Fc(w), t = C.current.length > 0;
		if (!e && !t) return;
		let n = Ic(w), r = t ? [...C.current] : void 0;
		b.current(n, r), w.commands.clearContent(), Rc(C.current), y([]);
	}, [w]), G(() => {
		w && w.setEditable(!n);
	}, [w, n]), G(() => {
		if (i && !n && w) {
			let e = setTimeout(() => w.commands.focus(), 50);
			return () => clearTimeout(e);
		}
	}, [
		i,
		a,
		n,
		w
	]);
	let te = q(a);
	G(() => {
		w && a !== te.current && (te.current = a, w.commands.clearContent(), Rc(C.current), y([]));
	}, [w, a]), G(() => () => Rc(C.current), []);
	let ne = K(() => s ? Object.fromEntries(s.map((e) => [e, []])) : Nc, [s]), re = W((e) => {
		S.current?.(e);
		let t;
		switch (e.type) {
			case "size":
				t = p("messages.attachments.fileTooLarge", {
					filename: e.file?.name ?? "",
					limit: Lc(e.limit),
					defaultValue: `File "${e.file?.name}" exceeds ${Lc(e.limit)} limit`
				});
				break;
			case "type":
				t = p("messages.attachments.invalidType", {
					filename: e.file?.name ?? "",
					defaultValue: `File type not accepted: ${e.file?.name}`
				});
				break;
			case "count":
				t = p("messages.attachments.tooMany", {
					limit: e.limit,
					defaultValue: `Maximum ${e.limit} files per message`
				});
				break;
		}
		Vn.show({
			title: p("messages.attachments.errorTitle", "File error"),
			message: t,
			color: "red"
		});
	}, [p]), { getRootProps: ie, getInputProps: T, isDragActive: E, open: D } = Tc({
		accept: ne,
		maxSize: o,
		noClick: !0,
		noKeyboard: !0,
		onDrop: W((e, t) => {
			for (let e of t) for (let t of e.errors) t.code === "file-too-large" ? re({
				type: "size",
				file: e.file,
				limit: o
			}) : t.code === "file-invalid-type" && re({
				type: "type",
				file: e.file,
				limit: 0
			});
			if (e.length === 0) return;
			let n = c - C.current.length;
			if (n <= 0) {
				re({
					type: "count",
					limit: c
				});
				return;
			}
			let r = e.slice(0, n);
			e.length > n && re({
				type: "count",
				limit: c
			});
			let i = r.map((e) => ({
				file: e,
				id: crypto.randomUUID(),
				preview: e.type.startsWith("image/") ? URL.createObjectURL(e) : void 0
			}));
			y((e) => [...e, ...i]);
		}, [
			c,
			o,
			re
		]),
		multiple: void 0,
		onDragEnter: void 0,
		onDragLeave: void 0,
		onDragOver: void 0
	}), ae = W((e) => {
		y((t) => {
			let n = t.find((t) => t.id === e);
			return n?.preview && URL.revokeObjectURL(n.preview), t.filter((t) => t.id !== e);
		});
	}, []), O = W(() => {
		ee.current?.();
	}, []), oe = W((e) => {
		w && w.chain().focus().insertContent(e.emoji).run(), g();
	}, [w, g]), se = Fc(w) && v.length === 0, ce = K(() => ({
		boldControlLabel: p("messages.toolbar.bold", "Bold"),
		italicControlLabel: p("messages.toolbar.italic", "Italic"),
		codeControlLabel: p("messages.toolbar.code", "Code"),
		bulletListControlLabel: p("messages.toolbar.list", "List")
	}), [p]);
	return /* @__PURE__ */ U("div", {
		"data-testid": "message-composer",
		...ie(),
		style: {
			padding: "8px 16px",
			position: "relative"
		},
		children: [
			/* @__PURE__ */ H("input", { ...T() }),
			/* @__PURE__ */ H(Oc, { active: E }),
			/* @__PURE__ */ U(Jn, {
				editor: w,
				labels: ce,
				styles: {
					root: {
						border: "1px solid var(--mantine-color-default-border)",
						borderRadius: "var(--mantine-radius-md)",
						overflow: "hidden"
					},
					toolbar: {
						borderBottom: "1px solid var(--mantine-color-default-border)",
						padding: "2px 4px",
						minHeight: 32,
						gap: 0
					},
					content: { "& .ProseMirror": {
						minHeight: "1.5em",
						maxHeight: "calc(1.5em * 6 + 1em)",
						overflowY: "auto",
						padding: "8px 12px"
					} }
				},
				children: [
					d && /* @__PURE__ */ U(j, {
						style: {
							display: "flex",
							alignItems: "center",
							gap: 8,
							padding: "6px 12px",
							borderBottom: "1px solid var(--mantine-color-default-border)",
							backgroundColor: "var(--mantine-color-blue-light)"
						},
						"data-testid": "pending-context-banner",
						children: [/* @__PURE__ */ H(j, {
							style: { flex: 1 },
							children: /* @__PURE__ */ H(Eo, {
								type: `${d.type}_context`,
								entityGuid: d.entityGuid,
								snapshot: d.snapshot,
								compact: !0
							})
						}), /* @__PURE__ */ H(ye, {
							size: "sm",
							onClick: f,
							"aria-label": "Dismiss context"
						})]
					}),
					/* @__PURE__ */ H(vo, {
						attachments: v,
						onRemove: ae
					}),
					/* @__PURE__ */ U(Jn.Toolbar, { children: [
						!l && /* @__PURE__ */ H(j, {
							visibleFrom: "sm",
							style: { display: "flex" },
							children: /* @__PURE__ */ U(Jn.ControlsGroup, { children: [
								/* @__PURE__ */ H(Jn.Bold, {}),
								/* @__PURE__ */ H(Jn.Italic, {}),
								/* @__PURE__ */ H(Jn.Code, {}),
								/* @__PURE__ */ H(Jn.BulletList, {})
							] })
						}),
						/* @__PURE__ */ H(Jn.Control, {
							"aria-label": p("messages.toolbar.attach", "Attach file"),
							"data-testid": "message-composer-attach",
							onClick: D,
							children: /* @__PURE__ */ H(Ut, { size: 16 })
						}),
						/* @__PURE__ */ U(Ie, {
							opened: h,
							onClose: g,
							position: "top-end",
							width: 352,
							shadow: "md",
							children: [/* @__PURE__ */ H(Ie.Target, { children: /* @__PURE__ */ H(Jn.Control, {
								"aria-label": p("messages.toolbar.emoji", "Emoji"),
								"data-testid": "message-composer-emoji",
								onClick: _,
								active: h,
								children: /* @__PURE__ */ H(Bt, { size: 16 })
							}) }), /* @__PURE__ */ H(Ie.Dropdown, {
								p: 0,
								children: /* @__PURE__ */ H(yn, {
									fallback: /* @__PURE__ */ H(Ae, {
										size: "sm",
										m: "md"
									}),
									children: /* @__PURE__ */ H(kc, {
										onEmojiClick: oe,
										emojiStyle: "apple",
										theme: "auto",
										searchPlaceholder: p("messages.toolbar.emojiSearch", "Search emojis..."),
										width: 350,
										height: 400,
										lazyLoadEmojis: !0,
										previewConfig: { showPreview: !1 }
									})
								})
							})]
						}),
						/* @__PURE__ */ H("div", { style: { flex: 1 } }),
						/* @__PURE__ */ H(k, {
							variant: "filled",
							color: "blue",
							size: "sm",
							onClick: O,
							disabled: n || se,
							"aria-label": p("messages.aria.send"),
							"data-testid": "message-composer-send",
							style: { marginRight: 2 },
							children: /* @__PURE__ */ H(Zt, { size: 14 })
						})
					] }),
					/* @__PURE__ */ H(Jn.Content, { "data-testid": "message-composer-input" })
				]
			})
		]
	});
}
//#endregion
//#region src/components/chat/TypingIndicator.tsx
var Bc = "\n@keyframes typingDot {\n  0%, 60%, 100% { opacity: 0.2; }\n  30% { opacity: 1; }\n}\n", Vc = (e) => ({
	width: 4,
	height: 4,
	borderRadius: "50%",
	backgroundColor: "var(--mantine-color-dimmed)",
	animation: "typingDot 1.4s infinite ease-in-out both",
	animationDelay: `${e}s`
});
function Hc({ userName: e }) {
	let { t } = hn();
	return /* @__PURE__ */ U(P, {
		gap: 4,
		px: "md",
		py: 4,
		"data-testid": "typing-indicator",
		children: [
			/* @__PURE__ */ U("style", { children: [Bc, "\n        @media (prefers-reduced-motion: reduce) {\n          @keyframes typingDot {\n            0%, 100% { opacity: 0.6; }\n          }\n        }\n      "] }),
			/* @__PURE__ */ H(R, {
				size: "sm",
				c: "dimmed",
				children: t("messages.typing", { name: e })
			}),
			/* @__PURE__ */ U(P, {
				gap: 2,
				align: "center",
				ml: 2,
				children: [
					/* @__PURE__ */ H("span", { style: Vc(0) }),
					/* @__PURE__ */ H("span", { style: Vc(.2) }),
					/* @__PURE__ */ H("span", { style: Vc(.4) })
				]
			})
		]
	});
}
//#endregion
//#region src/types/conversations.ts
var Uc = {
	all: ["conversations"],
	lists: () => [...Uc.all, "list"],
	list: (e) => [...Uc.lists(), e ?? {}],
	details: () => [...Uc.all, "detail"],
	detail: (e) => [...Uc.details(), e],
	messages: (e) => [
		...Uc.all,
		"messages",
		e
	],
	unreadTotal: () => [...Uc.all, "unreadTotal"]
}, Wc = [
	"pending",
	"partially_paid",
	"paid",
	"overpaid",
	"expired",
	"expired_partial",
	"failed",
	"refunded"
], Gc = [
	"awaiting_payment",
	"confirmed",
	"preparing",
	"ready",
	"shipped",
	"delivered",
	"cancelled"
];
//#endregion
//#region src/hooks/usePagination.ts
function Kc(e) {
	let { total: t, initialPage: n = 1, initialLimit: r = 10 } = e, [i, a] = J(n), [o, s] = J(r), c = K(() => Math.max(1, Math.ceil(t / o)), [t, o]), l = K(() => (i - 1) * o, [i, o]), u = K(() => i < c, [i, c]), d = K(() => i > 1, [i]);
	return {
		page: i,
		limit: o,
		total: t,
		totalPages: c,
		offset: l,
		hasNext: u,
		hasPrev: d,
		setPage: W((e) => {
			a(Math.max(1, Math.min(e, c)));
		}, [c]),
		setLimit: W((e) => {
			s(e), a(1);
		}, []),
		nextPage: W(() => {
			u && a((e) => e + 1);
		}, [u]),
		prevPage: W(() => {
			d && a((e) => e - 1);
		}, [d]),
		reset: W(() => {
			a(n), s(r);
		}, [n, r])
	};
}
//#endregion
//#region src/hooks/useConfirmation.ts
function qc() {
	let [e, t] = J(!1), [n, r] = J(!1), [i, a] = J(null), o = W((e) => {
		a(e), t(!0), r(!1);
	}, []), s = W(() => {
		n || (t(!1), a(null));
	}, [n]);
	return {
		isOpen: e,
		isLoading: n,
		confirm: o,
		cancel: s,
		modalProps: {
			opened: e,
			onClose: s,
			onConfirm: W(async () => {
				if (i?.onConfirm) try {
					r(!0), await i.onConfirm(), t(!1), a(null);
				} finally {
					r(!1);
				}
			}, [i]),
			title: i?.title ?? "",
			message: i?.message ?? "",
			danger: i?.danger ?? !1,
			confirmLabel: i?.confirmLabel ?? (i?.danger ? "Eliminar" : "Confirmar"),
			cancelLabel: i?.cancelLabel ?? "Cancelar",
			loading: n
		}
	};
}
//#endregion
//#region src/utils/currencyConverter.ts
var Jc = [
	"ARS",
	"USD",
	"EUR",
	"BRL"
], Yc = [
	"BTC",
	"ETH",
	"USDT",
	"TRX"
], Xc = [
	"USDT",
	"USDC",
	"DAI",
	"BUSD"
], Zc = [...Jc, ...Yc];
function Qc(e) {
	return Xc.includes(e);
}
function $c(e) {
	return Qc(e) ? "USD" : e.toUpperCase();
}
function el(e, t, n) {
	let r = `${e}_${t}`;
	if (n[r] !== void 0) return n[r];
	let i = `${t}_${e}`;
	return n[i] !== void 0 && n[i] !== 0 ? 1 / n[i] : null;
}
function tl(e, t) {
	let n = $c(e), r = $c(t);
	return n === r ? [] : n === "USD" ? [`USD_${r}`] : r === "USD" ? [`${n}_USD`] : [`${n}_USD`, `USD_${r}`];
}
function nl(e, t, n, r) {
	if (typeof e != "number" || isNaN(e)) return null;
	let i = $c(t), a = $c(n);
	if (i === a) return e;
	if (i === "USD") {
		let t = el("USD", a, r);
		return t === null ? null : e * t;
	}
	if (a === "USD") {
		let t = el(i, "USD", r);
		return t === null ? null : e * t;
	}
	let o = el(i, "USD", r), s = el("USD", a, r);
	return o === null || s === null ? null : e * o * s;
}
function rl(e, t, n, r) {
	return `${C(n, r)} (${C(e, t)})`;
}
function il(e, t, n, r) {
	let i = nl(e, t, n, r);
	return i === null ? null : rl(e, t, i, n);
}
//#endregion
//#region src/hooks/useCurrencyConversion.ts
var al = 300 * 1e3, ol = 600 * 1e3, sl = "USD";
async function cl(e, t) {
	if (e.length === 0) return {
		rates: {},
		timestamp: (/* @__PURE__ */ new Date()).toISOString()
	};
	let n = `${t}/api/v2/exchange-rates?pairs=${e.join(",")}`, r = await fetch(n, {
		method: "GET",
		headers: { "Content-Type": "application/json" }
	});
	if (!r.ok) throw Error(`Failed to fetch exchange rates: ${r.status} ${r.statusText}`);
	let i = await r.json();
	if (!i.success) throw Error("API returned unsuccessful response");
	return i.data;
}
function ll(e) {
	let { sourceCurrency: t, targetCurrency: n, apiBaseUrl: r, enabled: i = !0 } = e, a = n || sl, o = r ?? (typeof window < "u" ? window.location.origin : ""), s = K(() => tl(t, a), [t, a]), { data: c, isLoading: l, error: u, refetch: d } = Yn({
		queryKey: K(() => ["exchangeRates", s.join(",")], [s]),
		queryFn: () => cl(s, o),
		staleTime: al,
		gcTime: ol,
		enabled: i && s.length > 0
	}), f = W((e) => t === a ? e : c?.rates ? nl(e, t, a, c.rates) : null, [
		c?.rates,
		t,
		a
	]), p = K(() => t === a ? 1 : c?.rates ? nl(1, t, a, c.rates) : null, [
		c?.rates,
		t,
		a
	]), m = W(async () => {
		await d();
	}, [d]);
	return {
		convert: f,
		rates: c?.rates || {},
		isLoading: l,
		error: u,
		userCurrency: a,
		refreshRates: m,
		exchangeRate: p,
		ratesTimestamp: c?.timestamp || null
	};
}
//#endregion
//#region src/hooks/usePreferencesSync.ts
function ul(e) {
	let { userGuid: t, onLanguageChange: n, onCurrencyChange: r, onThemeChange: i, enabled: a = !0 } = e, o = q(null), s = q(!1), c = q(n), l = q(r), u = q(i);
	G(() => {
		c.current = n;
	}, [n]), G(() => {
		l.current = r;
	}, [r]), G(() => {
		u.current = i;
	}, [i]);
	let { isConnected: d, subscribe: f, unsubscribe: p } = $n(), m = W((e) => {
		if (e.correlationId && e.correlationId === o.current) {
			console.log("[usePreferencesSync] Skipping self-originated event:", e.correlationId);
			return;
		}
		console.log("[usePreferencesSync] Processing preferences update:", e), e.language_code && c.current && (console.log("[usePreferencesSync] Language changed to:", e.language_code), c.current(e.language_code)), e.preferred_currency && l.current && (console.log("[usePreferencesSync] Currency changed to:", e.preferred_currency), l.current(e.preferred_currency)), e.ui_preferences?.theme && u.current && (console.log("[usePreferencesSync] Theme changed to:", e.ui_preferences.theme), u.current(e.ui_preferences.theme));
	}, []);
	Qn(Xn.PREFERENCES_UPDATED, m, [m]), G(() => {
		if (!a || !t || !d) {
			console.log("[usePreferencesSync] Skipping subscription:", {
				enabled: a,
				userGuid: t,
				isConnected: d
			}), s.current = !1;
			return;
		}
		let e = Zn.userPreferences(t);
		return console.log("[usePreferencesSync] Subscribing to topic:", e), f([e]), s.current = !0, () => {
			console.log("[usePreferencesSync] Unsubscribing from topic:", e), p([e]), s.current = !1;
		};
	}, [
		a,
		t,
		d,
		f,
		p
	]);
	let h = W((e) => {
		o.current = e, setTimeout(() => {
			o.current === e && (o.current = null);
		}, 5e3);
	}, []);
	return {
		isSubscribed: s.current,
		setLastCorrelationId: h
	};
}
//#endregion
//#region src/hooks/useVersionNotification.ts
function dl(e) {
	let { currentBuildId: t, app: n, onUpdateAvailable: r, enabled: i = !0 } = e, a = q(r);
	G(() => {
		a.current = r;
	}, [r]);
	let o = q(null), s = q(!1), { isConnected: c, subscribe: l, unsubscribe: u } = $n(), d = W((e) => {
		i && e.app === n && e.buildId && t && e.buildId !== t && e.buildId !== o.current && (o.current = e.buildId, a.current(e));
	}, [
		i,
		n,
		t
	]);
	return Qn(Xn.FRONTEND_VERSION_UPDATED, d, [d]), G(() => {
		if (!i || !c) {
			s.current = !1;
			return;
		}
		let e = Zn.systemBroadcast();
		return l([e]), s.current = !0, () => {
			u([e]), s.current = !1;
		};
	}, [
		i,
		c,
		l,
		u
	]), { isSubscribed: s.current };
}
//#endregion
//#region src/providers/UserPreferencesProvider.tsx
var fl = "tt-theme-cache", pl = 800, ml = bn({
	theme: "light",
	compactMode: !1,
	showTooltips: !0,
	highContrast: !1,
	largeText: !1,
	screenReader: !1,
	reducedMotion: !1,
	autoLogoutMinutes: 0
});
function hl() {
	return Cn(ml);
}
function gl(e) {
	if (typeof document > "u") return;
	let t = document.documentElement;
	t.setAttribute("data-compact", String(e.compactMode)), t.setAttribute("data-show-tooltips", String(e.showTooltips)), t.setAttribute("data-high-contrast", String(e.highContrast)), t.setAttribute("data-large-text", String(e.largeText)), t.setAttribute("data-reduced-motion", String(e.reducedMotion)), t.setAttribute("data-screen-reader", String(e.screenReader));
}
function _l() {
	if (typeof document > "u") return;
	let e = document.documentElement;
	e.removeAttribute("data-compact"), e.removeAttribute("data-show-tooltips"), e.removeAttribute("data-high-contrast"), e.removeAttribute("data-large-text"), e.removeAttribute("data-reduced-motion"), e.removeAttribute("data-screen-reader");
}
function vl(e) {
	let t = e?.ui_preferences ?? void 0, n = e?.accessibility_preferences ?? void 0;
	return {
		theme: t?.theme ?? "light",
		compactMode: t?.compactMode ?? !1,
		showTooltips: t?.showTooltips ?? !0,
		highContrast: n?.highContrast ?? !1,
		largeText: n?.largeText ?? !1,
		screenReader: n?.screenReader ?? !1,
		reducedMotion: n?.reducedMotion ?? !1,
		autoLogoutMinutes: t?.autoLogoutMinutes ?? 0
	};
}
function yl({ profile: e, isAuthenticated: t, onSaveTheme: n, themeCacheKey: r = fl, applyA11yAttributes: i = !0, children: a }) {
	let { setColorScheme: o, colorScheme: s } = Je(), c = qe("light"), l = q(!1), u = q(null), d = q(t), f = vl(e);
	G(() => {
		i && (t && e ? gl(f) : _l());
	}, [
		i,
		t,
		e,
		f.compactMode,
		f.showTooltips,
		f.highContrast,
		f.largeText,
		f.screenReader,
		f.reducedMotion
	]), G(() => {
		if (!t || !e) return;
		let n = e.ui_preferences?.theme ?? "light";
		if (u.current !== n) {
			if (u.current = n, l.current = !0, o(n), typeof window < "u") {
				let e = n === "auto" ? c : n;
				window.localStorage.setItem(r, e), window.localStorage.setItem("mantine-color-scheme-value", e);
			}
			requestAnimationFrame(() => {
				l.current = !1;
			});
		}
	}, [
		t,
		e,
		e?.ui_preferences?.theme,
		o,
		c,
		r
	]), G(() => {
		d.current === !0 && t === !1 && (typeof window < "u" && (window.localStorage.removeItem(r), window.localStorage.removeItem("mantine-color-scheme-value")), l.current = !0, o("auto"), u.current = null, requestAnimationFrame(() => {
			l.current = !1;
		})), d.current = t;
	}, [
		t,
		r,
		o
	]);
	let p = Dn(async (r) => {
		if (!(!t || !e)) try {
			await n(r);
		} catch (e) {
			console.error("[UserPreferences] Failed to save theme:", e);
		}
	}, pl);
	G(() => {
		!t || !e || l.current || s !== (e.ui_preferences?.theme ?? "light") && (s === "light" || s === "dark") && (typeof window < "u" && window.localStorage.setItem(r, s), p(s));
	}, [
		s,
		t,
		e,
		e?.ui_preferences?.theme,
		p,
		r
	]);
	let m = W(() => {
		typeof window > "u" || e?.ui_preferences?.theme === "auto" && window.localStorage.setItem(r, c);
	}, [
		e?.ui_preferences?.theme,
		c,
		r
	]);
	return G(() => {
		m();
	}, [m]), G(() => () => {
		i && _l();
	}, [i]), /* @__PURE__ */ H(ml.Provider, {
		value: f,
		children: a
	});
}
//#endregion
export { Er as AddressContextBadge, mr as AddressStatusBadge, So as AttachmentCard, vo as AttachmentPreview, Mr as BalanceLevelBadge, xi as Breadcrumbs, Xi as CHART_COLORS, Zi as CHART_COLOR_SEQUENCE, Z as CHART_DEFAULTS, Zr as CardSkeleton, Sr as CategoryBadge, ri as ChartSkeleton, mo as ChatAttachmentProvider, Sa as ConfirmModal, Ar as ConfirmationLevelBadge, Eo as ContextCard, Fr as CounterBadge, ga as CurrencyInput, Oa as CurrencySwitcher, Ur as CustomRoleBadge, ya as DATE_RANGE_PRESETS, Da as DEFAULT_CURRENCIES, de as DEFAULT_FONT_STACKS, wa as DEFAULT_LANGUAGES, Wi as DataTable, zi as DataTableHeader, Vi as DataTablePagination, xa as DateRangePicker, Fo as DateSeparator, Oc as DropZoneOverlay, $a as EmptyCartState, di as EmptyState, Rr as EndpointCounterBadge, mi as ErrorBoundary, pi as ErrorState, n as FULFILLMENT_STATUS_CONFIG, Gc as FULFILLMENT_STATUS_VALUES, oo as FavoritesDrawerItem, hi as FilterChips, br as FulfillmentStatusBadge, oi as FullScreenLoader, Ia as HeaderDivider, Fa as HeaderLayout, La as HeaderNavButton, Ra as HeaderPreferences, za as HeaderUserSection, re as IMAGE_SIZE_PIXELS, Ca as ImageLightbox, go as ImageThumbnail, Lr as ItemCounterBadge, Yi as KPICard, ni as KPISkeleton, y as LOCALE, Ta as LanguageSwitcher, Or as LevelBadge, Xr as ListSkeleton, ii as LoadingSkeleton, co as MerchantCardLayout, lo as MerchantCardSkeleton, Za as MerchantCartCard, qr as MerchantGridSkeleton, gr as MerchantOrderStatusBadge, hr as MerchantStatusBadge, Cr as MerchantTypeBadge, Mo as MessageBubble, zc as MessageComposer, Ro as MessageList, fo as MessageStatus, Ba as MessagesHeaderButton, io as MultiCartDrawer, a as NOTIFICATIONS_CONFIG, m as NOTIFICATION_COLORS, gi as NOTIFICATION_ICON_SIZE, yi as NOTIFICATION_ICON_TYPES, Ir as NotificationCounterBadge, vi as NotificationIcons, t as ORDER_PAYMENT_STATUS_CONFIG, yr as OrderPaymentStatusBadge, ur as OrderStatusBadge, Wc as PAYMENT_STATUS_VALUES, Qi as PIE_CHART_COLORS, ai as PageLoader, Dr as PaymentModeBadge, dr as PaymentStatusBadge, Ti as PriceDisplay, Ga as ProductCard, Jr as ProductDetailSkeleton, Gr as ProductGridSkeleton, da as QuantityInput, Pr as RankingLevelBadge, jr as RatingLevelBadge, kr as ResourceLevelBadge, wr as ResourceTypeBadge, Vr as RoleBadge, Tr as RoleTypeBadge, Xc as STABLECOINS, Yc as SUPPORTED_CRYPTO, Zc as SUPPORTED_CURRENCIES, Jc as SUPPORTED_FIAT, ma as SearchInput, $r as StatsSkeleton, X as StatusBadge, Mi as StockBadge, vr as StockStatusBadge, _r as SyncStatusBadge, Hr as SystemRoleBadge, ei as TableSkeleton, ia as TeleAreaChart, aa as TeleBarChart, ua as TeleDonutChart, oa as TeleLineChart, ca as TelePieChart, Qr as TextSkeleton, Ea as ThemeSwitcher, Li as Timeline, pr as TransactionStatusBadge, Hc as TypingIndicator, Nr as UsageLevelBadge, yl as UserPreferencesProvider, Ja as WishlistButton, fr as WithdrawalStatusBadge, ea as X_AXIS_DEFAULTS, $i as Y_AXIS_DEFAULTS, ra as assignPieColors, na as assignSeriesColors, se as buildBrandTheme, Uc as conversationKeys, il as convertAndFormat, nl as convertCurrency, le as darken, T as formatBusinessHours, rl as formatConvertedPrice, C as formatCurrency, E as formatCurrencyCompact, b as formatDate, _o as formatFileSize, x as formatNumber, ne as formatPercentage, ee as formatRelativeTime, O as generateColorPalette, ta as getChartColor, S as getImageSizeUrl, v as getRecommendedSize, tl as getRequiredPairs, ki as getStockStatus, D as hexToRgb, ce as hslToRgb, w as isCurrentlyOpen, te as isIcecatImage, ie as isMerchantImage, Qc as isStablecoin, ue as lighten, ae as rgbToHex, oe as rgbToHsl, fe as useBrandTheme, qc as useConfirmation, ll as useCurrencyConversion, fa as useDebounce, pa as useDebouncedCallback, ho as useFetchAttachment, Aa as useHeaderLayout, Kc as usePagination, ul as usePreferencesSync, hl as useUserPreferences, dl as useVersionNotification };

//# sourceMappingURL=index.es.js.map